
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire49d7"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire49d7"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;

if (!$parcel$global.lb) {
  // Set of loaded bundles
  $parcel$global.lb = new Set();
  // Queue of bundles to execute once they're dep bundles are loaded
  $parcel$global.bq = [];

  // Register loaded bundle
  $parcel$global.rlb = (bundle) => { $parcel$global.lb.add(bundle); $parcel$global.pq(); }

  // Run when ready
  $parcel$global.rwr = (b, r, d) => { $parcel$global.bq.push({b, r, d}); $parcel$global.pq(); }

  // Process queue
  $parcel$global.pq = () => { var runnableEntry = $parcel$global.bq.find((i) => { return i.d.every((dep) => { return $parcel$global.lb.has(dep); }); }); if (runnableEntry) { $parcel$global.bq = $parcel$global.bq.filter((i) => { return i.b !== runnableEntry.b; }); runnableEntry.r(); $parcel$global.pq(); } }
}
parcelRegister("d3lq5", function(module, exports) {

$parcel$export(module.exports, "getGlobalErrorCount", () => $2bf103f5c1da86b6$export$d06c0426664e7c08);
$parcel$export(module.exports, "default", () => $2bf103f5c1da86b6$export$2e2bcd8739ae039);

var $4eDgu = parcelRequire("4eDgu");
let $2bf103f5c1da86b6$var$shouldInitilizeGlobalErrorHandler = true;
let $2bf103f5c1da86b6$var$globalCount = 0;
const $2bf103f5c1da86b6$var$errors = [];
let $2bf103f5c1da86b6$var$push = (name, labelStack, errorType, errorMessage, errorStack)=>{
    $2bf103f5c1da86b6$var$errors.push({
        name: name,
        labelStack: labelStack,
        errorType: errorType,
        errorMessage: errorMessage,
        errorStack: errorStack
    });
};
function $2bf103f5c1da86b6$export$ebe081a8c9bf8176(sinkFunc) {
    $2bf103f5c1da86b6$var$push = sinkFunc;
    $2bf103f5c1da86b6$var$errors.forEach((e)=>{
        sinkFunc(e.name, e.labelStack, e.errorType, e.errorMessage, e.errorStack);
    });
    $2bf103f5c1da86b6$var$errors.length = 0;
}
function $2bf103f5c1da86b6$export$d06c0426664e7c08() {
    return $2bf103f5c1da86b6$var$globalCount;
}
function $2bf103f5c1da86b6$var$handleError(e) {
    $2bf103f5c1da86b6$var$globalCount++;
    if (e.error?.UFOhasCaught === undefined) try {
        if (e.error instanceof Error) $2bf103f5c1da86b6$var$push('GlobalErrorHandler', null, e.error.name, e.error.message, e.error.stack);
        else if (e.error) {
            const hint = JSON.stringify(e.error).slice(0, 50);
            $2bf103f5c1da86b6$var$push('GlobalErrorHandler', null, '', `Non error object thrown: ${hint}`, undefined);
        } else if (e.message !== undefined) {
            const hint = e.message.slice(0, 50);
            $2bf103f5c1da86b6$var$push('GlobalErrorHandler', null, '', `Non error object thrown: ${hint}`, undefined);
        }
        if (e.error && typeof e.error === 'object') e.error.UFOhasCaught = true;
    // eslint-disable-next-line no-empty
    } catch (e) {}
}
function $2bf103f5c1da86b6$var$handlePromiseRejection(e) {
    $2bf103f5c1da86b6$var$globalCount++;
    if (e.reason instanceof Error) $2bf103f5c1da86b6$var$push('GlobalErrorHandler', null, e.reason.name, e.reason.message, e.reason.stack);
    else if (e.reason) try {
        const hint = JSON.stringify(e.reason).slice(0, 50);
        $2bf103f5c1da86b6$var$push('GlobalErrorHandler', null, '', `Non error object thrown: ${hint}`, undefined);
    // eslint-disable-next-line no-empty
    } catch (e) {}
}
function $2bf103f5c1da86b6$var$setupUFOGlobalErrorHandler() {
    if ($2bf103f5c1da86b6$var$shouldInitilizeGlobalErrorHandler) {
        (0, $4eDgu.bind)(window, {
            type: 'error',
            listener: (e)=>$2bf103f5c1da86b6$var$handleError(e)
        });
        (0, $4eDgu.bind)(window, {
            type: 'unhandledrejection',
            listener: $2bf103f5c1da86b6$var$handlePromiseRejection
        });
        $2bf103f5c1da86b6$var$shouldInitilizeGlobalErrorHandler = false;
    }
}
var $2bf103f5c1da86b6$export$2e2bcd8739ae039 = $2bf103f5c1da86b6$var$setupUFOGlobalErrorHandler;

});

parcelRegister("1vZZg", function(module, exports) {

$parcel$export(module.exports, "reportError", () => $cb60f6eafe197acd$export$b33b857ad1d9900e);
$parcel$export(module.exports, "installErrorHandler", () => $cb60f6eafe197acd$export$abd5747ea77ecab9);

var $8XtVW = parcelRequire("8XtVW");
const $cb60f6eafe197acd$var$buffer = [];
let $cb60f6eafe197acd$var$push = (payload)=>{
    $cb60f6eafe197acd$var$buffer.push(payload);
};
function $cb60f6eafe197acd$export$b33b857ad1d9900e(payload) {
    $cb60f6eafe197acd$var$push(payload);
}
function $cb60f6eafe197acd$export$abd5747ea77ecab9(handler) {
    if ((0, $8XtVW.fg)('moving_jira_entry-points_api_under_platform')) {
        $cb60f6eafe197acd$var$push = handler;
        $cb60f6eafe197acd$var$buffer.forEach((payload)=>handler(payload));
        $cb60f6eafe197acd$var$buffer.length = 0;
    }
}

});

parcelRegister("S1tY7", function(module, exports) {

$parcel$export(module.exports, "captureException", () => $0a2631a0a92d682b$export$f5282963edea4a68);
$parcel$export(module.exports, "captureMessage", () => $0a2631a0a92d682b$export$45654777c133ae80);
$parcel$export(module.exports, "captureEvent", () => $0a2631a0a92d682b$export$1462b974fdcf6ba2);
$parcel$export(module.exports, "withScope", () => $0a2631a0a92d682b$export$ec58d9285c204497);
$parcel$export(module.exports, "getCurrentScope", () => $0a2631a0a92d682b$export$c7be4b0125a10cba);
$parcel$export(module.exports, "getClient", () => $0a2631a0a92d682b$export$6bb76d6eba7e258c);

var $7cDym = parcelRequire("7cDym");
var $iILRy = parcelRequire("iILRy");
var $dcNCf = parcelRequire("dcNCf");
var $3vU5t = parcelRequire("3vU5t");
var $dcmwb = parcelRequire("dcmwb");

var $kxRA4 = parcelRequire("kxRA4");

var $eblj3 = parcelRequire("eblj3");

var $5x0VR = parcelRequire("5x0VR");

var $e8qIc = parcelRequire("e8qIc");

var $4eCQ6 = parcelRequire("4eCQ6");
/**
 * Captures an exception event and sends it to Sentry.
 *
 * @param exception The exception to capture.
 * @param hint Optional additional data to attach to the Sentry event.
 * @returns the id of the captured Sentry event.
 */ function $0a2631a0a92d682b$export$f5282963edea4a68(// eslint-disable-next-line @typescript-eslint/no-explicit-any
exception, hint) {
    // eslint-disable-next-line deprecation/deprecation
    return (0, $5x0VR.getCurrentHub)().captureException(exception, (0, $4eCQ6.parseEventHintOrCaptureContext)(hint));
}
/**
 * Captures a message event and sends it to Sentry.
 *
 * @param exception The exception to capture.
 * @param captureContext Define the level of the message or pass in additional data to attach to the message.
 * @returns the id of the captured message.
 */ function $0a2631a0a92d682b$export$45654777c133ae80(message, // eslint-disable-next-line deprecation/deprecation
captureContext) {
    // This is necessary to provide explicit scopes upgrade, without changing the original
    // arity of the `captureMessage(message, level)` method.
    const level = typeof captureContext === 'string' ? captureContext : undefined;
    const context = typeof captureContext !== 'string' ? {
        captureContext: captureContext
    } : undefined;
    // eslint-disable-next-line deprecation/deprecation
    return (0, $5x0VR.getCurrentHub)().captureMessage(message, level, context);
}
/**
 * Captures a manually created event and sends it to Sentry.
 *
 * @param exception The event to send to Sentry.
 * @param hint Optional additional data to attach to the Sentry event.
 * @returns the id of the captured event.
 */ function $0a2631a0a92d682b$export$1462b974fdcf6ba2(event, hint) {
    // eslint-disable-next-line deprecation/deprecation
    return (0, $5x0VR.getCurrentHub)().captureEvent(event, hint);
}
/**
 * Callback to set context information onto the scope.
 * @param callback Callback function that receives Scope.
 *
 * @deprecated Use getCurrentScope() directly.
 */ // eslint-disable-next-line deprecation/deprecation
function $0a2631a0a92d682b$export$99d44f04437e9cb8(callback) {
    // eslint-disable-next-line deprecation/deprecation
    (0, $5x0VR.getCurrentHub)().configureScope(callback);
}
/**
 * Records a new breadcrumb which will be attached to future events.
 *
 * Breadcrumbs will be added to subsequent events to provide more context on
 * user's actions prior to an error or crash.
 *
 * @param breadcrumb The breadcrumb to record.
 */ // eslint-disable-next-line deprecation/deprecation
function $0a2631a0a92d682b$export$efda9a273d7a036d(breadcrumb, hint) {
    // eslint-disable-next-line deprecation/deprecation
    (0, $5x0VR.getCurrentHub)().addBreadcrumb(breadcrumb, hint);
}
/**
 * Sets context data with the given name.
 * @param name of the context
 * @param context Any kind of data. This data will be normalized.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any, deprecation/deprecation
function $0a2631a0a92d682b$export$2f04de43fe27971a(name, context) {
    // eslint-disable-next-line deprecation/deprecation
    (0, $5x0VR.getCurrentHub)().setContext(name, context);
}
/**
 * Set an object that will be merged sent as extra data with the event.
 * @param extras Extras object to merge into current context.
 */ // eslint-disable-next-line deprecation/deprecation
function $0a2631a0a92d682b$export$bb4922da0dd51b92(extras) {
    // eslint-disable-next-line deprecation/deprecation
    (0, $5x0VR.getCurrentHub)().setExtras(extras);
}
/**
 * Set key:value that will be sent as extra data with the event.
 * @param key String of extra
 * @param extra Any kind of data. This data will be normalized.
 */ // eslint-disable-next-line deprecation/deprecation
function $0a2631a0a92d682b$export$8e8e7789d42ed61d(key, extra) {
    // eslint-disable-next-line deprecation/deprecation
    (0, $5x0VR.getCurrentHub)().setExtra(key, extra);
}
/**
 * Set an object that will be merged sent as tags data with the event.
 * @param tags Tags context object to merge into current context.
 */ // eslint-disable-next-line deprecation/deprecation
function $0a2631a0a92d682b$export$74a8fb34822092e6(tags) {
    // eslint-disable-next-line deprecation/deprecation
    (0, $5x0VR.getCurrentHub)().setTags(tags);
}
/**
 * Set key:value that will be sent as tags data with the event.
 *
 * Can also be used to unset a tag, by passing `undefined`.
 *
 * @param key String key of tag
 * @param value Value of tag
 */ // eslint-disable-next-line deprecation/deprecation
function $0a2631a0a92d682b$export$a37d07ee78eb4569(key, value) {
    // eslint-disable-next-line deprecation/deprecation
    (0, $5x0VR.getCurrentHub)().setTag(key, value);
}
/**
 * Updates user context information for future events.
 *
 * @param user User context object to be set in the current context. Pass `null` to unset the user.
 */ // eslint-disable-next-line deprecation/deprecation
function $0a2631a0a92d682b$export$8b6bb3dd62a01be2(user) {
    // eslint-disable-next-line deprecation/deprecation
    (0, $5x0VR.getCurrentHub)().setUser(user);
}
/**
 * Creates a new scope with and executes the given operation within.
 * The scope is automatically removed once the operation
 * finishes or throws.
 *
 * This is essentially a convenience function for:
 *
 *     pushScope();
 *     callback();
 *     popScope();
 */ /**
 * Either creates a new active scope, or sets the given scope as active scope in the given callback.
 */ function $0a2631a0a92d682b$export$ec58d9285c204497(...rest) {
    // eslint-disable-next-line deprecation/deprecation
    const hub = (0, $5x0VR.getCurrentHub)();
    // If a scope is defined, we want to make this the active scope instead of the default one
    if (rest.length === 2) {
        const [scope, callback] = rest;
        if (!scope) // eslint-disable-next-line deprecation/deprecation
        return hub.withScope(callback);
        // eslint-disable-next-line deprecation/deprecation
        return hub.withScope(()=>{
            // eslint-disable-next-line deprecation/deprecation
            hub.getStackTop().scope = scope;
            return callback(scope);
        });
    }
    // eslint-disable-next-line deprecation/deprecation
    return hub.withScope(rest[0]);
}
/**
 * Attempts to fork the current isolation scope and the current scope based on the current async context strategy. If no
 * async context strategy is set, the isolation scope and the current scope will not be forked (this is currently the
 * case, for example, in the browser).
 *
 * Usage of this function in environments without async context strategy is discouraged and may lead to unexpected behaviour.
 *
 * This function is intended for Sentry SDK and SDK integration development. It is not recommended to be used in "normal"
 * applications directly because it comes with pitfalls. Use at your own risk!
 *
 * @param callback The callback in which the passed isolation scope is active. (Note: In environments without async
 * context strategy, the currently active isolation scope may change within execution of the callback.)
 * @returns The same value that `callback` returns.
 */ function $0a2631a0a92d682b$export$9a4fed82c350c2bd(callback) {
    return (0, $5x0VR.runWithAsyncContext)(()=>{
        return callback((0, $5x0VR.getIsolationScope)());
    });
}
/**
 * Forks the current scope and sets the provided span as active span in the context of the provided callback.
 *
 * @param span Spans started in the context of the provided callback will be children of this span.
 * @param callback Execution context in which the provided span will be active. Is passed the newly forked scope.
 * @returns the value returned from the provided callback function.
 */ function $0a2631a0a92d682b$export$e57ac09b143d92a2(span, callback) {
    return $0a2631a0a92d682b$export$ec58d9285c204497((scope)=>{
        // eslint-disable-next-line deprecation/deprecation
        scope.setSpan(span);
        return callback(scope);
    });
}
/**
 * Starts a new `Transaction` and returns it. This is the entry point to manual tracing instrumentation.
 *
 * A tree structure can be built by adding child spans to the transaction, and child spans to other spans. To start a
 * new child span within the transaction or any span, call the respective `.startChild()` method.
 *
 * Every child span must be finished before the transaction is finished, otherwise the unfinished spans are discarded.
 *
 * The transaction must be finished with a call to its `.end()` method, at which point the transaction with all its
 * finished child spans will be sent to Sentry.
 *
 * NOTE: This function should only be used for *manual* instrumentation. Auto-instrumentation should call
 * `startTransaction` directly on the hub.
 *
 * @param context Properties of the new `Transaction`.
 * @param customSamplingContext Information given to the transaction sampling function (along with context-dependent
 * default values). See {@link Options.tracesSampler}.
 *
 * @returns The transaction which was just started
 *
 * @deprecated Use `startSpan()`, `startSpanManual()` or `startInactiveSpan()` instead.
 */ function $0a2631a0a92d682b$export$e262da7ae6480481(context, customSamplingContext) {
    // eslint-disable-next-line deprecation/deprecation
    return (0, $5x0VR.getCurrentHub)().startTransaction({
        ...context
    }, customSamplingContext);
}
/**
 * Create a cron monitor check in and send it to Sentry.
 *
 * @param checkIn An object that describes a check in.
 * @param upsertMonitorConfig An optional object that describes a monitor config. Use this if you want
 * to create a monitor automatically when sending a check in.
 */ function $0a2631a0a92d682b$export$413528111fbc67c(checkIn, upsertMonitorConfig) {
    const scope = $0a2631a0a92d682b$export$c7be4b0125a10cba();
    const client = $0a2631a0a92d682b$export$6bb76d6eba7e258c();
    if (!client) (0, $eblj3.DEBUG_BUILD) && (0, $dcNCf.logger).warn('Cannot capture check-in. No client defined.');
    else if (!client.captureCheckIn) (0, $eblj3.DEBUG_BUILD) && (0, $dcNCf.logger).warn('Cannot capture check-in. Client does not support sending check-ins.');
    else return client.captureCheckIn(checkIn, upsertMonitorConfig, scope);
    return (0, $dcmwb.uuid4)();
}
/**
 * Wraps a callback with a cron monitor check in. The check in will be sent to Sentry when the callback finishes.
 *
 * @param monitorSlug The distinct slug of the monitor.
 * @param upsertMonitorConfig An optional object that describes a monitor config. Use this if you want
 * to create a monitor automatically when sending a check in.
 */ function $0a2631a0a92d682b$export$553526fc5f03c0b1(monitorSlug, callback, upsertMonitorConfig) {
    const checkInId = $0a2631a0a92d682b$export$413528111fbc67c({
        monitorSlug: monitorSlug,
        status: 'in_progress'
    }, upsertMonitorConfig);
    const now = (0, $3vU5t.timestampInSeconds)();
    function finishCheckIn(status) {
        $0a2631a0a92d682b$export$413528111fbc67c({
            monitorSlug: monitorSlug,
            status: status,
            checkInId: checkInId,
            duration: (0, $3vU5t.timestampInSeconds)() - now
        });
    }
    let maybePromiseResult;
    try {
        maybePromiseResult = callback();
    } catch (e) {
        finishCheckIn('error');
        throw e;
    }
    if ((0, $iILRy.isThenable)(maybePromiseResult)) Promise.resolve(maybePromiseResult).then(()=>{
        finishCheckIn('ok');
    }, ()=>{
        finishCheckIn('error');
    });
    else finishCheckIn('ok');
    return maybePromiseResult;
}
/**
 * Call `flush()` on the current client, if there is one. See {@link Client.flush}.
 *
 * @param timeout Maximum time in ms the client should wait to flush its event queue. Omitting this parameter will cause
 * the client to wait until all events are sent before resolving the promise.
 * @returns A promise which resolves to `true` if the queue successfully drains before the timeout, or `false` if it
 * doesn't (or if there's no client defined).
 */ async function $0a2631a0a92d682b$export$4909b86c8034bf73(timeout) {
    const client = $0a2631a0a92d682b$export$6bb76d6eba7e258c();
    if (client) return client.flush(timeout);
    (0, $eblj3.DEBUG_BUILD) && (0, $dcNCf.logger).warn('Cannot flush events. No client defined.');
    return Promise.resolve(false);
}
/**
 * Call `close()` on the current client, if there is one. See {@link Client.close}.
 *
 * @param timeout Maximum time in ms the client should wait to flush its event queue before shutting down. Omitting this
 * parameter will cause the client to wait until all events are sent before disabling itself.
 * @returns A promise which resolves to `true` if the queue successfully drains before the timeout, or `false` if it
 * doesn't (or if there's no client defined).
 */ async function $0a2631a0a92d682b$export$8360e631d277ea4d(timeout) {
    const client = $0a2631a0a92d682b$export$6bb76d6eba7e258c();
    if (client) return client.close(timeout);
    (0, $eblj3.DEBUG_BUILD) && (0, $dcNCf.logger).warn('Cannot flush events and disable SDK. No client defined.');
    return Promise.resolve(false);
}
/**
 * This is the getter for lastEventId.
 *
 * @returns The last event id of a captured event.
 */ function $0a2631a0a92d682b$export$5d4e9fd7fac8e617() {
    // eslint-disable-next-line deprecation/deprecation
    return (0, $5x0VR.getCurrentHub)().lastEventId();
}
/**
 * Get the currently active client.
 */ function $0a2631a0a92d682b$export$6bb76d6eba7e258c() {
    // eslint-disable-next-line deprecation/deprecation
    return (0, $5x0VR.getCurrentHub)().getClient();
}
/**
 * Returns true if Sentry has been properly initialized.
 */ function $0a2631a0a92d682b$export$3f95c6f800b78024() {
    return !!$0a2631a0a92d682b$export$6bb76d6eba7e258c();
}
/**
 * Get the currently active scope.
 */ function $0a2631a0a92d682b$export$c7be4b0125a10cba() {
    // eslint-disable-next-line deprecation/deprecation
    return (0, $5x0VR.getCurrentHub)().getScope();
}
/**
 * Start a session on the current isolation scope.
 *
 * @param context (optional) additional properties to be applied to the returned session object
 *
 * @returns the new active session
 */ function $0a2631a0a92d682b$export$c0d84948cecf78d8(context) {
    const client = $0a2631a0a92d682b$export$6bb76d6eba7e258c();
    const isolationScope = (0, $5x0VR.getIsolationScope)();
    const currentScope = $0a2631a0a92d682b$export$c7be4b0125a10cba();
    const { release: release, environment: environment = (0, $kxRA4.DEFAULT_ENVIRONMENT) } = client && client.getOptions() || {};
    // Will fetch userAgent if called from browser sdk
    const { userAgent: userAgent } = (0, $7cDym.GLOBAL_OBJ).navigator || {};
    const session = (0, $e8qIc.makeSession)({
        release: release,
        environment: environment,
        user: currentScope.getUser() || isolationScope.getUser(),
        ...userAgent && {
            userAgent: userAgent
        },
        ...context
    });
    // End existing session if there's one
    const currentSession = isolationScope.getSession();
    if (currentSession && currentSession.status === 'ok') (0, $e8qIc.updateSession)(currentSession, {
        status: 'exited'
    });
    $0a2631a0a92d682b$export$17a5be43989a0bc1();
    // Afterwards we set the new session on the scope
    isolationScope.setSession(session);
    // TODO (v8): Remove this and only use the isolation scope(?).
    // For v7 though, we can't "soft-break" people using getCurrentHub().getScope().setSession()
    currentScope.setSession(session);
    return session;
}
/**
 * End the session on the current isolation scope.
 */ function $0a2631a0a92d682b$export$17a5be43989a0bc1() {
    const isolationScope = (0, $5x0VR.getIsolationScope)();
    const currentScope = $0a2631a0a92d682b$export$c7be4b0125a10cba();
    const session = currentScope.getSession() || isolationScope.getSession();
    if (session) (0, $e8qIc.closeSession)(session);
    $0a2631a0a92d682b$var$_sendSessionUpdate();
    // the session is over; take it off of the scope
    isolationScope.setSession();
    // TODO (v8): Remove this and only use the isolation scope(?).
    // For v7 though, we can't "soft-break" people using getCurrentHub().getScope().setSession()
    currentScope.setSession();
}
/**
 * Sends the current Session on the scope
 */ function $0a2631a0a92d682b$var$_sendSessionUpdate() {
    const isolationScope = (0, $5x0VR.getIsolationScope)();
    const currentScope = $0a2631a0a92d682b$export$c7be4b0125a10cba();
    const client = $0a2631a0a92d682b$export$6bb76d6eba7e258c();
    // TODO (v8): Remove currentScope and only use the isolation scope(?).
    // For v7 though, we can't "soft-break" people using getCurrentHub().getScope().setSession()
    const session = currentScope.getSession() || isolationScope.getSession();
    if (session && client && client.captureSession) client.captureSession(session);
}
/**
 * Sends the current session on the scope to Sentry
 *
 * @param end If set the session will be marked as exited and removed from the scope.
 *            Defaults to `false`.
 */ function $0a2631a0a92d682b$export$667e7b4d445d566b(end = false) {
    // both send the update and pull the session from the scope
    if (end) {
        $0a2631a0a92d682b$export$17a5be43989a0bc1();
        return;
    }
    // only send the update
    $0a2631a0a92d682b$var$_sendSessionUpdate();
}

});
parcelRegister("7cDym", function(module, exports) {

$parcel$export(module.exports, "GLOBAL_OBJ", () => $53e855d0408f33b0$export$f1a6cdb1459e81d1);
$parcel$export(module.exports, "getGlobalObject", () => $53e855d0408f33b0$export$256479dc0cea61c4);
$parcel$export(module.exports, "getGlobalSingleton", () => $53e855d0408f33b0$export$7e223ec222791509);
/** Internal global with common properties and Sentry extensions  */ // The code below for 'isGlobalObj' and 'GLOBAL_OBJ' was copied from core-js before modification
// https://github.com/zloirock/core-js/blob/1b944df55282cdc99c90db5f49eb0b6eda2cc0a3/packages/core-js/internals/global.js
// core-js has the following licence:
//
// Copyright (c) 2014-2022 Denis Pushkarev
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
// THE SOFTWARE.
/** Returns 'obj' if it's the global object, otherwise returns undefined */ function $53e855d0408f33b0$var$isGlobalObj(obj) {
    return obj && obj.Math == Math ? obj : undefined;
}
/** Get's the global object for the current JavaScript runtime */ const $53e855d0408f33b0$export$f1a6cdb1459e81d1 = typeof globalThis == 'object' && $53e855d0408f33b0$var$isGlobalObj(globalThis) || // eslint-disable-next-line no-restricted-globals
typeof window == 'object' && $53e855d0408f33b0$var$isGlobalObj(window) || typeof self == 'object' && $53e855d0408f33b0$var$isGlobalObj(self) || typeof $parcel$global == 'object' && $53e855d0408f33b0$var$isGlobalObj($parcel$global) || function() {
    return this;
}() || {};
/**
 * @deprecated Use GLOBAL_OBJ instead or WINDOW from @sentry/browser. This will be removed in v8
 */ function $53e855d0408f33b0$export$256479dc0cea61c4() {
    return $53e855d0408f33b0$export$f1a6cdb1459e81d1;
}
/**
 * Returns a global singleton contained in the global `__SENTRY__` object.
 *
 * If the singleton doesn't already exist in `__SENTRY__`, it will be created using the given factory
 * function and added to the `__SENTRY__` object.
 *
 * @param name name of the global singleton on __SENTRY__
 * @param creator creator Factory function to create the singleton if it doesn't already exist on `__SENTRY__`
 * @param obj (Optional) The global object on which to look for `__SENTRY__`, if not `GLOBAL_OBJ`'s return value
 * @returns the singleton
 */ function $53e855d0408f33b0$export$7e223ec222791509(name, creator, obj) {
    const gbl = obj || $53e855d0408f33b0$export$f1a6cdb1459e81d1;
    const __SENTRY__ = gbl.__SENTRY__ = gbl.__SENTRY__ || {};
    const singleton = __SENTRY__[name] || (__SENTRY__[name] = creator());
    return singleton;
}

});

parcelRegister("iILRy", function(module, exports) {

$parcel$export(module.exports, "isError", () => $da11769a558e7bba$export$e6127cc7fe7395c3);
$parcel$export(module.exports, "isInstanceOf", () => $da11769a558e7bba$export$49034edbe6b62415);
$parcel$export(module.exports, "isString", () => $da11769a558e7bba$export$844ec244b1367d54);
$parcel$export(module.exports, "isPrimitive", () => $da11769a558e7bba$export$c3825b437cbdea5c);
$parcel$export(module.exports, "isPlainObject", () => $da11769a558e7bba$export$53b83ca8eaab0383);
$parcel$export(module.exports, "isEvent", () => $da11769a558e7bba$export$9671ea99bd126ace);
$parcel$export(module.exports, "isElement", () => $da11769a558e7bba$export$45a5e7f76e0caa8d);
$parcel$export(module.exports, "isRegExp", () => $da11769a558e7bba$export$49841c62b9eff15);
$parcel$export(module.exports, "isThenable", () => $da11769a558e7bba$export$f5b060c2914b97c8);
$parcel$export(module.exports, "isSyntheticEvent", () => $da11769a558e7bba$export$bc2894c7158efbac);
$parcel$export(module.exports, "isNaN", () => $da11769a558e7bba$export$c9f5652083b8129d);
$parcel$export(module.exports, "isVueViewModel", () => $da11769a558e7bba$export$7916fad0ebc23f48);
// eslint-disable-next-line @typescript-eslint/unbound-method
const $da11769a558e7bba$var$objectToString = Object.prototype.toString;
/**
 * Checks whether given value's type is one of a few Error or Error-like
 * {@link isError}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $da11769a558e7bba$export$e6127cc7fe7395c3(wat) {
    switch($da11769a558e7bba$var$objectToString.call(wat)){
        case '[object Error]':
        case '[object Exception]':
        case '[object DOMException]':
            return true;
        default:
            return $da11769a558e7bba$export$49034edbe6b62415(wat, Error);
    }
}
/**
 * Checks whether given value is an instance of the given built-in class.
 *
 * @param wat The value to be checked
 * @param className
 * @returns A boolean representing the result.
 */ function $da11769a558e7bba$var$isBuiltin(wat, className) {
    return $da11769a558e7bba$var$objectToString.call(wat) === `[object ${className}]`;
}
/**
 * Checks whether given value's type is ErrorEvent
 * {@link isErrorEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $da11769a558e7bba$export$9f9636d330b71954(wat) {
    return $da11769a558e7bba$var$isBuiltin(wat, 'ErrorEvent');
}
/**
 * Checks whether given value's type is DOMError
 * {@link isDOMError}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $da11769a558e7bba$export$ef9e2056653f0c8e(wat) {
    return $da11769a558e7bba$var$isBuiltin(wat, 'DOMError');
}
/**
 * Checks whether given value's type is DOMException
 * {@link isDOMException}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $da11769a558e7bba$export$12e869b2a583f783(wat) {
    return $da11769a558e7bba$var$isBuiltin(wat, 'DOMException');
}
/**
 * Checks whether given value's type is a string
 * {@link isString}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $da11769a558e7bba$export$844ec244b1367d54(wat) {
    return $da11769a558e7bba$var$isBuiltin(wat, 'String');
}
/**
 * Checks whether given string is parameterized
 * {@link isParameterizedString}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $da11769a558e7bba$export$dbcbffa59149b824(wat) {
    return typeof wat === 'object' && wat !== null && '__sentry_template_string__' in wat && '__sentry_template_values__' in wat;
}
/**
 * Checks whether given value is a primitive (undefined, null, number, boolean, string, bigint, symbol)
 * {@link isPrimitive}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $da11769a558e7bba$export$c3825b437cbdea5c(wat) {
    return wat === null || $da11769a558e7bba$export$dbcbffa59149b824(wat) || typeof wat !== 'object' && typeof wat !== 'function';
}
/**
 * Checks whether given value's type is an object literal, or a class instance.
 * {@link isPlainObject}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $da11769a558e7bba$export$53b83ca8eaab0383(wat) {
    return $da11769a558e7bba$var$isBuiltin(wat, 'Object');
}
/**
 * Checks whether given value's type is an Event instance
 * {@link isEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $da11769a558e7bba$export$9671ea99bd126ace(wat) {
    return typeof Event !== 'undefined' && $da11769a558e7bba$export$49034edbe6b62415(wat, Event);
}
/**
 * Checks whether given value's type is an Element instance
 * {@link isElement}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $da11769a558e7bba$export$45a5e7f76e0caa8d(wat) {
    return typeof Element !== 'undefined' && $da11769a558e7bba$export$49034edbe6b62415(wat, Element);
}
/**
 * Checks whether given value's type is an regexp
 * {@link isRegExp}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $da11769a558e7bba$export$49841c62b9eff15(wat) {
    return $da11769a558e7bba$var$isBuiltin(wat, 'RegExp');
}
/**
 * Checks whether given value has a then function.
 * @param wat A value to be checked.
 */ function $da11769a558e7bba$export$f5b060c2914b97c8(wat) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    return Boolean(wat && wat.then && typeof wat.then === 'function');
}
/**
 * Checks whether given value's type is a SyntheticEvent
 * {@link isSyntheticEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $da11769a558e7bba$export$bc2894c7158efbac(wat) {
    return $da11769a558e7bba$export$53b83ca8eaab0383(wat) && 'nativeEvent' in wat && 'preventDefault' in wat && 'stopPropagation' in wat;
}
/**
 * Checks whether given value is NaN
 * {@link isNaN}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $da11769a558e7bba$export$c9f5652083b8129d(wat) {
    return typeof wat === 'number' && wat !== wat;
}
/**
 * Checks whether given value's type is an instance of provided constructor.
 * {@link isInstanceOf}.
 *
 * @param wat A value to be checked.
 * @param base A constructor to be used in a check.
 * @returns A boolean representing the result.
 */ function $da11769a558e7bba$export$49034edbe6b62415(wat, base) {
    try {
        return wat instanceof base;
    } catch (_e) {
        return false;
    }
}
/**
 * Checks whether given value's type is a Vue ViewModel.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $da11769a558e7bba$export$7916fad0ebc23f48(wat) {
    // Not using Object.prototype.toString because in Vue 3 it would read the instance's Symbol(Symbol.toStringTag) property.
    return !!(typeof wat === 'object' && wat !== null && (wat.__isVue || wat._isVue));
}

});

parcelRegister("dcNCf", function(module, exports) {

$parcel$export(module.exports, "CONSOLE_LEVELS", () => $99d2e20a18415135$export$2a2b1d2252a69ecb);
$parcel$export(module.exports, "originalConsoleMethods", () => $99d2e20a18415135$export$77c4ce905194557b);
$parcel$export(module.exports, "consoleSandbox", () => $99d2e20a18415135$export$cda52e2a8927a2ca);
$parcel$export(module.exports, "logger", () => $99d2e20a18415135$export$af88d00dbe7f521);

var $hIqTc = parcelRequire("hIqTc");

var $7cDym = parcelRequire("7cDym");
/** Prefix for logging strings */ const $99d2e20a18415135$var$PREFIX = 'Sentry Logger ';
const $99d2e20a18415135$export$2a2b1d2252a69ecb = [
    'debug',
    'info',
    'warn',
    'error',
    'log',
    'assert',
    'trace'
];
/** This may be mutated by the console instrumentation. */ const $99d2e20a18415135$export$77c4ce905194557b = {};
/** JSDoc */ /**
 * Temporarily disable sentry console instrumentations.
 *
 * @param callback The function to run against the original `console` messages
 * @returns The results of the callback
 */ function $99d2e20a18415135$export$cda52e2a8927a2ca(callback) {
    if (!('console' in (0, $7cDym.GLOBAL_OBJ))) return callback();
    const console = (0, $7cDym.GLOBAL_OBJ).console;
    const wrappedFuncs = {};
    const wrappedLevels = Object.keys($99d2e20a18415135$export$77c4ce905194557b);
    // Restore all wrapped console methods
    wrappedLevels.forEach((level)=>{
        const originalConsoleMethod = $99d2e20a18415135$export$77c4ce905194557b[level];
        wrappedFuncs[level] = console[level];
        console[level] = originalConsoleMethod;
    });
    try {
        return callback();
    } finally{
        // Revert restoration to wrapped state
        wrappedLevels.forEach((level)=>{
            console[level] = wrappedFuncs[level];
        });
    }
}
function $99d2e20a18415135$var$makeLogger() {
    let enabled = false;
    const logger = {
        enable: ()=>{
            enabled = true;
        },
        disable: ()=>{
            enabled = false;
        },
        isEnabled: ()=>enabled
    };
    if (0, $hIqTc.DEBUG_BUILD) $99d2e20a18415135$export$2a2b1d2252a69ecb.forEach((name)=>{
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        logger[name] = (...args)=>{
            if (enabled) $99d2e20a18415135$export$cda52e2a8927a2ca(()=>{
                (0, $7cDym.GLOBAL_OBJ).console[name](`${$99d2e20a18415135$var$PREFIX}[${name}]:`, ...args);
            });
        };
    });
    else $99d2e20a18415135$export$2a2b1d2252a69ecb.forEach((name)=>{
        logger[name] = ()=>undefined;
    });
    return logger;
}
const $99d2e20a18415135$export$af88d00dbe7f521 = $99d2e20a18415135$var$makeLogger();

});
parcelRegister("hIqTc", function(module, exports) {

$parcel$export(module.exports, "DEBUG_BUILD", () => $ce5b6768bb00d02d$export$16a28057038b10ef);
/**
 * This serves as a build time flag that will be true by default, but false in non-debug builds or if users replace `__SENTRY_DEBUG__` in their generated code.
 *
 * ATTENTION: This constant must never cross package boundaries (i.e. be exported) to guarantee that it can be used for tree shaking.
 */ const $ce5b6768bb00d02d$export$16a28057038b10ef = typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__;

});


parcelRegister("3vU5t", function(module, exports) {

$parcel$export(module.exports, "dateTimestampInSeconds", () => $28efc62202f72105$export$7740643b9eeaf0c4);
$parcel$export(module.exports, "timestampInSeconds", () => $28efc62202f72105$export$ee52dced521e3e18);

var $7cDym = parcelRequire("7cDym");
const $28efc62202f72105$var$ONE_SECOND_IN_MS = 1000;
/**
 * A partial definition of the [Performance Web API]{@link https://developer.mozilla.org/en-US/docs/Web/API/Performance}
 * for accessing a high-resolution monotonic clock.
 */ /**
 * Returns a timestamp in seconds since the UNIX epoch using the Date API.
 *
 * TODO(v8): Return type should be rounded.
 */ function $28efc62202f72105$export$7740643b9eeaf0c4() {
    return Date.now() / $28efc62202f72105$var$ONE_SECOND_IN_MS;
}
/**
 * Returns a wrapper around the native Performance API browser implementation, or undefined for browsers that do not
 * support the API.
 *
 * Wrapping the native API works around differences in behavior from different browsers.
 */ function $28efc62202f72105$var$createUnixTimestampInSecondsFunc() {
    const { performance: performance } = (0, $7cDym.GLOBAL_OBJ);
    if (!performance || !performance.now) return $28efc62202f72105$export$7740643b9eeaf0c4;
    // Some browser and environments don't have a timeOrigin, so we fallback to
    // using Date.now() to compute the starting time.
    const approxStartingTimeOrigin = Date.now() - performance.now();
    const timeOrigin = performance.timeOrigin == undefined ? approxStartingTimeOrigin : performance.timeOrigin;
    // performance.now() is a monotonic clock, which means it starts at 0 when the process begins. To get the current
    // wall clock time (actual UNIX timestamp), we need to add the starting time origin and the current time elapsed.
    //
    // TODO: This does not account for the case where the monotonic clock that powers performance.now() drifts from the
    // wall clock time, which causes the returned timestamp to be inaccurate. We should investigate how to detect and
    // correct for this.
    // See: https://github.com/getsentry/sentry-javascript/issues/2590
    // See: https://github.com/mdn/content/issues/4713
    // See: https://dev.to/noamr/when-a-millisecond-is-not-a-millisecond-3h6
    return ()=>{
        return (timeOrigin + performance.now()) / $28efc62202f72105$var$ONE_SECOND_IN_MS;
    };
}
/**
 * Returns a timestamp in seconds since the UNIX epoch using either the Performance or Date APIs, depending on the
 * availability of the Performance API.
 *
 * BUG: Note that because of how browsers implement the Performance API, the clock might stop when the computer is
 * asleep. This creates a skew between `dateTimestampInSeconds` and `timestampInSeconds`. The
 * skew can grow to arbitrary amounts like days, weeks or months.
 * See https://github.com/getsentry/sentry-javascript/issues/2590.
 */ const $28efc62202f72105$export$ee52dced521e3e18 = $28efc62202f72105$var$createUnixTimestampInSecondsFunc();
/**
 * Re-exported with an old name for backwards-compatibility.
 * TODO (v8): Remove this
 *
 * @deprecated Use `timestampInSeconds` instead.
 */ const $28efc62202f72105$export$c5907b5a8838db13 = $28efc62202f72105$export$ee52dced521e3e18;
/**
 * Internal helper to store what is the source of browserPerformanceTimeOrigin below. For debugging only.
 */ let $28efc62202f72105$export$f9f8cce55af5194c;
/**
 * The number of milliseconds since the UNIX epoch. This value is only usable in a browser, and only when the
 * performance API is available.
 */ const $28efc62202f72105$export$baf075a948ffc0bf = (()=>{
    // Unfortunately browsers may report an inaccurate time origin data, through either performance.timeOrigin or
    // performance.timing.navigationStart, which results in poor results in performance data. We only treat time origin
    // data as reliable if they are within a reasonable threshold of the current time.
    const { performance: performance } = (0, $7cDym.GLOBAL_OBJ);
    if (!performance || !performance.now) {
        $28efc62202f72105$export$f9f8cce55af5194c = 'none';
        return undefined;
    }
    const threshold = 3600000;
    const performanceNow = performance.now();
    const dateNow = Date.now();
    // if timeOrigin isn't available set delta to threshold so it isn't used
    const timeOriginDelta = performance.timeOrigin ? Math.abs(performance.timeOrigin + performanceNow - dateNow) : threshold;
    const timeOriginIsReliable = timeOriginDelta < threshold;
    // While performance.timing.navigationStart is deprecated in favor of performance.timeOrigin, performance.timeOrigin
    // is not as widely supported. Namely, performance.timeOrigin is undefined in Safari as of writing.
    // Also as of writing, performance.timing is not available in Web Workers in mainstream browsers, so it is not always
    // a valid fallback. In the absence of an initial time provided by the browser, fallback to the current time from the
    // Date API.
    // eslint-disable-next-line deprecation/deprecation
    const navigationStart = performance.timing && performance.timing.navigationStart;
    const hasNavigationStart = typeof navigationStart === 'number';
    // if navigationStart isn't available set delta to threshold so it isn't used
    const navigationStartDelta = hasNavigationStart ? Math.abs(navigationStart + performanceNow - dateNow) : threshold;
    const navigationStartIsReliable = navigationStartDelta < threshold;
    if (timeOriginIsReliable || navigationStartIsReliable) {
        // Use the more reliable time origin
        if (timeOriginDelta <= navigationStartDelta) {
            $28efc62202f72105$export$f9f8cce55af5194c = 'timeOrigin';
            return performance.timeOrigin;
        } else {
            $28efc62202f72105$export$f9f8cce55af5194c = 'navigationStart';
            return navigationStart;
        }
    }
    // Either both timeOrigin and navigationStart are skewed or neither is available, fallback to Date.
    $28efc62202f72105$export$f9f8cce55af5194c = 'dateNow';
    return dateNow;
})();

});

parcelRegister("dcmwb", function(module, exports) {

$parcel$export(module.exports, "uuid4", () => $99bddcfa757468f3$export$19f53698e68b2496);
$parcel$export(module.exports, "addExceptionMechanism", () => $99bddcfa757468f3$export$c69a9a0313b03bb1);
$parcel$export(module.exports, "addContextToFrame", () => $99bddcfa757468f3$export$ec2291bfc64632f0);
$parcel$export(module.exports, "arrayify", () => $99bddcfa757468f3$export$3131421a7d01b4fb);

var $fGLXA = parcelRequire("fGLXA");

var $Reevt = parcelRequire("Reevt");

var $7cDym = parcelRequire("7cDym");
/**
 * UUID4 generator
 *
 * @returns string Generated UUID4.
 */ function $99bddcfa757468f3$export$19f53698e68b2496() {
    const gbl = (0, $7cDym.GLOBAL_OBJ);
    const crypto = gbl.crypto || gbl.msCrypto;
    let getRandomByte = ()=>Math.random() * 16;
    try {
        if (crypto && crypto.randomUUID) return crypto.randomUUID().replace(/-/g, '');
        if (crypto && crypto.getRandomValues) getRandomByte = ()=>{
            // crypto.getRandomValues might return undefined instead of the typed array
            // in old Chromium versions (e.g. 23.0.1235.0 (151422))
            // However, `typedArray` is still filled in-place.
            // @see https://developer.mozilla.org/en-US/docs/Web/API/Crypto/getRandomValues#typedarray
            const typedArray = new Uint8Array(1);
            crypto.getRandomValues(typedArray);
            return typedArray[0];
        };
    } catch (_) {
    // some runtimes can crash invoking crypto
    // https://github.com/getsentry/sentry-javascript/issues/8935
    }
    // http://stackoverflow.com/questions/105034/how-to-create-a-guid-uuid-in-javascript/2117523#2117523
    // Concatenating the following numbers as strings results in '10000000100040008000100000000000'
    return "10000000100040008000100000000000".replace(/[018]/g, (c)=>// eslint-disable-next-line no-bitwise
        (c ^ (getRandomByte() & 15) >> c / 4).toString(16));
}
function $99bddcfa757468f3$var$getFirstException(event) {
    return event.exception && event.exception.values ? event.exception.values[0] : undefined;
}
/**
 * Extracts either message or type+value from an event that can be used for user-facing logs
 * @returns event's description
 */ function $99bddcfa757468f3$export$4157119e2b157127(event) {
    const { message: message, event_id: eventId } = event;
    if (message) return message;
    const firstException = $99bddcfa757468f3$var$getFirstException(event);
    if (firstException) {
        if (firstException.type && firstException.value) return `${firstException.type}: ${firstException.value}`;
        return firstException.type || firstException.value || eventId || '<unknown>';
    }
    return eventId || '<unknown>';
}
/**
 * Adds exception values, type and value to an synthetic Exception.
 * @param event The event to modify.
 * @param value Value of the exception.
 * @param type Type of the exception.
 * @hidden
 */ function $99bddcfa757468f3$export$f26508487bf83ee7(event, value, type) {
    const exception = event.exception = event.exception || {};
    const values = exception.values = exception.values || [];
    const firstException = values[0] = values[0] || {};
    if (!firstException.value) firstException.value = value || '';
    if (!firstException.type) firstException.type = type || 'Error';
}
/**
 * Adds exception mechanism data to a given event. Uses defaults if the second parameter is not passed.
 *
 * @param event The event to modify.
 * @param newMechanism Mechanism data to add to the event.
 * @hidden
 */ function $99bddcfa757468f3$export$c69a9a0313b03bb1(event, newMechanism) {
    const firstException = $99bddcfa757468f3$var$getFirstException(event);
    if (!firstException) return;
    const defaultMechanism = {
        type: 'generic',
        handled: true
    };
    const currentMechanism = firstException.mechanism;
    firstException.mechanism = {
        ...defaultMechanism,
        ...currentMechanism,
        ...newMechanism
    };
    if (newMechanism && 'data' in newMechanism) {
        const mergedData = {
            ...currentMechanism && currentMechanism.data,
            ...newMechanism.data
        };
        firstException.mechanism.data = mergedData;
    }
}
// https://semver.org/#is-there-a-suggested-regular-expression-regex-to-check-a-semver-string
const $99bddcfa757468f3$var$SEMVER_REGEXP = /^(0|[1-9]\d*)\.(0|[1-9]\d*)\.(0|[1-9]\d*)(?:-((?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*)(?:\.(?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*))*))?(?:\+([0-9a-zA-Z-]+(?:\.[0-9a-zA-Z-]+)*))?$/;
/**
 * Represents Semantic Versioning object
 */ /**
 * Parses input into a SemVer interface
 * @param input string representation of a semver version
 */ function $99bddcfa757468f3$export$d364f2020ab30578(input) {
    const match = input.match($99bddcfa757468f3$var$SEMVER_REGEXP) || [];
    const major = parseInt(match[1], 10);
    const minor = parseInt(match[2], 10);
    const patch = parseInt(match[3], 10);
    return {
        buildmetadata: match[5],
        major: isNaN(major) ? undefined : major,
        minor: isNaN(minor) ? undefined : minor,
        patch: isNaN(patch) ? undefined : patch,
        prerelease: match[4]
    };
}
/**
 * This function adds context (pre/post/line) lines to the provided frame
 *
 * @param lines string[] containing all lines
 * @param frame StackFrame that will be mutated
 * @param linesOfContext number of context lines we want to add pre/post
 */ function $99bddcfa757468f3$export$ec2291bfc64632f0(lines, frame, linesOfContext = 5) {
    // When there is no line number in the frame, attaching context is nonsensical and will even break grouping
    if (frame.lineno === undefined) return;
    const maxLines = lines.length;
    const sourceLine = Math.max(Math.min(maxLines - 1, frame.lineno - 1), 0);
    frame.pre_context = lines.slice(Math.max(0, sourceLine - linesOfContext), sourceLine).map((line)=>(0, $Reevt.snipLine)(line, 0));
    frame.context_line = (0, $Reevt.snipLine)(lines[Math.min(maxLines - 1, sourceLine)], frame.colno || 0);
    frame.post_context = lines.slice(Math.min(sourceLine + 1, maxLines), sourceLine + 1 + linesOfContext).map((line)=>(0, $Reevt.snipLine)(line, 0));
}
/**
 * Checks whether or not we've already captured the given exception (note: not an identical exception - the very object
 * in question), and marks it captured if not.
 *
 * This is useful because it's possible for an error to get captured by more than one mechanism. After we intercept and
 * record an error, we rethrow it (assuming we've intercepted it before it's reached the top-level global handlers), so
 * that we don't interfere with whatever effects the error might have had were the SDK not there. At that point, because
 * the error has been rethrown, it's possible for it to bubble up to some other code we've instrumented. If it's not
 * caught after that, it will bubble all the way up to the global handlers (which of course we also instrument). This
 * function helps us ensure that even if we encounter the same error more than once, we only record it the first time we
 * see it.
 *
 * Note: It will ignore primitives (always return `false` and not mark them as seen), as properties can't be set on
 * them. {@link: Object.objectify} can be used on exceptions to convert any that are primitives into their equivalent
 * object wrapper forms so that this check will always work. However, because we need to flag the exact object which
 * will get rethrown, and because that rethrowing happens outside of the event processing pipeline, the objectification
 * must be done before the exception captured.
 *
 * @param A thrown exception to check or flag as having been seen
 * @returns `true` if the exception has already been captured, `false` if not (with the side effect of marking it seen)
 */ function $99bddcfa757468f3$export$6de4ffac6a2f1098(exception) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    if (exception && exception.__sentry_captured__) return true;
    try {
        // set it this way rather than by assignment so that it's not ennumerable and therefore isn't recorded by the
        // `ExtraErrorData` integration
        (0, $fGLXA.addNonEnumerableProperty)(exception, '__sentry_captured__', true);
    } catch (err) {
    // `exception` is a primitive, so we can't mark it seen
    }
    return false;
}
/**
 * Checks whether the given input is already an array, and if it isn't, wraps it in one.
 *
 * @param maybeArray Input to turn into an array, if necessary
 * @returns The input, if already an array, or an array with the input as the only element, if not
 */ function $99bddcfa757468f3$export$3131421a7d01b4fb(maybeArray) {
    return Array.isArray(maybeArray) ? maybeArray : [
        maybeArray
    ];
}

});
parcelRegister("fGLXA", function(module, exports) {

$parcel$export(module.exports, "fill", () => $b6bffb2757114e28$export$9563e054e6f787fb);
$parcel$export(module.exports, "addNonEnumerableProperty", () => $b6bffb2757114e28$export$e73679ffaf56810e);
$parcel$export(module.exports, "convertToPlainObject", () => $b6bffb2757114e28$export$62ff257738bf57f5);
$parcel$export(module.exports, "dropUndefinedKeys", () => $b6bffb2757114e28$export$d25f2688db1bb433);

var $fitR1 = parcelRequire("fitR1");

var $hIqTc = parcelRequire("hIqTc");

var $iILRy = parcelRequire("iILRy");

var $dcNCf = parcelRequire("dcNCf");

var $Reevt = parcelRequire("Reevt");
/**
 * Replace a method in an object with a wrapped version of itself.
 *
 * @param source An object that contains a method to be wrapped.
 * @param name The name of the method to be wrapped.
 * @param replacementFactory A higher-order function that takes the original version of the given method and returns a
 * wrapped version. Note: The function returned by `replacementFactory` needs to be a non-arrow function, in order to
 * preserve the correct value of `this`, and the original method must be called using `origMethod.call(this, <other
 * args>)` or `origMethod.apply(this, [<other args>])` (rather than being called directly), again to preserve `this`.
 * @returns void
 */ function $b6bffb2757114e28$export$9563e054e6f787fb(source, name, replacementFactory) {
    if (!(name in source)) return;
    const original = source[name];
    const wrapped = replacementFactory(original);
    // Make sure it's a function first, as we need to attach an empty prototype for `defineProperties` to work
    // otherwise it'll throw "TypeError: Object.defineProperties called on non-object"
    if (typeof wrapped === 'function') $b6bffb2757114e28$export$5c1499e2e5d010ae(wrapped, original);
    source[name] = wrapped;
}
/**
 * Defines a non-enumerable property on the given object.
 *
 * @param obj The object on which to set the property
 * @param name The name of the property to be set
 * @param value The value to which to set the property
 */ function $b6bffb2757114e28$export$e73679ffaf56810e(obj, name, value) {
    try {
        Object.defineProperty(obj, name, {
            // enumerable: false, // the default, so we can save on bundle size by not explicitly setting it
            value: value,
            writable: true,
            configurable: true
        });
    } catch (o_O) {
        (0, $hIqTc.DEBUG_BUILD) && (0, $dcNCf.logger).log(`Failed to add non-enumerable property "${name}" to object`, obj);
    }
}
/**
 * Remembers the original function on the wrapped function and
 * patches up the prototype.
 *
 * @param wrapped the wrapper function
 * @param original the original function that gets wrapped
 */ function $b6bffb2757114e28$export$5c1499e2e5d010ae(wrapped, original) {
    try {
        const proto = original.prototype || {};
        wrapped.prototype = original.prototype = proto;
        $b6bffb2757114e28$export$e73679ffaf56810e(wrapped, '__sentry_original__', original);
    } catch (o_O) {} // eslint-disable-line no-empty
}
/**
 * This extracts the original function if available.  See
 * `markFunctionWrapped` for more information.
 *
 * @param func the function to unwrap
 * @returns the unwrapped version of the function if available.
 */ function $b6bffb2757114e28$export$e6cc1e135e2092e5(func) {
    return func.__sentry_original__;
}
/**
 * Encodes given object into url-friendly format
 *
 * @param object An object that contains serializable values
 * @returns string Encoded
 */ function $b6bffb2757114e28$export$9ef804feabbcbaf1(object) {
    return Object.keys(object).map((key)=>`${encodeURIComponent(key)}=${encodeURIComponent(object[key])}`).join('&');
}
/**
 * Transforms any `Error` or `Event` into a plain object with all of their enumerable properties, and some of their
 * non-enumerable properties attached.
 *
 * @param value Initial source that we have to transform in order for it to be usable by the serializer
 * @returns An Event or Error turned into an object - or the value argurment itself, when value is neither an Event nor
 *  an Error.
 */ function $b6bffb2757114e28$export$62ff257738bf57f5(value) {
    if ((0, $iILRy.isError)(value)) return {
        message: value.message,
        name: value.name,
        stack: value.stack,
        ...$b6bffb2757114e28$var$getOwnProperties(value)
    };
    else if ((0, $iILRy.isEvent)(value)) {
        const newObj = {
            type: value.type,
            target: $b6bffb2757114e28$var$serializeEventTarget(value.target),
            currentTarget: $b6bffb2757114e28$var$serializeEventTarget(value.currentTarget),
            ...$b6bffb2757114e28$var$getOwnProperties(value)
        };
        if (typeof CustomEvent !== 'undefined' && (0, $iILRy.isInstanceOf)(value, CustomEvent)) newObj.detail = value.detail;
        return newObj;
    } else return value;
}
/** Creates a string representation of the target of an `Event` object */ function $b6bffb2757114e28$var$serializeEventTarget(target) {
    try {
        return (0, $iILRy.isElement)(target) ? (0, $fitR1.htmlTreeAsString)(target) : Object.prototype.toString.call(target);
    } catch (_oO) {
        return '<unknown>';
    }
}
/** Filters out all but an object's own properties */ function $b6bffb2757114e28$var$getOwnProperties(obj) {
    if (typeof obj === 'object' && obj !== null) {
        const extractedProps = {};
        for(const property in obj)if (Object.prototype.hasOwnProperty.call(obj, property)) extractedProps[property] = obj[property];
        return extractedProps;
    } else return {};
}
/**
 * Given any captured exception, extract its keys and create a sorted
 * and truncated list that will be used inside the event message.
 * eg. `Non-error exception captured with keys: foo, bar, baz`
 */ function $b6bffb2757114e28$export$b0244d5063c0b61b(exception, maxLength = 40) {
    const keys = Object.keys($b6bffb2757114e28$export$62ff257738bf57f5(exception));
    keys.sort();
    if (!keys.length) return '[object has no keys]';
    if (keys[0].length >= maxLength) return (0, $Reevt.truncate)(keys[0], maxLength);
    for(let includedKeys = keys.length; includedKeys > 0; includedKeys--){
        const serialized = keys.slice(0, includedKeys).join(', ');
        if (serialized.length > maxLength) continue;
        if (includedKeys === keys.length) return serialized;
        return (0, $Reevt.truncate)(serialized, maxLength);
    }
    return '';
}
/**
 * Given any object, return a new object having removed all fields whose value was `undefined`.
 * Works recursively on objects and arrays.
 *
 * Attention: This function keeps circular references in the returned object.
 */ function $b6bffb2757114e28$export$d25f2688db1bb433(inputValue) {
    // This map keeps track of what already visited nodes map to.
    // Our Set - based memoBuilder doesn't work here because we want to the output object to have the same circular
    // references as the input object.
    const memoizationMap = new Map();
    // This function just proxies `_dropUndefinedKeys` to keep the `memoBuilder` out of this function's API
    return $b6bffb2757114e28$var$_dropUndefinedKeys(inputValue, memoizationMap);
}
function $b6bffb2757114e28$var$_dropUndefinedKeys(inputValue, memoizationMap) {
    if ($b6bffb2757114e28$var$isPojo(inputValue)) {
        // If this node has already been visited due to a circular reference, return the object it was mapped to in the new object
        const memoVal = memoizationMap.get(inputValue);
        if (memoVal !== undefined) return memoVal;
        const returnValue = {};
        // Store the mapping of this value in case we visit it again, in case of circular data
        memoizationMap.set(inputValue, returnValue);
        for (const key of Object.keys(inputValue))if (typeof inputValue[key] !== 'undefined') returnValue[key] = $b6bffb2757114e28$var$_dropUndefinedKeys(inputValue[key], memoizationMap);
        return returnValue;
    }
    if (Array.isArray(inputValue)) {
        // If this node has already been visited due to a circular reference, return the array it was mapped to in the new object
        const memoVal = memoizationMap.get(inputValue);
        if (memoVal !== undefined) return memoVal;
        const returnValue = [];
        // Store the mapping of this value in case we visit it again, in case of circular data
        memoizationMap.set(inputValue, returnValue);
        inputValue.forEach((item)=>{
            returnValue.push($b6bffb2757114e28$var$_dropUndefinedKeys(item, memoizationMap));
        });
        return returnValue;
    }
    return inputValue;
}
function $b6bffb2757114e28$var$isPojo(input) {
    if (!(0, $iILRy.isPlainObject)(input)) return false;
    try {
        const name = Object.getPrototypeOf(input).constructor.name;
        return !name || name === 'Object';
    } catch (e) {
        return true;
    }
}
/**
 * Ensure that something is an object.
 *
 * Turns `undefined` and `null` into `String`s and all other primitives into instances of their respective wrapper
 * classes (String, Boolean, Number, etc.). Acts as the identity function on non-primitives.
 *
 * @param wat The subject of the objectification
 * @returns A version of `wat` which can safely be used with `Object` class methods
 */ function $b6bffb2757114e28$export$92b78acdbe066b6b(wat) {
    let objectified;
    switch(true){
        case wat === undefined || wat === null:
            objectified = new String(wat);
            break;
        // Though symbols and bigints do have wrapper classes (`Symbol` and `BigInt`, respectively), for whatever reason
        // those classes don't have constructors which can be used with the `new` keyword. We therefore need to cast each as
        // an object in order to wrap it.
        case typeof wat === 'symbol' || typeof wat === 'bigint':
            objectified = Object(wat);
            break;
        // this will catch the remaining primitives: `String`, `Number`, and `Boolean`
        case (0, $iILRy.isPrimitive)(wat):
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            objectified = new wat.constructor(wat);
            break;
        // by process of elimination, at this point we know that `wat` must already be an object
        default:
            objectified = wat;
            break;
    }
    return objectified;
}

});
parcelRegister("fitR1", function(module, exports) {

$parcel$export(module.exports, "htmlTreeAsString", () => $b22fb1e4caddd4ea$export$5647df6b7814ac86);

var $iILRy = parcelRequire("iILRy");

var $7cDym = parcelRequire("7cDym");
// eslint-disable-next-line deprecation/deprecation
const $b22fb1e4caddd4ea$var$WINDOW = (0, $7cDym.getGlobalObject)();
const $b22fb1e4caddd4ea$var$DEFAULT_MAX_STRING_LENGTH = 80;
/**
 * Given a child DOM element, returns a query-selector statement describing that
 * and its ancestors
 * e.g. [HTMLElement] => body > div > input#foo.btn[name=baz]
 * @returns generated DOM path
 */ function $b22fb1e4caddd4ea$export$5647df6b7814ac86(elem, options = {}) {
    if (!elem) return '<unknown>';
    // try/catch both:
    // - accessing event.target (see getsentry/raven-js#838, #768)
    // - `htmlTreeAsString` because it's complex, and just accessing the DOM incorrectly
    // - can throw an exception in some circumstances.
    try {
        let currentElem = elem;
        const MAX_TRAVERSE_HEIGHT = 5;
        const out = [];
        let height = 0;
        let len = 0;
        const separator = ' > ';
        const sepLength = separator.length;
        let nextStr;
        const keyAttrs = Array.isArray(options) ? options : options.keyAttrs;
        const maxStringLength = !Array.isArray(options) && options.maxStringLength || $b22fb1e4caddd4ea$var$DEFAULT_MAX_STRING_LENGTH;
        while(currentElem && height++ < MAX_TRAVERSE_HEIGHT){
            nextStr = $b22fb1e4caddd4ea$var$_htmlElementAsString(currentElem, keyAttrs);
            // bail out if
            // - nextStr is the 'html' element
            // - the length of the string that would be created exceeds maxStringLength
            //   (ignore this limit if we are on the first iteration)
            if (nextStr === 'html' || height > 1 && len + out.length * sepLength + nextStr.length >= maxStringLength) break;
            out.push(nextStr);
            len += nextStr.length;
            currentElem = currentElem.parentNode;
        }
        return out.reverse().join(separator);
    } catch (_oO) {
        return '<unknown>';
    }
}
/**
 * Returns a simple, query-selector representation of a DOM element
 * e.g. [HTMLElement] => input#foo.btn[name=baz]
 * @returns generated DOM path
 */ function $b22fb1e4caddd4ea$var$_htmlElementAsString(el, keyAttrs) {
    const elem = el;
    const out = [];
    let className;
    let classes;
    let key;
    let attr;
    let i;
    if (!elem || !elem.tagName) return '';
    // @ts-expect-error WINDOW has HTMLElement
    if ($b22fb1e4caddd4ea$var$WINDOW.HTMLElement) {
        // If using the component name annotation plugin, this value may be available on the DOM node
        if (elem instanceof HTMLElement && elem.dataset && elem.dataset['sentryComponent']) return elem.dataset['sentryComponent'];
    }
    out.push(elem.tagName.toLowerCase());
    // Pairs of attribute keys defined in `serializeAttribute` and their values on element.
    const keyAttrPairs = keyAttrs && keyAttrs.length ? keyAttrs.filter((keyAttr)=>elem.getAttribute(keyAttr)).map((keyAttr)=>[
            keyAttr,
            elem.getAttribute(keyAttr)
        ]) : null;
    if (keyAttrPairs && keyAttrPairs.length) keyAttrPairs.forEach((keyAttrPair)=>{
        out.push(`[${keyAttrPair[0]}="${keyAttrPair[1]}"]`);
    });
    else {
        if (elem.id) out.push(`#${elem.id}`);
        // eslint-disable-next-line prefer-const
        className = elem.className;
        if (className && (0, $iILRy.isString)(className)) {
            classes = className.split(/\s+/);
            for(i = 0; i < classes.length; i++)out.push(`.${classes[i]}`);
        }
    }
    const allowedAttrs = [
        'aria-label',
        'type',
        'name',
        'title',
        'alt'
    ];
    for(i = 0; i < allowedAttrs.length; i++){
        key = allowedAttrs[i];
        attr = elem.getAttribute(key);
        if (attr) out.push(`[${key}="${attr}"]`);
    }
    return out.join('');
}
/**
 * A safe form of location.href
 */ function $b22fb1e4caddd4ea$export$1cfafeee2987818b() {
    try {
        return $b22fb1e4caddd4ea$var$WINDOW.document.location.href;
    } catch (oO) {
        return '';
    }
}
/**
 * Gets a DOM element by using document.querySelector.
 *
 * This wrapper will first check for the existance of the function before
 * actually calling it so that we don't have to take care of this check,
 * every time we want to access the DOM.
 *
 * Reason: DOM/querySelector is not available in all environments.
 *
 * We have to cast to any because utils can be consumed by a variety of environments,
 * and we don't want to break TS users. If you know what element will be selected by
 * `document.querySelector`, specify it as part of the generic call. For example,
 * `const element = getDomElement<Element>('selector');`
 *
 * @param selector the selector string passed on to document.querySelector
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $b22fb1e4caddd4ea$export$c660c1f3ab49225c(selector) {
    if ($b22fb1e4caddd4ea$var$WINDOW.document && $b22fb1e4caddd4ea$var$WINDOW.document.querySelector) return $b22fb1e4caddd4ea$var$WINDOW.document.querySelector(selector);
    return null;
}
/**
 * Given a DOM element, traverses up the tree until it finds the first ancestor node
 * that has the `data-sentry-component` attribute. This attribute is added at build-time
 * by projects that have the component name annotation plugin installed.
 *
 * @returns a string representation of the component for the provided DOM element, or `null` if not found
 */ function $b22fb1e4caddd4ea$export$26727cfcc4d7e0fc(elem) {
    // @ts-expect-error WINDOW has HTMLElement
    if (!$b22fb1e4caddd4ea$var$WINDOW.HTMLElement) return null;
    let currentElem = elem;
    const MAX_TRAVERSE_HEIGHT = 5;
    for(let i = 0; i < MAX_TRAVERSE_HEIGHT; i++){
        if (!currentElem) return null;
        if (currentElem instanceof HTMLElement && currentElem.dataset['sentryComponent']) return currentElem.dataset['sentryComponent'];
        currentElem = currentElem.parentNode;
    }
    return null;
}

});

parcelRegister("Reevt", function(module, exports) {

$parcel$export(module.exports, "truncate", () => $09fffdb97f1e8b16$export$6a506b36fdea397d);
$parcel$export(module.exports, "snipLine", () => $09fffdb97f1e8b16$export$4215662d762d6f9d);
$parcel$export(module.exports, "safeJoin", () => $09fffdb97f1e8b16$export$465e9d514283d4fd);

var $iILRy = parcelRequire("iILRy");
/**
 * Truncates given string to the maximum characters count
 *
 * @param str An object that contains serializable values
 * @param max Maximum number of characters in truncated string (0 = unlimited)
 * @returns string Encoded
 */ function $09fffdb97f1e8b16$export$6a506b36fdea397d(str, max = 0) {
    if (typeof str !== 'string' || max === 0) return str;
    return str.length <= max ? str : `${str.slice(0, max)}...`;
}
/**
 * This is basically just `trim_line` from
 * https://github.com/getsentry/sentry/blob/master/src/sentry/lang/javascript/processor.py#L67
 *
 * @param str An object that contains serializable values
 * @param max Maximum number of characters in truncated string
 * @returns string Encoded
 */ function $09fffdb97f1e8b16$export$4215662d762d6f9d(line, colno) {
    let newLine = line;
    const lineLength = newLine.length;
    if (lineLength <= 150) return newLine;
    if (colno > lineLength) // eslint-disable-next-line no-param-reassign
    colno = lineLength;
    let start = Math.max(colno - 60, 0);
    if (start < 5) start = 0;
    let end = Math.min(start + 140, lineLength);
    if (end > lineLength - 5) end = lineLength;
    if (end === lineLength) start = Math.max(end - 140, 0);
    newLine = newLine.slice(start, end);
    if (start > 0) newLine = `'{snip} ${newLine}`;
    if (end < lineLength) newLine += ' {snip}';
    return newLine;
}
/**
 * Join values in array
 * @param input array of values to be joined together
 * @param delimiter string to be placed in-between values
 * @returns Joined values
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $09fffdb97f1e8b16$export$465e9d514283d4fd(input, delimiter) {
    if (!Array.isArray(input)) return '';
    const output = [];
    // eslint-disable-next-line @typescript-eslint/prefer-for-of
    for(let i = 0; i < input.length; i++){
        const value = input[i];
        try {
            // This is a hack to fix a Vue3-specific bug that causes an infinite loop of
            // console warnings. This happens when a Vue template is rendered with
            // an undeclared variable, which we try to stringify, ultimately causing
            // Vue to issue another warning which repeats indefinitely.
            // see: https://github.com/getsentry/sentry-javascript/pull/8981
            if ((0, $iILRy.isVueViewModel)(value)) output.push('[VueViewModel]');
            else output.push(String(value));
        } catch (e) {
            output.push('[value cannot be serialized]');
        }
    }
    return output.join(delimiter);
}
/**
 * Checks if the given value matches a regex or string
 *
 * @param value The string to test
 * @param pattern Either a regex or a string against which `value` will be matched
 * @param requireExactStringMatch If true, `value` must match `pattern` exactly. If false, `value` will match
 * `pattern` if it contains `pattern`. Only applies to string-type patterns.
 */ function $09fffdb97f1e8b16$export$cdded5b28a5f8c6d(value, pattern, requireExactStringMatch = false) {
    if (!(0, $iILRy.isString)(value)) return false;
    if ((0, $iILRy.isRegExp)(pattern)) return pattern.test(value);
    if ((0, $iILRy.isString)(pattern)) return requireExactStringMatch ? value === pattern : value.includes(pattern);
    return false;
}
/**
 * Test the given string against an array of strings and regexes. By default, string matching is done on a
 * substring-inclusion basis rather than a strict equality basis
 *
 * @param testString The string to test
 * @param patterns The patterns against which to test the string
 * @param requireExactStringMatch If true, `testString` must match one of the given string patterns exactly in order to
 * count. If false, `testString` will match a string pattern if it contains that pattern.
 * @returns
 */ function $09fffdb97f1e8b16$export$a7a5ec66062ea5d(testString, patterns = [], requireExactStringMatch = false) {
    return patterns.some((pattern)=>$09fffdb97f1e8b16$export$cdded5b28a5f8c6d(testString, pattern, requireExactStringMatch));
}

});



parcelRegister("kxRA4", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_ENVIRONMENT", () => $03dc22e629eb4b6a$export$849dbeeeda01ae98);
const $03dc22e629eb4b6a$export$849dbeeeda01ae98 = 'production';

});

parcelRegister("eblj3", function(module, exports) {

$parcel$export(module.exports, "DEBUG_BUILD", () => $a5329ec29b88335a$export$16a28057038b10ef);
/**
 * This serves as a build time flag that will be true by default, but false in non-debug builds or if users replace `__SENTRY_DEBUG__` in their generated code.
 *
 * ATTENTION: This constant must never cross package boundaries (i.e. be exported) to guarantee that it can be used for tree shaking.
 */ const $a5329ec29b88335a$export$16a28057038b10ef = typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__;

});

parcelRegister("5x0VR", function(module, exports) {

$parcel$export(module.exports, "getCurrentHub", () => $4070c1ec13a9a49f$export$a07cdf6544bbd7c);
$parcel$export(module.exports, "getIsolationScope", () => $4070c1ec13a9a49f$export$68f3af03034c9e90);
$parcel$export(module.exports, "runWithAsyncContext", () => $4070c1ec13a9a49f$export$70d775fb1f267027);

var $dcNCf = parcelRequire("dcNCf");
var $3vU5t = parcelRequire("3vU5t");
var $7cDym = parcelRequire("7cDym");
var $iILRy = parcelRequire("iILRy");
var $dcmwb = parcelRequire("dcmwb");

var $kxRA4 = parcelRequire("kxRA4");

var $eblj3 = parcelRequire("eblj3");

var $1EIrE = parcelRequire("1EIrE");

var $e8qIc = parcelRequire("e8qIc");

var $4COab = parcelRequire("4COab");
/**
 * API compatibility version of this hub.
 *
 * WARNING: This number should only be increased when the global interface
 * changes and new methods are introduced.
 *
 * @hidden
 */ const $4070c1ec13a9a49f$export$24a86ef7798177e4 = parseFloat((0, $4COab.SDK_VERSION));
/**
 * Default maximum number of breadcrumbs added to an event. Can be overwritten
 * with {@link Options.maxBreadcrumbs}.
 */ const $4070c1ec13a9a49f$var$DEFAULT_BREADCRUMBS = 100;
/**
 * @deprecated The `Hub` class will be removed in version 8 of the SDK in favour of `Scope` and `Client` objects.
 *
 * If you previously used the `Hub` class directly, replace it with `Scope` and `Client` objects. More information:
 * - [Multiple Sentry Instances](https://docs.sentry.io/platforms/javascript/best-practices/multiple-sentry-instances/)
 * - [Browser Extensions](https://docs.sentry.io/platforms/javascript/best-practices/browser-extensions/)
 *
 * Some of our APIs are typed with the Hub class instead of the interface (e.g. `getCurrentHub`). Most of them are deprecated
 * themselves and will also be removed in version 8. More information:
 * - [Migration Guide](https://github.com/getsentry/sentry-javascript/blob/develop/MIGRATION.md#deprecate-hub)
 */ // eslint-disable-next-line deprecation/deprecation
class $4070c1ec13a9a49f$export$8c41bb232f1008b1 {
    /** Is a {@link Layer}[] containing the client and scope */ /** Contains the last event id of a captured event.  */ /**
   * Creates a new instance of the hub, will push one {@link Layer} into the
   * internal stack on creation.
   *
   * @param client bound to the hub.
   * @param scope bound to the hub.
   * @param version number, higher number means higher priority.
   *
   * @deprecated Instantiation of Hub objects is deprecated and the constructor will be removed in version 8 of the SDK.
   *
   * If you are currently using the Hub for multi-client use like so:
   *
   * ```
   * // OLD
   * const hub = new Hub();
   * hub.bindClient(client);
   * makeMain(hub)
   * ```
   *
   * instead initialize the client as follows:
   *
   * ```
   * // NEW
   * Sentry.withIsolationScope(() => {
   *    Sentry.setCurrentClient(client);
   *    client.init();
   * });
   * ```
   *
   * If you are using the Hub to capture events like so:
   *
   * ```
   * // OLD
   * const client = new Client();
   * const hub = new Hub(client);
   * hub.captureException()
   * ```
   *
   * instead capture isolated events as follows:
   *
   * ```
   * // NEW
   * const client = new Client();
   * const scope = new Scope();
   * scope.setClient(client);
   * scope.captureException();
   * ```
   */ constructor(client, scope, isolationScope, _version = $4070c1ec13a9a49f$export$24a86ef7798177e4){
        this._version = _version;
        let assignedScope;
        if (!scope) {
            assignedScope = new (0, $1EIrE.Scope)();
            assignedScope.setClient(client);
        } else assignedScope = scope;
        let assignedIsolationScope;
        if (!isolationScope) {
            assignedIsolationScope = new (0, $1EIrE.Scope)();
            assignedIsolationScope.setClient(client);
        } else assignedIsolationScope = isolationScope;
        this._stack = [
            {
                scope: assignedScope
            }
        ];
        if (client) // eslint-disable-next-line deprecation/deprecation
        this.bindClient(client);
        this._isolationScope = assignedIsolationScope;
    }
    /**
   * Checks if this hub's version is older than the given version.
   *
   * @param version A version number to compare to.
   * @return True if the given version is newer; otherwise false.
   *
   * @deprecated This will be removed in v8.
   */ isOlderThan(version) {
        return this._version < version;
    }
    /**
   * This binds the given client to the current scope.
   * @param client An SDK client (client) instance.
   *
   * @deprecated Use `initAndBind()` directly, or `setCurrentClient()` and/or `client.init()` instead.
   */ bindClient(client) {
        // eslint-disable-next-line deprecation/deprecation
        const top = this.getStackTop();
        top.client = client;
        top.scope.setClient(client);
        // eslint-disable-next-line deprecation/deprecation
        if (client && client.setupIntegrations) // eslint-disable-next-line deprecation/deprecation
        client.setupIntegrations();
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `withScope` instead.
   */ pushScope() {
        // We want to clone the content of prev scope
        // eslint-disable-next-line deprecation/deprecation
        const scope = this.getScope().clone();
        // eslint-disable-next-line deprecation/deprecation
        this.getStack().push({
            // eslint-disable-next-line deprecation/deprecation
            client: this.getClient(),
            scope: scope
        });
        return scope;
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `withScope` instead.
   */ popScope() {
        // eslint-disable-next-line deprecation/deprecation
        if (this.getStack().length <= 1) return false;
        // eslint-disable-next-line deprecation/deprecation
        return !!this.getStack().pop();
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `Sentry.withScope()` instead.
   */ withScope(callback) {
        // eslint-disable-next-line deprecation/deprecation
        const scope = this.pushScope();
        let maybePromiseResult;
        try {
            maybePromiseResult = callback(scope);
        } catch (e) {
            // eslint-disable-next-line deprecation/deprecation
            this.popScope();
            throw e;
        }
        if ((0, $iILRy.isThenable)(maybePromiseResult)) // @ts-expect-error - isThenable returns the wrong type
        return maybePromiseResult.then((res)=>{
            // eslint-disable-next-line deprecation/deprecation
            this.popScope();
            return res;
        }, (e)=>{
            // eslint-disable-next-line deprecation/deprecation
            this.popScope();
            throw e;
        });
        // eslint-disable-next-line deprecation/deprecation
        this.popScope();
        return maybePromiseResult;
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `Sentry.getClient()` instead.
   */ getClient() {
        // eslint-disable-next-line deprecation/deprecation
        return this.getStackTop().client;
    }
    /**
   * Returns the scope of the top stack.
   *
   * @deprecated Use `Sentry.getCurrentScope()` instead.
   */ getScope() {
        // eslint-disable-next-line deprecation/deprecation
        return this.getStackTop().scope;
    }
    /**
   * @deprecated Use `Sentry.getIsolationScope()` instead.
   */ getIsolationScope() {
        return this._isolationScope;
    }
    /**
   * Returns the scope stack for domains or the process.
   * @deprecated This will be removed in v8.
   */ getStack() {
        return this._stack;
    }
    /**
   * Returns the topmost scope layer in the order domain > local > process.
   * @deprecated This will be removed in v8.
   */ getStackTop() {
        return this._stack[this._stack.length - 1];
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `Sentry.captureException()` instead.
   */ captureException(exception, hint) {
        const eventId = this._lastEventId = hint && hint.event_id ? hint.event_id : (0, $dcmwb.uuid4)();
        const syntheticException = new Error('Sentry syntheticException');
        // eslint-disable-next-line deprecation/deprecation
        this.getScope().captureException(exception, {
            originalException: exception,
            syntheticException: syntheticException,
            ...hint,
            event_id: eventId
        });
        return eventId;
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use  `Sentry.captureMessage()` instead.
   */ captureMessage(message, // eslint-disable-next-line deprecation/deprecation
    level, hint) {
        const eventId = this._lastEventId = hint && hint.event_id ? hint.event_id : (0, $dcmwb.uuid4)();
        const syntheticException = new Error(message);
        // eslint-disable-next-line deprecation/deprecation
        this.getScope().captureMessage(message, level, {
            originalException: message,
            syntheticException: syntheticException,
            ...hint,
            event_id: eventId
        });
        return eventId;
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `Sentry.captureEvent()` instead.
   */ captureEvent(event, hint) {
        const eventId = hint && hint.event_id ? hint.event_id : (0, $dcmwb.uuid4)();
        if (!event.type) this._lastEventId = eventId;
        // eslint-disable-next-line deprecation/deprecation
        this.getScope().captureEvent(event, {
            ...hint,
            event_id: eventId
        });
        return eventId;
    }
    /**
   * @inheritDoc
   *
   * @deprecated This will be removed in v8.
   */ lastEventId() {
        return this._lastEventId;
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `Sentry.addBreadcrumb()` instead.
   */ addBreadcrumb(breadcrumb, hint) {
        // eslint-disable-next-line deprecation/deprecation
        const { scope: scope, client: client } = this.getStackTop();
        if (!client) return;
        const { beforeBreadcrumb: beforeBreadcrumb = null, maxBreadcrumbs: maxBreadcrumbs = $4070c1ec13a9a49f$var$DEFAULT_BREADCRUMBS } = client.getOptions && client.getOptions() || {};
        if (maxBreadcrumbs <= 0) return;
        const timestamp = (0, $3vU5t.dateTimestampInSeconds)();
        const mergedBreadcrumb = {
            timestamp: timestamp,
            ...breadcrumb
        };
        const finalBreadcrumb = beforeBreadcrumb ? (0, $dcNCf.consoleSandbox)(()=>beforeBreadcrumb(mergedBreadcrumb, hint)) : mergedBreadcrumb;
        if (finalBreadcrumb === null) return;
        if (client.emit) client.emit('beforeAddBreadcrumb', finalBreadcrumb, hint);
        // TODO(v8): I know this comment doesn't make much sense because the hub will be deprecated but I still wanted to
        // write it down. In theory, we would have to add the breadcrumbs to the isolation scope here, however, that would
        // duplicate all of the breadcrumbs. There was the possibility of adding breadcrumbs to both, the isolation scope
        // and the normal scope, and deduplicating it down the line in the event processing pipeline. However, that would
        // have been very fragile, because the breadcrumb objects would have needed to keep their identity all throughout
        // the event processing pipeline.
        // In the new implementation, the top level `Sentry.addBreadcrumb()` should ONLY write to the isolation scope.
        scope.addBreadcrumb(finalBreadcrumb, maxBreadcrumbs);
    }
    /**
   * @inheritDoc
   * @deprecated Use `Sentry.setUser()` instead.
   */ setUser(user) {
        // TODO(v8): The top level `Sentry.setUser()` function should write ONLY to the isolation scope.
        // eslint-disable-next-line deprecation/deprecation
        this.getScope().setUser(user);
        // eslint-disable-next-line deprecation/deprecation
        this.getIsolationScope().setUser(user);
    }
    /**
   * @inheritDoc
   * @deprecated Use `Sentry.setTags()` instead.
   */ setTags(tags) {
        // TODO(v8): The top level `Sentry.setTags()` function should write ONLY to the isolation scope.
        // eslint-disable-next-line deprecation/deprecation
        this.getScope().setTags(tags);
        // eslint-disable-next-line deprecation/deprecation
        this.getIsolationScope().setTags(tags);
    }
    /**
   * @inheritDoc
   * @deprecated Use `Sentry.setExtras()` instead.
   */ setExtras(extras) {
        // TODO(v8): The top level `Sentry.setExtras()` function should write ONLY to the isolation scope.
        // eslint-disable-next-line deprecation/deprecation
        this.getScope().setExtras(extras);
        // eslint-disable-next-line deprecation/deprecation
        this.getIsolationScope().setExtras(extras);
    }
    /**
   * @inheritDoc
   * @deprecated Use `Sentry.setTag()` instead.
   */ setTag(key, value) {
        // TODO(v8): The top level `Sentry.setTag()` function should write ONLY to the isolation scope.
        // eslint-disable-next-line deprecation/deprecation
        this.getScope().setTag(key, value);
        // eslint-disable-next-line deprecation/deprecation
        this.getIsolationScope().setTag(key, value);
    }
    /**
   * @inheritDoc
   * @deprecated Use `Sentry.setExtra()` instead.
   */ setExtra(key, extra) {
        // TODO(v8): The top level `Sentry.setExtra()` function should write ONLY to the isolation scope.
        // eslint-disable-next-line deprecation/deprecation
        this.getScope().setExtra(key, extra);
        // eslint-disable-next-line deprecation/deprecation
        this.getIsolationScope().setExtra(key, extra);
    }
    /**
   * @inheritDoc
   * @deprecated Use `Sentry.setContext()` instead.
   */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    setContext(name, context) {
        // TODO(v8): The top level `Sentry.setContext()` function should write ONLY to the isolation scope.
        // eslint-disable-next-line deprecation/deprecation
        this.getScope().setContext(name, context);
        // eslint-disable-next-line deprecation/deprecation
        this.getIsolationScope().setContext(name, context);
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `getScope()` directly.
   */ configureScope(callback) {
        // eslint-disable-next-line deprecation/deprecation
        const { scope: scope, client: client } = this.getStackTop();
        if (client) callback(scope);
    }
    /**
   * @inheritDoc
   */ // eslint-disable-next-line deprecation/deprecation
    run(callback) {
        // eslint-disable-next-line deprecation/deprecation
        const oldHub = $4070c1ec13a9a49f$export$4188a14ad302d1bc(this);
        try {
            callback(this);
        } finally{
            // eslint-disable-next-line deprecation/deprecation
            $4070c1ec13a9a49f$export$4188a14ad302d1bc(oldHub);
        }
    }
    /**
   * @inheritDoc
   * @deprecated Use `Sentry.getClient().getIntegrationByName()` instead.
   */ getIntegration(integration) {
        // eslint-disable-next-line deprecation/deprecation
        const client = this.getClient();
        if (!client) return null;
        try {
            // eslint-disable-next-line deprecation/deprecation
            return client.getIntegration(integration);
        } catch (_oO) {
            (0, $eblj3.DEBUG_BUILD) && (0, $dcNCf.logger).warn(`Cannot retrieve integration ${integration.id} from the current Hub`);
            return null;
        }
    }
    /**
   * Starts a new `Transaction` and returns it. This is the entry point to manual tracing instrumentation.
   *
   * A tree structure can be built by adding child spans to the transaction, and child spans to other spans. To start a
   * new child span within the transaction or any span, call the respective `.startChild()` method.
   *
   * Every child span must be finished before the transaction is finished, otherwise the unfinished spans are discarded.
   *
   * The transaction must be finished with a call to its `.end()` method, at which point the transaction with all its
   * finished child spans will be sent to Sentry.
   *
   * @param context Properties of the new `Transaction`.
   * @param customSamplingContext Information given to the transaction sampling function (along with context-dependent
   * default values). See {@link Options.tracesSampler}.
   *
   * @returns The transaction which was just started
   *
   * @deprecated Use `startSpan()`, `startSpanManual()` or `startInactiveSpan()` instead.
   */ startTransaction(context, customSamplingContext) {
        const result = this._callExtensionMethod('startTransaction', context, customSamplingContext);
        if ((0, $eblj3.DEBUG_BUILD) && !result) {
            // eslint-disable-next-line deprecation/deprecation
            const client = this.getClient();
            if (!client) (0, $dcNCf.logger).warn("Tracing extension 'startTransaction' is missing. You should 'init' the SDK before calling 'startTransaction'");
            else (0, $dcNCf.logger).warn(`Tracing extension 'startTransaction' has not been added. Call 'addTracingExtensions' before calling 'init':
Sentry.addTracingExtensions();
Sentry.init({...});
`);
        }
        return result;
    }
    /**
   * @inheritDoc
   * @deprecated Use `spanToTraceHeader()` instead.
   */ traceHeaders() {
        return this._callExtensionMethod('traceHeaders');
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use top level `captureSession` instead.
   */ captureSession(endSession = false) {
        // both send the update and pull the session from the scope
        if (endSession) // eslint-disable-next-line deprecation/deprecation
        return this.endSession();
        // only send the update
        this._sendSessionUpdate();
    }
    /**
   * @inheritDoc
   * @deprecated Use top level `endSession` instead.
   */ endSession() {
        // eslint-disable-next-line deprecation/deprecation
        const layer = this.getStackTop();
        const scope = layer.scope;
        const session = scope.getSession();
        if (session) (0, $e8qIc.closeSession)(session);
        this._sendSessionUpdate();
        // the session is over; take it off of the scope
        scope.setSession();
    }
    /**
   * @inheritDoc
   * @deprecated Use top level `startSession` instead.
   */ startSession(context) {
        // eslint-disable-next-line deprecation/deprecation
        const { scope: scope, client: client } = this.getStackTop();
        const { release: release, environment: environment = (0, $kxRA4.DEFAULT_ENVIRONMENT) } = client && client.getOptions() || {};
        // Will fetch userAgent if called from browser sdk
        const { userAgent: userAgent } = (0, $7cDym.GLOBAL_OBJ).navigator || {};
        const session = (0, $e8qIc.makeSession)({
            release: release,
            environment: environment,
            user: scope.getUser(),
            ...userAgent && {
                userAgent: userAgent
            },
            ...context
        });
        // End existing session if there's one
        const currentSession = scope.getSession && scope.getSession();
        if (currentSession && currentSession.status === 'ok') (0, $e8qIc.updateSession)(currentSession, {
            status: 'exited'
        });
        // eslint-disable-next-line deprecation/deprecation
        this.endSession();
        // Afterwards we set the new session on the scope
        scope.setSession(session);
        return session;
    }
    /**
   * Returns if default PII should be sent to Sentry and propagated in ourgoing requests
   * when Tracing is used.
   *
   * @deprecated Use top-level `getClient().getOptions().sendDefaultPii` instead. This function
   * only unnecessarily increased API surface but only wrapped accessing the option.
   */ shouldSendDefaultPii() {
        // eslint-disable-next-line deprecation/deprecation
        const client = this.getClient();
        const options = client && client.getOptions();
        return Boolean(options && options.sendDefaultPii);
    }
    /**
   * Sends the current Session on the scope
   */ _sendSessionUpdate() {
        // eslint-disable-next-line deprecation/deprecation
        const { scope: scope, client: client } = this.getStackTop();
        const session = scope.getSession();
        if (session && client && client.captureSession) client.captureSession(session);
    }
    /**
   * Calls global extension method and binding current instance to the function call
   */ // @ts-expect-error Function lacks ending return statement and return type does not include 'undefined'. ts(2366)
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    _callExtensionMethod(method, ...args) {
        const carrier = $4070c1ec13a9a49f$export$19eade501500c6c1();
        const sentry = carrier.__SENTRY__;
        if (sentry && sentry.extensions && typeof sentry.extensions[method] === 'function') return sentry.extensions[method].apply(this, args);
        (0, $eblj3.DEBUG_BUILD) && (0, $dcNCf.logger).warn(`Extension method ${method} couldn't be found, doing nothing.`);
    }
}
/**
 * Returns the global shim registry.
 *
 * FIXME: This function is problematic, because despite always returning a valid Carrier,
 * it has an optional `__SENTRY__` property, which then in turn requires us to always perform an unnecessary check
 * at the call-site. We always access the carrier through this function, so we can guarantee that `__SENTRY__` is there.
 **/ function $4070c1ec13a9a49f$export$19eade501500c6c1() {
    (0, $7cDym.GLOBAL_OBJ).__SENTRY__ = (0, $7cDym.GLOBAL_OBJ).__SENTRY__ || {
        extensions: {},
        hub: undefined
    };
    return 0, $7cDym.GLOBAL_OBJ;
}
/**
 * Replaces the current main hub with the passed one on the global object
 *
 * @returns The old replaced hub
 *
 * @deprecated Use `setCurrentClient()` instead.
 */ // eslint-disable-next-line deprecation/deprecation
function $4070c1ec13a9a49f$export$4188a14ad302d1bc(hub) {
    const registry = $4070c1ec13a9a49f$export$19eade501500c6c1();
    const oldHub = $4070c1ec13a9a49f$export$bfa8a924a84a76b7(registry);
    $4070c1ec13a9a49f$export$849f05434e95d2f2(registry, hub);
    return oldHub;
}
/**
 * Returns the default hub instance.
 *
 * If a hub is already registered in the global carrier but this module
 * contains a more recent version, it replaces the registered version.
 * Otherwise, the currently registered hub will be returned.
 *
 * @deprecated Use the respective replacement method directly instead.
 */ // eslint-disable-next-line deprecation/deprecation
function $4070c1ec13a9a49f$export$a07cdf6544bbd7c() {
    // Get main carrier (global for every environment)
    const registry = $4070c1ec13a9a49f$export$19eade501500c6c1();
    if (registry.__SENTRY__ && registry.__SENTRY__.acs) {
        const hub = registry.__SENTRY__.acs.getCurrentHub();
        if (hub) return hub;
    }
    // Return hub that lives on a global object
    return $4070c1ec13a9a49f$var$getGlobalHub(registry);
}
/**
 * Get the currently active isolation scope.
 * The isolation scope is active for the current exection context,
 * meaning that it will remain stable for the same Hub.
 */ function $4070c1ec13a9a49f$export$68f3af03034c9e90() {
    // eslint-disable-next-line deprecation/deprecation
    return $4070c1ec13a9a49f$export$a07cdf6544bbd7c().getIsolationScope();
}
// eslint-disable-next-line deprecation/deprecation
function $4070c1ec13a9a49f$var$getGlobalHub(registry = $4070c1ec13a9a49f$export$19eade501500c6c1()) {
    // If there's no hub, or its an old API, assign a new one
    if (!$4070c1ec13a9a49f$var$hasHubOnCarrier(registry) || // eslint-disable-next-line deprecation/deprecation
    $4070c1ec13a9a49f$export$bfa8a924a84a76b7(registry).isOlderThan($4070c1ec13a9a49f$export$24a86ef7798177e4)) // eslint-disable-next-line deprecation/deprecation
    $4070c1ec13a9a49f$export$849f05434e95d2f2(registry, new $4070c1ec13a9a49f$export$8c41bb232f1008b1());
    // Return hub that lives on a global object
    return $4070c1ec13a9a49f$export$bfa8a924a84a76b7(registry);
}
/**
 * @private Private API with no semver guarantees!
 *
 * If the carrier does not contain a hub, a new hub is created with the global hub client and scope.
 */ // eslint-disable-next-line deprecation/deprecation
function $4070c1ec13a9a49f$export$236689a79f5aa020(carrier, parent = $4070c1ec13a9a49f$var$getGlobalHub()) {
    // If there's no hub on current domain, or it's an old API, assign a new one
    if (!$4070c1ec13a9a49f$var$hasHubOnCarrier(carrier) || // eslint-disable-next-line deprecation/deprecation
    $4070c1ec13a9a49f$export$bfa8a924a84a76b7(carrier).isOlderThan($4070c1ec13a9a49f$export$24a86ef7798177e4)) {
        // eslint-disable-next-line deprecation/deprecation
        const client = parent.getClient();
        // eslint-disable-next-line deprecation/deprecation
        const scope = parent.getScope();
        // eslint-disable-next-line deprecation/deprecation
        const isolationScope = parent.getIsolationScope();
        // eslint-disable-next-line deprecation/deprecation
        $4070c1ec13a9a49f$export$849f05434e95d2f2(carrier, new $4070c1ec13a9a49f$export$8c41bb232f1008b1(client, scope.clone(), isolationScope.clone()));
    }
}
/**
 * @private Private API with no semver guarantees!
 *
 * Sets the global async context strategy
 */ function $4070c1ec13a9a49f$export$774ae0e6b6e444ca(strategy) {
    // Get main carrier (global for every environment)
    const registry = $4070c1ec13a9a49f$export$19eade501500c6c1();
    registry.__SENTRY__ = registry.__SENTRY__ || {};
    registry.__SENTRY__.acs = strategy;
}
/**
 * Runs the supplied callback in its own async context. Async Context strategies are defined per SDK.
 *
 * @param callback The callback to run in its own async context
 * @param options Options to pass to the async context strategy
 * @returns The result of the callback
 */ function $4070c1ec13a9a49f$export$70d775fb1f267027(callback, options = {}) {
    const registry = $4070c1ec13a9a49f$export$19eade501500c6c1();
    if (registry.__SENTRY__ && registry.__SENTRY__.acs) return registry.__SENTRY__.acs.runWithAsyncContext(callback, options);
    // if there was no strategy, fallback to just calling the callback
    return callback();
}
/**
 * This will tell whether a carrier has a hub on it or not
 * @param carrier object
 */ function $4070c1ec13a9a49f$var$hasHubOnCarrier(carrier) {
    return !!(carrier && carrier.__SENTRY__ && carrier.__SENTRY__.hub);
}
/**
 * This will create a new {@link Hub} and add to the passed object on
 * __SENTRY__.hub.
 * @param carrier object
 * @hidden
 */ // eslint-disable-next-line deprecation/deprecation
function $4070c1ec13a9a49f$export$bfa8a924a84a76b7(carrier) {
    // eslint-disable-next-line deprecation/deprecation
    return (0, $7cDym.getGlobalSingleton)('hub', ()=>new $4070c1ec13a9a49f$export$8c41bb232f1008b1(), carrier);
}
/**
 * This will set passed {@link Hub} on the passed object's __SENTRY__.hub attribute
 * @param carrier object
 * @param hub Hub
 * @returns A boolean indicating success or failure
 */ // eslint-disable-next-line deprecation/deprecation
function $4070c1ec13a9a49f$export$849f05434e95d2f2(carrier, hub) {
    if (!carrier) return false;
    const __SENTRY__ = carrier.__SENTRY__ = carrier.__SENTRY__ || {};
    __SENTRY__.hub = hub;
    return true;
}

});
parcelRegister("1EIrE", function(module, exports) {

$parcel$export(module.exports, "Scope", () => $134c00b9fe831f67$export$775b6bb06e53a214);
$parcel$export(module.exports, "getGlobalScope", () => $134c00b9fe831f67$export$aa55d5ab8e05984f);

var $3vU5t = parcelRequire("3vU5t");
var $iILRy = parcelRequire("iILRy");
var $dcNCf = parcelRequire("dcNCf");
var $dcmwb = parcelRequire("dcmwb");

var $kB5Xz = parcelRequire("kB5Xz");

var $e8qIc = parcelRequire("e8qIc");

var $7i0oJ = parcelRequire("7i0oJ");
/**
 * Default value for maximum number of breadcrumbs added to an event.
 */ const $134c00b9fe831f67$var$DEFAULT_MAX_BREADCRUMBS = 100;
/**
 * The global scope is kept in this module.
 * When accessing this via `getGlobalScope()` we'll make sure to set one if none is currently present.
 */ let $134c00b9fe831f67$var$globalScope;
/**
 * Holds additional event information. {@link Scope.applyToEvent} will be
 * called by the client before an event will be sent.
 */ class $134c00b9fe831f67$export$775b6bb06e53a214 {
    /** Flag if notifying is happening. */ /** Callback for client to receive scope changes. */ /** Callback list that will be called after {@link applyToEvent}. */ /** Array of breadcrumbs. */ /** User */ /** Tags */ /** Extra */ /** Contexts */ /** Attachments */ /** Propagation Context for distributed tracing */ /**
   * A place to stash data which is needed at some point in the SDK's event processing pipeline but which shouldn't get
   * sent to Sentry
   */ /** Fingerprint */ /** Severity */ // eslint-disable-next-line deprecation/deprecation
    /**
   * Transaction Name
   */ /** Span */ /** Session */ /** Request Mode Session Status */ /** The client on this scope */ // NOTE: Any field which gets added here should get added not only to the constructor but also to the `clone` method.
    constructor(){
        this._notifyingListeners = false;
        this._scopeListeners = [];
        this._eventProcessors = [];
        this._breadcrumbs = [];
        this._attachments = [];
        this._user = {};
        this._tags = {};
        this._extra = {};
        this._contexts = {};
        this._sdkProcessingMetadata = {};
        this._propagationContext = $134c00b9fe831f67$var$generatePropagationContext();
    }
    /**
   * Inherit values from the parent scope.
   * @deprecated Use `scope.clone()` and `new Scope()` instead.
   */ static clone(scope) {
        return scope ? scope.clone() : new $134c00b9fe831f67$export$775b6bb06e53a214();
    }
    /**
   * Clone this scope instance.
   */ clone() {
        const newScope = new $134c00b9fe831f67$export$775b6bb06e53a214();
        newScope._breadcrumbs = [
            ...this._breadcrumbs
        ];
        newScope._tags = {
            ...this._tags
        };
        newScope._extra = {
            ...this._extra
        };
        newScope._contexts = {
            ...this._contexts
        };
        newScope._user = this._user;
        newScope._level = this._level;
        newScope._span = this._span;
        newScope._session = this._session;
        newScope._transactionName = this._transactionName;
        newScope._fingerprint = this._fingerprint;
        newScope._eventProcessors = [
            ...this._eventProcessors
        ];
        newScope._requestSession = this._requestSession;
        newScope._attachments = [
            ...this._attachments
        ];
        newScope._sdkProcessingMetadata = {
            ...this._sdkProcessingMetadata
        };
        newScope._propagationContext = {
            ...this._propagationContext
        };
        newScope._client = this._client;
        return newScope;
    }
    /** Update the client on the scope. */ setClient(client) {
        this._client = client;
    }
    /**
   * Get the client assigned to this scope.
   *
   * It is generally recommended to use the global function `Sentry.getClient()` instead, unless you know what you are doing.
   */ getClient() {
        return this._client;
    }
    /**
   * Add internal on change listener. Used for sub SDKs that need to store the scope.
   * @hidden
   */ addScopeListener(callback) {
        this._scopeListeners.push(callback);
    }
    /**
   * @inheritDoc
   */ addEventProcessor(callback) {
        this._eventProcessors.push(callback);
        return this;
    }
    /**
   * @inheritDoc
   */ setUser(user) {
        // If null is passed we want to unset everything, but still define keys,
        // so that later down in the pipeline any existing values are cleared.
        this._user = user || {
            email: undefined,
            id: undefined,
            ip_address: undefined,
            segment: undefined,
            username: undefined
        };
        if (this._session) (0, $e8qIc.updateSession)(this._session, {
            user: user
        });
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ getUser() {
        return this._user;
    }
    /**
   * @inheritDoc
   */ getRequestSession() {
        return this._requestSession;
    }
    /**
   * @inheritDoc
   */ setRequestSession(requestSession) {
        this._requestSession = requestSession;
        return this;
    }
    /**
   * @inheritDoc
   */ setTags(tags) {
        this._tags = {
            ...this._tags,
            ...tags
        };
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ setTag(key, value) {
        this._tags = {
            ...this._tags,
            [key]: value
        };
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ setExtras(extras) {
        this._extra = {
            ...this._extra,
            ...extras
        };
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ setExtra(key, extra) {
        this._extra = {
            ...this._extra,
            [key]: extra
        };
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ setFingerprint(fingerprint) {
        this._fingerprint = fingerprint;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ setLevel(// eslint-disable-next-line deprecation/deprecation
    level) {
        this._level = level;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Sets the transaction name on the scope for future events.
   */ setTransactionName(name) {
        this._transactionName = name;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ setContext(key, context) {
        if (context === null) // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
        delete this._contexts[key];
        else this._contexts[key] = context;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Sets the Span on the scope.
   * @param span Span
   * @deprecated Instead of setting a span on a scope, use `startSpan()`/`startSpanManual()` instead.
   */ setSpan(span) {
        this._span = span;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Returns the `Span` if there is one.
   * @deprecated Use `getActiveSpan()` instead.
   */ getSpan() {
        return this._span;
    }
    /**
   * Returns the `Transaction` attached to the scope (if there is one).
   * @deprecated You should not rely on the transaction, but just use `startSpan()` APIs instead.
   */ getTransaction() {
        // Often, this span (if it exists at all) will be a transaction, but it's not guaranteed to be. Regardless, it will
        // have a pointer to the currently-active transaction.
        const span = this._span;
        // Cannot replace with getRootSpan because getRootSpan returns a span, not a transaction
        // Also, this method will be removed anyway.
        // eslint-disable-next-line deprecation/deprecation
        return span && span.transaction;
    }
    /**
   * @inheritDoc
   */ setSession(session) {
        if (!session) delete this._session;
        else this._session = session;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ getSession() {
        return this._session;
    }
    /**
   * @inheritDoc
   */ update(captureContext) {
        if (!captureContext) return this;
        const scopeToMerge = typeof captureContext === 'function' ? captureContext(this) : captureContext;
        if (scopeToMerge instanceof $134c00b9fe831f67$export$775b6bb06e53a214) {
            const scopeData = scopeToMerge.getScopeData();
            this._tags = {
                ...this._tags,
                ...scopeData.tags
            };
            this._extra = {
                ...this._extra,
                ...scopeData.extra
            };
            this._contexts = {
                ...this._contexts,
                ...scopeData.contexts
            };
            if (scopeData.user && Object.keys(scopeData.user).length) this._user = scopeData.user;
            if (scopeData.level) this._level = scopeData.level;
            if (scopeData.fingerprint.length) this._fingerprint = scopeData.fingerprint;
            if (scopeToMerge.getRequestSession()) this._requestSession = scopeToMerge.getRequestSession();
            if (scopeData.propagationContext) this._propagationContext = scopeData.propagationContext;
        } else if ((0, $iILRy.isPlainObject)(scopeToMerge)) {
            const scopeContext = captureContext;
            this._tags = {
                ...this._tags,
                ...scopeContext.tags
            };
            this._extra = {
                ...this._extra,
                ...scopeContext.extra
            };
            this._contexts = {
                ...this._contexts,
                ...scopeContext.contexts
            };
            if (scopeContext.user) this._user = scopeContext.user;
            if (scopeContext.level) this._level = scopeContext.level;
            if (scopeContext.fingerprint) this._fingerprint = scopeContext.fingerprint;
            if (scopeContext.requestSession) this._requestSession = scopeContext.requestSession;
            if (scopeContext.propagationContext) this._propagationContext = scopeContext.propagationContext;
        }
        return this;
    }
    /**
   * @inheritDoc
   */ clear() {
        this._breadcrumbs = [];
        this._tags = {};
        this._extra = {};
        this._user = {};
        this._contexts = {};
        this._level = undefined;
        this._transactionName = undefined;
        this._fingerprint = undefined;
        this._requestSession = undefined;
        this._span = undefined;
        this._session = undefined;
        this._notifyScopeListeners();
        this._attachments = [];
        this._propagationContext = $134c00b9fe831f67$var$generatePropagationContext();
        return this;
    }
    /**
   * @inheritDoc
   */ addBreadcrumb(breadcrumb, maxBreadcrumbs) {
        const maxCrumbs = typeof maxBreadcrumbs === 'number' ? maxBreadcrumbs : $134c00b9fe831f67$var$DEFAULT_MAX_BREADCRUMBS;
        // No data has been changed, so don't notify scope listeners
        if (maxCrumbs <= 0) return this;
        const mergedBreadcrumb = {
            timestamp: (0, $3vU5t.dateTimestampInSeconds)(),
            ...breadcrumb
        };
        const breadcrumbs = this._breadcrumbs;
        breadcrumbs.push(mergedBreadcrumb);
        this._breadcrumbs = breadcrumbs.length > maxCrumbs ? breadcrumbs.slice(-maxCrumbs) : breadcrumbs;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ getLastBreadcrumb() {
        return this._breadcrumbs[this._breadcrumbs.length - 1];
    }
    /**
   * @inheritDoc
   */ clearBreadcrumbs() {
        this._breadcrumbs = [];
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ addAttachment(attachment) {
        this._attachments.push(attachment);
        return this;
    }
    /**
   * @inheritDoc
   * @deprecated Use `getScopeData()` instead.
   */ getAttachments() {
        const data = this.getScopeData();
        return data.attachments;
    }
    /**
   * @inheritDoc
   */ clearAttachments() {
        this._attachments = [];
        return this;
    }
    /** @inheritDoc */ getScopeData() {
        const { _breadcrumbs: _breadcrumbs, _attachments: _attachments, _contexts: _contexts, _tags: _tags, _extra: _extra, _user: _user, _level: _level, _fingerprint: _fingerprint, _eventProcessors: _eventProcessors, _propagationContext: _propagationContext, _sdkProcessingMetadata: _sdkProcessingMetadata, _transactionName: _transactionName, _span: _span } = this;
        return {
            breadcrumbs: _breadcrumbs,
            attachments: _attachments,
            contexts: _contexts,
            tags: _tags,
            extra: _extra,
            user: _user,
            level: _level,
            fingerprint: _fingerprint || [],
            eventProcessors: _eventProcessors,
            propagationContext: _propagationContext,
            sdkProcessingMetadata: _sdkProcessingMetadata,
            transactionName: _transactionName,
            span: _span
        };
    }
    /**
   * Applies data from the scope to the event and runs all event processors on it.
   *
   * @param event Event
   * @param hint Object containing additional information about the original exception, for use by the event processors.
   * @hidden
   * @deprecated Use `applyScopeDataToEvent()` directly
   */ applyToEvent(event, hint = {}, additionalEventProcessors = []) {
        (0, $7i0oJ.applyScopeDataToEvent)(event, this.getScopeData());
        // TODO (v8): Update this order to be: Global > Client > Scope
        const eventProcessors = [
            ...additionalEventProcessors,
            // eslint-disable-next-line deprecation/deprecation
            ...(0, $kB5Xz.getGlobalEventProcessors)(),
            ...this._eventProcessors
        ];
        return (0, $kB5Xz.notifyEventProcessors)(eventProcessors, event, hint);
    }
    /**
   * Add data which will be accessible during event processing but won't get sent to Sentry
   */ setSDKProcessingMetadata(newData) {
        this._sdkProcessingMetadata = {
            ...this._sdkProcessingMetadata,
            ...newData
        };
        return this;
    }
    /**
   * @inheritDoc
   */ setPropagationContext(context) {
        this._propagationContext = context;
        return this;
    }
    /**
   * @inheritDoc
   */ getPropagationContext() {
        return this._propagationContext;
    }
    /**
   * Capture an exception for this scope.
   *
   * @param exception The exception to capture.
   * @param hint Optinal additional data to attach to the Sentry event.
   * @returns the id of the captured Sentry event.
   */ captureException(exception, hint) {
        const eventId = hint && hint.event_id ? hint.event_id : (0, $dcmwb.uuid4)();
        if (!this._client) {
            (0, $dcNCf.logger).warn('No client configured on scope - will not capture exception!');
            return eventId;
        }
        const syntheticException = new Error('Sentry syntheticException');
        this._client.captureException(exception, {
            originalException: exception,
            syntheticException: syntheticException,
            ...hint,
            event_id: eventId
        }, this);
        return eventId;
    }
    /**
   * Capture a message for this scope.
   *
   * @param message The message to capture.
   * @param level An optional severity level to report the message with.
   * @param hint Optional additional data to attach to the Sentry event.
   * @returns the id of the captured message.
   */ captureMessage(message, level, hint) {
        const eventId = hint && hint.event_id ? hint.event_id : (0, $dcmwb.uuid4)();
        if (!this._client) {
            (0, $dcNCf.logger).warn('No client configured on scope - will not capture message!');
            return eventId;
        }
        const syntheticException = new Error(message);
        this._client.captureMessage(message, level, {
            originalException: message,
            syntheticException: syntheticException,
            ...hint,
            event_id: eventId
        }, this);
        return eventId;
    }
    /**
   * Captures a manually created event for this scope and sends it to Sentry.
   *
   * @param exception The event to capture.
   * @param hint Optional additional data to attach to the Sentry event.
   * @returns the id of the captured event.
   */ captureEvent(event, hint) {
        const eventId = hint && hint.event_id ? hint.event_id : (0, $dcmwb.uuid4)();
        if (!this._client) {
            (0, $dcNCf.logger).warn('No client configured on scope - will not capture event!');
            return eventId;
        }
        this._client.captureEvent(event, {
            ...hint,
            event_id: eventId
        }, this);
        return eventId;
    }
    /**
   * This will be called on every set call.
   */ _notifyScopeListeners() {
        // We need this check for this._notifyingListeners to be able to work on scope during updates
        // If this check is not here we'll produce endless recursion when something is done with the scope
        // during the callback.
        if (!this._notifyingListeners) {
            this._notifyingListeners = true;
            this._scopeListeners.forEach((callback)=>{
                callback(this);
            });
            this._notifyingListeners = false;
        }
    }
}
/**
 * Get the global scope.
 * This scope is applied to _all_ events.
 */ function $134c00b9fe831f67$export$aa55d5ab8e05984f() {
    if (!$134c00b9fe831f67$var$globalScope) $134c00b9fe831f67$var$globalScope = new $134c00b9fe831f67$export$775b6bb06e53a214();
    return $134c00b9fe831f67$var$globalScope;
}
/**
 * This is mainly needed for tests.
 * DO NOT USE this, as this is an internal API and subject to change.
 * @hidden
 */ function $134c00b9fe831f67$export$c83048efd17527d6(scope) {
    $134c00b9fe831f67$var$globalScope = scope;
}
function $134c00b9fe831f67$var$generatePropagationContext() {
    return {
        traceId: (0, $dcmwb.uuid4)(),
        spanId: (0, $dcmwb.uuid4)().substring(16)
    };
}

});
parcelRegister("kB5Xz", function(module, exports) {

$parcel$export(module.exports, "getGlobalEventProcessors", () => $efebe2d81c62873e$export$3c4238858b85e8ac);
$parcel$export(module.exports, "addGlobalEventProcessor", () => $efebe2d81c62873e$export$8e4e25f54d456511);
$parcel$export(module.exports, "notifyEventProcessors", () => $efebe2d81c62873e$export$bf2a096c3e883e79);

var $7cDym = parcelRequire("7cDym");
var $iILRy = parcelRequire("iILRy");
var $dcNCf = parcelRequire("dcNCf");
var $9wGca = parcelRequire("9wGca");

var $eblj3 = parcelRequire("eblj3");
/**
 * Returns the global event processors.
 * @deprecated Global event processors will be removed in v8.
 */ function $efebe2d81c62873e$export$3c4238858b85e8ac() {
    return (0, $7cDym.getGlobalSingleton)('globalEventProcessors', ()=>[]);
}
/**
 * Add a EventProcessor to be kept globally.
 * @deprecated Use `addEventProcessor` instead. Global event processors will be removed in v8.
 */ function $efebe2d81c62873e$export$8e4e25f54d456511(callback) {
    // eslint-disable-next-line deprecation/deprecation
    $efebe2d81c62873e$export$3c4238858b85e8ac().push(callback);
}
/**
 * Process an array of event processors, returning the processed event (or `null` if the event was dropped).
 */ function $efebe2d81c62873e$export$bf2a096c3e883e79(processors, event, hint, index = 0) {
    return new (0, $9wGca.SyncPromise)((resolve, reject)=>{
        const processor = processors[index];
        if (event === null || typeof processor !== 'function') resolve(event);
        else {
            const result = processor({
                ...event
            }, hint);
            (0, $eblj3.DEBUG_BUILD) && processor.id && result === null && (0, $dcNCf.logger).log(`Event processor "${processor.id}" dropped event`);
            if ((0, $iILRy.isThenable)(result)) result.then((final)=>$efebe2d81c62873e$export$bf2a096c3e883e79(processors, final, hint, index + 1).then(resolve)).then(null, reject);
            else $efebe2d81c62873e$export$bf2a096c3e883e79(processors, result, hint, index + 1).then(resolve).then(null, reject);
        }
    });
}

});
parcelRegister("9wGca", function(module, exports) {

$parcel$export(module.exports, "SyncPromise", () => $6ef7d552c6eabd35$export$6f292d4960313241);

var $iILRy = parcelRequire("iILRy");
/* eslint-disable @typescript-eslint/explicit-function-return-type */ /** SyncPromise internal states */ var $6ef7d552c6eabd35$var$States;
(function(States) {
    /** Pending */ const PENDING = 0;
    States[States["PENDING"] = PENDING] = "PENDING";
    /** Resolved / OK */ const RESOLVED = 1;
    States[States["RESOLVED"] = RESOLVED] = "RESOLVED";
    /** Rejected / Error */ const REJECTED = 2;
    States[States["REJECTED"] = REJECTED] = "REJECTED";
})($6ef7d552c6eabd35$var$States || ($6ef7d552c6eabd35$var$States = {}));
// Overloads so we can call resolvedSyncPromise without arguments and generic argument
/**
 * Creates a resolved sync promise.
 *
 * @param value the value to resolve the promise with
 * @returns the resolved sync promise
 */ function $6ef7d552c6eabd35$export$1fda8aa4d135f8aa(value) {
    return new $6ef7d552c6eabd35$export$6f292d4960313241((resolve)=>{
        resolve(value);
    });
}
/**
 * Creates a rejected sync promise.
 *
 * @param value the value to reject the promise with
 * @returns the rejected sync promise
 */ function $6ef7d552c6eabd35$export$78e43115b553f358(reason) {
    return new $6ef7d552c6eabd35$export$6f292d4960313241((_, reject)=>{
        reject(reason);
    });
}
/**
 * Thenable class that behaves like a Promise and follows it's interface
 * but is not async internally
 */ class $6ef7d552c6eabd35$export$6f292d4960313241 {
    constructor(executor){
        $6ef7d552c6eabd35$export$6f292d4960313241.prototype.__init.call(this);
        $6ef7d552c6eabd35$export$6f292d4960313241.prototype.__init2.call(this);
        $6ef7d552c6eabd35$export$6f292d4960313241.prototype.__init3.call(this);
        $6ef7d552c6eabd35$export$6f292d4960313241.prototype.__init4.call(this);
        this._state = $6ef7d552c6eabd35$var$States.PENDING;
        this._handlers = [];
        try {
            executor(this._resolve, this._reject);
        } catch (e) {
            this._reject(e);
        }
    }
    /** JSDoc */ then(onfulfilled, onrejected) {
        return new $6ef7d552c6eabd35$export$6f292d4960313241((resolve, reject)=>{
            this._handlers.push([
                false,
                (result)=>{
                    if (!onfulfilled) // TODO: ¯\_(ツ)_/¯
                    // TODO: FIXME
                    resolve(result);
                    else try {
                        resolve(onfulfilled(result));
                    } catch (e) {
                        reject(e);
                    }
                },
                (reason)=>{
                    if (!onrejected) reject(reason);
                    else try {
                        resolve(onrejected(reason));
                    } catch (e) {
                        reject(e);
                    }
                }
            ]);
            this._executeHandlers();
        });
    }
    /** JSDoc */ catch(onrejected) {
        return this.then((val)=>val, onrejected);
    }
    /** JSDoc */ finally(onfinally) {
        return new $6ef7d552c6eabd35$export$6f292d4960313241((resolve, reject)=>{
            let val;
            let isRejected;
            return this.then((value)=>{
                isRejected = false;
                val = value;
                if (onfinally) onfinally();
            }, (reason)=>{
                isRejected = true;
                val = reason;
                if (onfinally) onfinally();
            }).then(()=>{
                if (isRejected) {
                    reject(val);
                    return;
                }
                resolve(val);
            });
        });
    }
    /** JSDoc */ __init() {
        this._resolve = (value)=>{
            this._setResult($6ef7d552c6eabd35$var$States.RESOLVED, value);
        };
    }
    /** JSDoc */ __init2() {
        this._reject = (reason)=>{
            this._setResult($6ef7d552c6eabd35$var$States.REJECTED, reason);
        };
    }
    /** JSDoc */ __init3() {
        this._setResult = (state, value)=>{
            if (this._state !== $6ef7d552c6eabd35$var$States.PENDING) return;
            if ((0, $iILRy.isThenable)(value)) {
                value.then(this._resolve, this._reject);
                return;
            }
            this._state = state;
            this._value = value;
            this._executeHandlers();
        };
    }
    /** JSDoc */ __init4() {
        this._executeHandlers = ()=>{
            if (this._state === $6ef7d552c6eabd35$var$States.PENDING) return;
            const cachedHandlers = this._handlers.slice();
            this._handlers = [];
            cachedHandlers.forEach((handler)=>{
                if (handler[0]) return;
                if (this._state === $6ef7d552c6eabd35$var$States.RESOLVED) // eslint-disable-next-line @typescript-eslint/no-floating-promises
                handler[1](this._value);
                if (this._state === $6ef7d552c6eabd35$var$States.REJECTED) handler[2](this._value);
                handler[0] = true;
            });
        };
    }
}

});


parcelRegister("e8qIc", function(module, exports) {

$parcel$export(module.exports, "makeSession", () => $a4a68878937a2cff$export$14a186326edbb264);
$parcel$export(module.exports, "updateSession", () => $a4a68878937a2cff$export$531818e825e774db);
$parcel$export(module.exports, "closeSession", () => $a4a68878937a2cff$export$56521d9ba90f62ee);

var $fGLXA = parcelRequire("fGLXA");
var $3vU5t = parcelRequire("3vU5t");
var $dcmwb = parcelRequire("dcmwb");
/**
 * Creates a new `Session` object by setting certain default parameters. If optional @param context
 * is passed, the passed properties are applied to the session object.
 *
 * @param context (optional) additional properties to be applied to the returned session object
 *
 * @returns a new `Session` object
 */ function $a4a68878937a2cff$export$14a186326edbb264(context) {
    // Both timestamp and started are in seconds since the UNIX epoch.
    const startingTime = (0, $3vU5t.timestampInSeconds)();
    const session = {
        sid: (0, $dcmwb.uuid4)(),
        init: true,
        timestamp: startingTime,
        started: startingTime,
        duration: 0,
        status: 'ok',
        errors: 0,
        ignoreDuration: false,
        toJSON: ()=>$a4a68878937a2cff$var$sessionToJSON(session)
    };
    if (context) $a4a68878937a2cff$export$531818e825e774db(session, context);
    return session;
}
/**
 * Updates a session object with the properties passed in the context.
 *
 * Note that this function mutates the passed object and returns void.
 * (Had to do this instead of returning a new and updated session because closing and sending a session
 * makes an update to the session after it was passed to the sending logic.
 * @see BaseClient.captureSession )
 *
 * @param session the `Session` to update
 * @param context the `SessionContext` holding the properties that should be updated in @param session
 */ // eslint-disable-next-line complexity
function $a4a68878937a2cff$export$531818e825e774db(session, context = {}) {
    if (context.user) {
        if (!session.ipAddress && context.user.ip_address) session.ipAddress = context.user.ip_address;
        if (!session.did && !context.did) session.did = context.user.id || context.user.email || context.user.username;
    }
    session.timestamp = context.timestamp || (0, $3vU5t.timestampInSeconds)();
    if (context.abnormal_mechanism) session.abnormal_mechanism = context.abnormal_mechanism;
    if (context.ignoreDuration) session.ignoreDuration = context.ignoreDuration;
    if (context.sid) // Good enough uuid validation. — Kamil
    session.sid = context.sid.length === 32 ? context.sid : (0, $dcmwb.uuid4)();
    if (context.init !== undefined) session.init = context.init;
    if (!session.did && context.did) session.did = `${context.did}`;
    if (typeof context.started === 'number') session.started = context.started;
    if (session.ignoreDuration) session.duration = undefined;
    else if (typeof context.duration === 'number') session.duration = context.duration;
    else {
        const duration = session.timestamp - session.started;
        session.duration = duration >= 0 ? duration : 0;
    }
    if (context.release) session.release = context.release;
    if (context.environment) session.environment = context.environment;
    if (!session.ipAddress && context.ipAddress) session.ipAddress = context.ipAddress;
    if (!session.userAgent && context.userAgent) session.userAgent = context.userAgent;
    if (typeof context.errors === 'number') session.errors = context.errors;
    if (context.status) session.status = context.status;
}
/**
 * Closes a session by setting its status and updating the session object with it.
 * Internally calls `updateSession` to update the passed session object.
 *
 * Note that this function mutates the passed session (@see updateSession for explanation).
 *
 * @param session the `Session` object to be closed
 * @param status the `SessionStatus` with which the session was closed. If you don't pass a status,
 *               this function will keep the previously set status, unless it was `'ok'` in which case
 *               it is changed to `'exited'`.
 */ function $a4a68878937a2cff$export$56521d9ba90f62ee(session, status) {
    let context = {};
    if (status) context = {
        status: status
    };
    else if (session.status === 'ok') context = {
        status: 'exited'
    };
    $a4a68878937a2cff$export$531818e825e774db(session, context);
}
/**
 * Serializes a passed session object to a JSON object with a slightly different structure.
 * This is necessary because the Sentry backend requires a slightly different schema of a session
 * than the one the JS SDKs use internally.
 *
 * @param session the session to be converted
 *
 * @returns a JSON object of the passed session
 */ function $a4a68878937a2cff$var$sessionToJSON(session) {
    return (0, $fGLXA.dropUndefinedKeys)({
        sid: `${session.sid}`,
        init: session.init,
        // Make sure that sec is converted to ms for date constructor
        started: new Date(session.started * 1000).toISOString(),
        timestamp: new Date(session.timestamp * 1000).toISOString(),
        status: session.status,
        errors: session.errors,
        did: typeof session.did === 'number' || typeof session.did === 'string' ? `${session.did}` : undefined,
        duration: session.duration,
        abnormal_mechanism: session.abnormal_mechanism,
        attrs: {
            release: session.release,
            environment: session.environment,
            ip_address: session.ipAddress,
            user_agent: session.userAgent
        }
    });
}

});

parcelRegister("7i0oJ", function(module, exports) {

$parcel$export(module.exports, "applyScopeDataToEvent", () => $54ea85da1a28365b$export$43988bc651a80216);
$parcel$export(module.exports, "mergeScopeData", () => $54ea85da1a28365b$export$25ac7e259a513db4);

var $dcmwb = parcelRequire("dcmwb");
var $fGLXA = parcelRequire("fGLXA");

var $9RUcR = parcelRequire("9RUcR");

var $hRcaM = parcelRequire("hRcaM");

var $gWxLP = parcelRequire("gWxLP");
/**
 * Applies data from the scope to the event and runs all event processors on it.
 */ function $54ea85da1a28365b$export$43988bc651a80216(event, data) {
    const { fingerprint: fingerprint, span: span, breadcrumbs: breadcrumbs, sdkProcessingMetadata: sdkProcessingMetadata } = data;
    // Apply general data
    $54ea85da1a28365b$var$applyDataToEvent(event, data);
    // We want to set the trace context for normal events only if there isn't already
    // a trace context on the event. There is a product feature in place where we link
    // errors with transaction and it relies on that.
    if (span) $54ea85da1a28365b$var$applySpanToEvent(event, span);
    $54ea85da1a28365b$var$applyFingerprintToEvent(event, fingerprint);
    $54ea85da1a28365b$var$applyBreadcrumbsToEvent(event, breadcrumbs);
    $54ea85da1a28365b$var$applySdkMetadataToEvent(event, sdkProcessingMetadata);
}
/** Merge data of two scopes together. */ function $54ea85da1a28365b$export$25ac7e259a513db4(data, mergeData) {
    const { extra: extra, tags: tags, user: user, contexts: contexts, level: level, sdkProcessingMetadata: sdkProcessingMetadata, breadcrumbs: breadcrumbs, fingerprint: fingerprint, eventProcessors: eventProcessors, attachments: attachments, propagationContext: propagationContext, transactionName: // eslint-disable-next-line deprecation/deprecation
    transactionName, span: span } = mergeData;
    $54ea85da1a28365b$export$b1a120a2871faa46(data, 'extra', extra);
    $54ea85da1a28365b$export$b1a120a2871faa46(data, 'tags', tags);
    $54ea85da1a28365b$export$b1a120a2871faa46(data, 'user', user);
    $54ea85da1a28365b$export$b1a120a2871faa46(data, 'contexts', contexts);
    $54ea85da1a28365b$export$b1a120a2871faa46(data, 'sdkProcessingMetadata', sdkProcessingMetadata);
    if (level) data.level = level;
    if (transactionName) // eslint-disable-next-line deprecation/deprecation
    data.transactionName = transactionName;
    if (span) data.span = span;
    if (breadcrumbs.length) data.breadcrumbs = [
        ...data.breadcrumbs,
        ...breadcrumbs
    ];
    if (fingerprint.length) data.fingerprint = [
        ...data.fingerprint,
        ...fingerprint
    ];
    if (eventProcessors.length) data.eventProcessors = [
        ...data.eventProcessors,
        ...eventProcessors
    ];
    if (attachments.length) data.attachments = [
        ...data.attachments,
        ...attachments
    ];
    data.propagationContext = {
        ...data.propagationContext,
        ...propagationContext
    };
}
/**
 * Merges certain scope data. Undefined values will overwrite any existing values.
 * Exported only for tests.
 */ function $54ea85da1a28365b$export$b1a120a2871faa46(data, prop, mergeVal) {
    if (mergeVal && Object.keys(mergeVal).length) {
        // Clone object
        data[prop] = {
            ...data[prop]
        };
        for(const key in mergeVal)if (Object.prototype.hasOwnProperty.call(mergeVal, key)) data[prop][key] = mergeVal[key];
    }
}
function $54ea85da1a28365b$var$applyDataToEvent(event, data) {
    const { extra: extra, tags: tags, user: user, contexts: contexts, level: level, transactionName: // eslint-disable-next-line deprecation/deprecation
    transactionName } = data;
    const cleanedExtra = (0, $fGLXA.dropUndefinedKeys)(extra);
    if (cleanedExtra && Object.keys(cleanedExtra).length) event.extra = {
        ...cleanedExtra,
        ...event.extra
    };
    const cleanedTags = (0, $fGLXA.dropUndefinedKeys)(tags);
    if (cleanedTags && Object.keys(cleanedTags).length) event.tags = {
        ...cleanedTags,
        ...event.tags
    };
    const cleanedUser = (0, $fGLXA.dropUndefinedKeys)(user);
    if (cleanedUser && Object.keys(cleanedUser).length) event.user = {
        ...cleanedUser,
        ...event.user
    };
    const cleanedContexts = (0, $fGLXA.dropUndefinedKeys)(contexts);
    if (cleanedContexts && Object.keys(cleanedContexts).length) event.contexts = {
        ...cleanedContexts,
        ...event.contexts
    };
    if (level) event.level = level;
    if (transactionName) event.transaction = transactionName;
}
function $54ea85da1a28365b$var$applyBreadcrumbsToEvent(event, breadcrumbs) {
    const mergedBreadcrumbs = [
        ...event.breadcrumbs || [],
        ...breadcrumbs
    ];
    event.breadcrumbs = mergedBreadcrumbs.length ? mergedBreadcrumbs : undefined;
}
function $54ea85da1a28365b$var$applySdkMetadataToEvent(event, sdkProcessingMetadata) {
    event.sdkProcessingMetadata = {
        ...event.sdkProcessingMetadata,
        ...sdkProcessingMetadata
    };
}
function $54ea85da1a28365b$var$applySpanToEvent(event, span) {
    event.contexts = {
        trace: (0, $gWxLP.spanToTraceContext)(span),
        ...event.contexts
    };
    const rootSpan = (0, $hRcaM.getRootSpan)(span);
    if (rootSpan) {
        event.sdkProcessingMetadata = {
            dynamicSamplingContext: (0, $9RUcR.getDynamicSamplingContextFromSpan)(span),
            ...event.sdkProcessingMetadata
        };
        const transactionName = (0, $gWxLP.spanToJSON)(rootSpan).description;
        if (transactionName) event.tags = {
            transaction: transactionName,
            ...event.tags
        };
    }
}
/**
 * Applies fingerprint from the scope to the event if there's one,
 * uses message if there's one instead or get rid of empty fingerprint
 */ function $54ea85da1a28365b$var$applyFingerprintToEvent(event, fingerprint) {
    // Make sure it's an array first and we actually have something in place
    event.fingerprint = event.fingerprint ? (0, $dcmwb.arrayify)(event.fingerprint) : [];
    // If we have something on the scope, then merge it with event
    if (fingerprint) event.fingerprint = event.fingerprint.concat(fingerprint);
    // If we have no data at all, remove empty array default
    if (event.fingerprint && !event.fingerprint.length) delete event.fingerprint;
}

});
parcelRegister("9RUcR", function(module, exports) {

$parcel$export(module.exports, "getDynamicSamplingContextFromSpan", () => $72f4a9b715a9337d$export$a117f995597e25df);

var $fGLXA = parcelRequire("fGLXA");

var $kxRA4 = parcelRequire("kxRA4");

var $S1tY7 = parcelRequire("S1tY7");

var $hRcaM = parcelRequire("hRcaM");

var $gWxLP = parcelRequire("gWxLP");
/**
 * Creates a dynamic sampling context from a client.
 *
 * Dispatches the `createDsc` lifecycle hook as a side effect.
 */ function $72f4a9b715a9337d$export$366bad00d6815eed(trace_id, client, scope) {
    const options = client.getOptions();
    const { publicKey: public_key } = client.getDsn() || {};
    // TODO(v8): Remove segment from User
    // eslint-disable-next-line deprecation/deprecation
    const { segment: user_segment } = scope && scope.getUser() || {};
    const dsc = (0, $fGLXA.dropUndefinedKeys)({
        environment: options.environment || (0, $kxRA4.DEFAULT_ENVIRONMENT),
        release: options.release,
        user_segment: user_segment,
        public_key: public_key,
        trace_id: trace_id
    });
    client.emit && client.emit('createDsc', dsc);
    return dsc;
}
/**
 * A Span with a frozen dynamic sampling context.
 */ /**
 * Creates a dynamic sampling context from a span (and client and scope)
 *
 * @param span the span from which a few values like the root span name and sample rate are extracted.
 *
 * @returns a dynamic sampling context
 */ function $72f4a9b715a9337d$export$a117f995597e25df(span) {
    const client = (0, $S1tY7.getClient)();
    if (!client) return {};
    // passing emit=false here to only emit later once the DSC is actually populated
    const dsc = $72f4a9b715a9337d$export$366bad00d6815eed((0, $gWxLP.spanToJSON)(span).trace_id || '', client, (0, $S1tY7.getCurrentScope)());
    // TODO (v8): Remove v7FrozenDsc as a Transaction will no longer have _frozenDynamicSamplingContext
    const txn = (0, $hRcaM.getRootSpan)(span);
    if (!txn) return dsc;
    // TODO (v8): Remove v7FrozenDsc as a Transaction will no longer have _frozenDynamicSamplingContext
    // For now we need to avoid breaking users who directly created a txn with a DSC, where this field is still set.
    // @see Transaction class constructor
    const v7FrozenDsc = txn && txn._frozenDynamicSamplingContext;
    if (v7FrozenDsc) return v7FrozenDsc;
    // TODO (v8): Replace txn.metadata with txn.attributes[]
    // We can't do this yet because attributes aren't always set yet.
    // eslint-disable-next-line deprecation/deprecation
    const { sampleRate: maybeSampleRate, source: source } = txn.metadata;
    if (maybeSampleRate != null) dsc.sample_rate = `${maybeSampleRate}`;
    // We don't want to have a transaction name in the DSC if the source is "url" because URLs might contain PII
    const jsonSpan = (0, $gWxLP.spanToJSON)(txn);
    // after JSON conversion, txn.name becomes jsonSpan.description
    if (source && source !== 'url') dsc.transaction = jsonSpan.description;
    dsc.sampled = String((0, $gWxLP.spanIsSampled)(txn));
    client.emit && client.emit('createDsc', dsc);
    return dsc;
}

});
parcelRegister("hRcaM", function(module, exports) {

$parcel$export(module.exports, "getRootSpan", () => $d000d42ea75264fb$export$c4c6a79b1260ca1b);
/**
 * Returns the root span of a given span.
 *
 * As long as we use `Transaction`s internally, the returned root span
 * will be a `Transaction` but be aware that this might change in the future.
 *
 * If the given span has no root span or transaction, `undefined` is returned.
 */ function $d000d42ea75264fb$export$c4c6a79b1260ca1b(span) {
    // TODO (v8): Remove this check and just return span
    // eslint-disable-next-line deprecation/deprecation
    return span.transaction;
}

});

parcelRegister("gWxLP", function(module, exports) {

$parcel$export(module.exports, "spanToTraceContext", () => $c55c4239837de097$export$46c6fbd1d265ebf0);
$parcel$export(module.exports, "spanToJSON", () => $c55c4239837de097$export$92d8c23565496537);
$parcel$export(module.exports, "spanIsSampled", () => $c55c4239837de097$export$5caecac1caaf3a71);

var $fGLXA = parcelRequire("fGLXA");
var $83T5J = parcelRequire("83T5J");
var $3vU5t = parcelRequire("3vU5t");
// These are aligned with OpenTelemetry trace flags
const $c55c4239837de097$export$208d5b368507fb8b = 0x0;
const $c55c4239837de097$export$eb571cd9b5d98de8 = 0x1;
/**
 * Convert a span to a trace context, which can be sent as the `trace` context in an event.
 */ function $c55c4239837de097$export$46c6fbd1d265ebf0(span) {
    const { spanId: span_id, traceId: trace_id } = span.spanContext();
    const { data: data, op: op, parent_span_id: parent_span_id, status: status, tags: tags, origin: origin } = $c55c4239837de097$export$92d8c23565496537(span);
    return (0, $fGLXA.dropUndefinedKeys)({
        data: data,
        op: op,
        parent_span_id: parent_span_id,
        span_id: span_id,
        status: status,
        tags: tags,
        trace_id: trace_id,
        origin: origin
    });
}
/**
 * Convert a Span to a Sentry trace header.
 */ function $c55c4239837de097$export$7e9f8ae9e4a328ab(span) {
    const { traceId: traceId, spanId: spanId } = span.spanContext();
    const sampled = $c55c4239837de097$export$5caecac1caaf3a71(span);
    return (0, $83T5J.generateSentryTraceHeader)(traceId, spanId, sampled);
}
/**
 * Convert a span time input intp a timestamp in seconds.
 */ function $c55c4239837de097$export$3f7581298f56c6d7(input) {
    if (typeof input === 'number') return $c55c4239837de097$var$ensureTimestampInSeconds(input);
    if (Array.isArray(input)) // See {@link HrTime} for the array-based time format
    return input[0] + input[1] / 1e9;
    if (input instanceof Date) return $c55c4239837de097$var$ensureTimestampInSeconds(input.getTime());
    return (0, $3vU5t.timestampInSeconds)();
}
/**
 * Converts a timestamp to second, if it was in milliseconds, or keeps it as second.
 */ function $c55c4239837de097$var$ensureTimestampInSeconds(timestamp) {
    const isMs = timestamp > 9999999999;
    return isMs ? timestamp / 1000 : timestamp;
}
/**
 * Convert a span to a JSON representation.
 * Note that all fields returned here are optional and need to be guarded against.
 *
 * Note: Because of this, we currently have a circular type dependency (which we opted out of in package.json).
 * This is not avoidable as we need `spanToJSON` in `spanUtils.ts`, which in turn is needed by `span.ts` for backwards compatibility.
 * And `spanToJSON` needs the Span class from `span.ts` to check here.
 * TODO v8: When we remove the deprecated stuff from `span.ts`, we can remove the circular dependency again.
 */ function $c55c4239837de097$export$92d8c23565496537(span) {
    if ($c55c4239837de097$var$spanIsSpanClass(span)) return span.getSpanJSON();
    // Fallback: We also check for `.toJSON()` here...
    // eslint-disable-next-line deprecation/deprecation
    if (typeof span.toJSON === 'function') // eslint-disable-next-line deprecation/deprecation
    return span.toJSON();
    return {};
}
/**
 * Sadly, due to circular dependency checks we cannot actually import the Span class here and check for instanceof.
 * :( So instead we approximate this by checking if it has the `getSpanJSON` method.
 */ function $c55c4239837de097$var$spanIsSpanClass(span) {
    return typeof span.getSpanJSON === 'function';
}
/**
 * Returns true if a span is sampled.
 * In most cases, you should just use `span.isRecording()` instead.
 * However, this has a slightly different semantic, as it also returns false if the span is finished.
 * So in the case where this distinction is important, use this method.
 */ function $c55c4239837de097$export$5caecac1caaf3a71(span) {
    // We align our trace flags with the ones OpenTelemetry use
    // So we also check for sampled the same way they do.
    const { traceFlags: traceFlags } = span.spanContext();
    // eslint-disable-next-line no-bitwise
    return Boolean(traceFlags & $c55c4239837de097$export$eb571cd9b5d98de8);
}

});
parcelRegister("83T5J", function(module, exports) {

$parcel$export(module.exports, "generateSentryTraceHeader", () => $5de9568ba86cc589$export$f35d907436da45cf);

var $7gsvv = parcelRequire("7gsvv");

var $dcmwb = parcelRequire("dcmwb");
// eslint-disable-next-line @sentry-internal/sdk/no-regexp-constructor -- RegExp is used for readability here
const $5de9568ba86cc589$export$394a210812ba3012 = new RegExp("^[ \\t]*([0-9a-f]{32})?-?([0-9a-f]{16})?-?([01])?[ \\t]*$");
/**
 * Extract transaction context data from a `sentry-trace` header.
 *
 * @param traceparent Traceparent string
 *
 * @returns Object containing data from the header, or undefined if traceparent string is malformed
 */ function $5de9568ba86cc589$export$8e9a29865c0a1226(traceparent) {
    if (!traceparent) return undefined;
    const matches = traceparent.match($5de9568ba86cc589$export$394a210812ba3012);
    if (!matches) return undefined;
    let parentSampled;
    if (matches[3] === '1') parentSampled = true;
    else if (matches[3] === '0') parentSampled = false;
    return {
        traceId: matches[1],
        parentSampled: parentSampled,
        parentSpanId: matches[2]
    };
}
/**
 * Create tracing context from incoming headers.
 *
 * @deprecated Use `propagationContextFromHeaders` instead.
 */ // TODO(v8): Remove this function
function $5de9568ba86cc589$export$ca5c066532785b6e(sentryTrace, baggage) {
    const traceparentData = $5de9568ba86cc589$export$8e9a29865c0a1226(sentryTrace);
    const dynamicSamplingContext = (0, $7gsvv.baggageHeaderToDynamicSamplingContext)(baggage);
    const { traceId: traceId, parentSpanId: parentSpanId, parentSampled: parentSampled } = traceparentData || {};
    if (!traceparentData) return {
        traceparentData: traceparentData,
        dynamicSamplingContext: undefined,
        propagationContext: {
            traceId: traceId || (0, $dcmwb.uuid4)(),
            spanId: (0, $dcmwb.uuid4)().substring(16)
        }
    };
    else return {
        traceparentData: traceparentData,
        dynamicSamplingContext: dynamicSamplingContext || {},
        propagationContext: {
            traceId: traceId || (0, $dcmwb.uuid4)(),
            parentSpanId: parentSpanId || (0, $dcmwb.uuid4)().substring(16),
            spanId: (0, $dcmwb.uuid4)().substring(16),
            sampled: parentSampled,
            dsc: dynamicSamplingContext || {}
        }
    };
}
/**
 * Create a propagation context from incoming headers.
 */ function $5de9568ba86cc589$export$261f383d16a93e39(sentryTrace, baggage) {
    const traceparentData = $5de9568ba86cc589$export$8e9a29865c0a1226(sentryTrace);
    const dynamicSamplingContext = (0, $7gsvv.baggageHeaderToDynamicSamplingContext)(baggage);
    const { traceId: traceId, parentSpanId: parentSpanId, parentSampled: parentSampled } = traceparentData || {};
    if (!traceparentData) return {
        traceId: traceId || (0, $dcmwb.uuid4)(),
        spanId: (0, $dcmwb.uuid4)().substring(16)
    };
    else return {
        traceId: traceId || (0, $dcmwb.uuid4)(),
        parentSpanId: parentSpanId || (0, $dcmwb.uuid4)().substring(16),
        spanId: (0, $dcmwb.uuid4)().substring(16),
        sampled: parentSampled,
        dsc: dynamicSamplingContext || {}
    };
}
/**
 * Create sentry-trace header from span context values.
 */ function $5de9568ba86cc589$export$f35d907436da45cf(traceId = (0, $dcmwb.uuid4)(), spanId = (0, $dcmwb.uuid4)().substring(16), sampled) {
    let sampledString = '';
    if (sampled !== undefined) sampledString = sampled ? '-1' : '-0';
    return `${traceId}-${spanId}${sampledString}`;
}

});
parcelRegister("7gsvv", function(module, exports) {

$parcel$export(module.exports, "baggageHeaderToDynamicSamplingContext", () => $54a023f047ef1316$export$5b96ee2c8421f107);

var $hIqTc = parcelRequire("hIqTc");

var $iILRy = parcelRequire("iILRy");

var $dcNCf = parcelRequire("dcNCf");
const $54a023f047ef1316$export$9ca9946bd449ac06 = 'baggage';
const $54a023f047ef1316$export$6e69537d67fa20f = 'sentry-';
const $54a023f047ef1316$export$eb0401070c617ea5 = /^sentry-/;
/**
 * Max length of a serialized baggage string
 *
 * https://www.w3.org/TR/baggage/#limits
 */ const $54a023f047ef1316$export$bdd844ddb2def819 = 8192;
/**
 * Takes a baggage header and turns it into Dynamic Sampling Context, by extracting all the "sentry-" prefixed values
 * from it.
 *
 * @param baggageHeader A very bread definition of a baggage header as it might appear in various frameworks.
 * @returns The Dynamic Sampling Context that was found on `baggageHeader`, if there was any, `undefined` otherwise.
 */ function $54a023f047ef1316$export$5b96ee2c8421f107(// Very liberal definition of what any incoming header might look like
baggageHeader) {
    if (!(0, $iILRy.isString)(baggageHeader) && !Array.isArray(baggageHeader)) return undefined;
    // Intermediary object to store baggage key value pairs of incoming baggage headers on.
    // It is later used to read Sentry-DSC-values from.
    let baggageObject = {};
    if (Array.isArray(baggageHeader)) // Combine all baggage headers into one object containing the baggage values so we can later read the Sentry-DSC-values from it
    baggageObject = baggageHeader.reduce((acc, curr)=>{
        const currBaggageObject = $54a023f047ef1316$var$baggageHeaderToObject(curr);
        for (const key of Object.keys(currBaggageObject))acc[key] = currBaggageObject[key];
        return acc;
    }, {});
    else {
        // Return undefined if baggage header is an empty string (technically an empty baggage header is not spec conform but
        // this is how we choose to handle it)
        if (!baggageHeader) return undefined;
        baggageObject = $54a023f047ef1316$var$baggageHeaderToObject(baggageHeader);
    }
    // Read all "sentry-" prefixed values out of the baggage object and put it onto a dynamic sampling context object.
    const dynamicSamplingContext = Object.entries(baggageObject).reduce((acc, [key, value])=>{
        if (key.match($54a023f047ef1316$export$eb0401070c617ea5)) {
            const nonPrefixedKey = key.slice($54a023f047ef1316$export$6e69537d67fa20f.length);
            acc[nonPrefixedKey] = value;
        }
        return acc;
    }, {});
    // Only return a dynamic sampling context object if there are keys in it.
    // A keyless object means there were no sentry values on the header, which means that there is no DSC.
    if (Object.keys(dynamicSamplingContext).length > 0) return dynamicSamplingContext;
    else return undefined;
}
/**
 * Turns a Dynamic Sampling Object into a baggage header by prefixing all the keys on the object with "sentry-".
 *
 * @param dynamicSamplingContext The Dynamic Sampling Context to turn into a header. For convenience and compatibility
 * with the `getDynamicSamplingContext` method on the Transaction class ,this argument can also be `undefined`. If it is
 * `undefined` the function will return `undefined`.
 * @returns a baggage header, created from `dynamicSamplingContext`, or `undefined` either if `dynamicSamplingContext`
 * was `undefined`, or if `dynamicSamplingContext` didn't contain any values.
 */ function $54a023f047ef1316$export$56766feef403f365(// this also takes undefined for convenience and bundle size in other places
dynamicSamplingContext) {
    if (!dynamicSamplingContext) return undefined;
    // Prefix all DSC keys with "sentry-" and put them into a new object
    const sentryPrefixedDSC = Object.entries(dynamicSamplingContext).reduce((acc, [dscKey, dscValue])=>{
        if (dscValue) acc[`${$54a023f047ef1316$export$6e69537d67fa20f}${dscKey}`] = dscValue;
        return acc;
    }, {});
    return $54a023f047ef1316$var$objectToBaggageHeader(sentryPrefixedDSC);
}
/**
 * Will parse a baggage header, which is a simple key-value map, into a flat object.
 *
 * @param baggageHeader The baggage header to parse.
 * @returns a flat object containing all the key-value pairs from `baggageHeader`.
 */ function $54a023f047ef1316$var$baggageHeaderToObject(baggageHeader) {
    return baggageHeader.split(',').map((baggageEntry)=>baggageEntry.split('=').map((keyOrValue)=>decodeURIComponent(keyOrValue.trim()))).reduce((acc, [key, value])=>{
        acc[key] = value;
        return acc;
    }, {});
}
/**
 * Turns a flat object (key-value pairs) into a baggage header, which is also just key-value pairs.
 *
 * @param object The object to turn into a baggage header.
 * @returns a baggage header string, or `undefined` if the object didn't have any values, since an empty baggage header
 * is not spec compliant.
 */ function $54a023f047ef1316$var$objectToBaggageHeader(object) {
    if (Object.keys(object).length === 0) // An empty baggage header is not spec compliant: We return undefined.
    return undefined;
    return Object.entries(object).reduce((baggageHeader, [objectKey, objectValue], currentIndex)=>{
        const baggageEntry = `${encodeURIComponent(objectKey)}=${encodeURIComponent(objectValue)}`;
        const newBaggageHeader = currentIndex === 0 ? baggageEntry : `${baggageHeader},${baggageEntry}`;
        if (newBaggageHeader.length > $54a023f047ef1316$export$bdd844ddb2def819) {
            (0, $hIqTc.DEBUG_BUILD) && (0, $dcNCf.logger).warn(`Not adding key: ${objectKey} with val: ${objectValue} to baggage header due to exceeding baggage size limits.`);
            return baggageHeader;
        } else return newBaggageHeader;
    }, '');
}

});






parcelRegister("4COab", function(module, exports) {

$parcel$export(module.exports, "SDK_VERSION", () => $35e19f6d6d4e4882$export$31499a9cd224b78c);
const $35e19f6d6d4e4882$export$31499a9cd224b78c = '7.120.3';

});


parcelRegister("4eCQ6", function(module, exports) {

$parcel$export(module.exports, "parseEventHintOrCaptureContext", () => $315698ec5d770461$export$76b5f966996d1653);

var $dcmwb = parcelRequire("dcmwb");
var $3vU5t = parcelRequire("3vU5t");
var $7cDym = parcelRequire("7cDym");
var $89fDe = parcelRequire("89fDe");
var $Reevt = parcelRequire("Reevt");

var $kxRA4 = parcelRequire("kxRA4");

var $kB5Xz = parcelRequire("kB5Xz");

var $1EIrE = parcelRequire("1EIrE");

var $7i0oJ = parcelRequire("7i0oJ");

var $gWxLP = parcelRequire("gWxLP");
/**
 * This type makes sure that we get either a CaptureContext, OR an EventHint.
 * It does not allow mixing them, which could lead to unexpected outcomes, e.g. this is disallowed:
 * { user: { id: '123' }, mechanism: { handled: false } }
 */ /**
 * Adds common information to events.
 *
 * The information includes release and environment from `options`,
 * breadcrumbs and context (extra, tags and user) from the scope.
 *
 * Information that is already present in the event is never overwritten. For
 * nested objects, such as the context, keys are merged.
 *
 * Note: This also triggers callbacks for `addGlobalEventProcessor`, but not `beforeSend`.
 *
 * @param event The original event.
 * @param hint May contain additional information about the original exception.
 * @param scope A scope containing event metadata.
 * @returns A new event with more information.
 * @hidden
 */ function $315698ec5d770461$export$2d67fb380bd11267(options, event, hint, scope, client, isolationScope) {
    const { normalizeDepth: normalizeDepth = 3, normalizeMaxBreadth: normalizeMaxBreadth = 1000 } = options;
    const prepared = {
        ...event,
        event_id: event.event_id || hint.event_id || (0, $dcmwb.uuid4)(),
        timestamp: event.timestamp || (0, $3vU5t.dateTimestampInSeconds)()
    };
    const integrations = hint.integrations || options.integrations.map((i)=>i.name);
    $315698ec5d770461$var$applyClientOptions(prepared, options);
    $315698ec5d770461$var$applyIntegrationsMetadata(prepared, integrations);
    // Only put debug IDs onto frames for error events.
    if (event.type === undefined) $315698ec5d770461$export$63042efc86f043e7(prepared, options.stackParser);
    // If we have scope given to us, use it as the base for further modifications.
    // This allows us to prevent unnecessary copying of data if `captureContext` is not provided.
    const finalScope = $315698ec5d770461$var$getFinalScope(scope, hint.captureContext);
    if (hint.mechanism) (0, $dcmwb.addExceptionMechanism)(prepared, hint.mechanism);
    const clientEventProcessors = client && client.getEventProcessors ? client.getEventProcessors() : [];
    // This should be the last thing called, since we want that
    // {@link Hub.addEventProcessor} gets the finished prepared event.
    // Merge scope data together
    const data = (0, $1EIrE.getGlobalScope)().getScopeData();
    if (isolationScope) {
        const isolationData = isolationScope.getScopeData();
        (0, $7i0oJ.mergeScopeData)(data, isolationData);
    }
    if (finalScope) {
        const finalScopeData = finalScope.getScopeData();
        (0, $7i0oJ.mergeScopeData)(data, finalScopeData);
    }
    const attachments = [
        ...hint.attachments || [],
        ...data.attachments
    ];
    if (attachments.length) hint.attachments = attachments;
    (0, $7i0oJ.applyScopeDataToEvent)(prepared, data);
    // TODO (v8): Update this order to be: Global > Client > Scope
    const eventProcessors = [
        ...clientEventProcessors,
        // eslint-disable-next-line deprecation/deprecation
        ...(0, $kB5Xz.getGlobalEventProcessors)(),
        // Run scope event processors _after_ all other processors
        ...data.eventProcessors
    ];
    const result = (0, $kB5Xz.notifyEventProcessors)(eventProcessors, prepared, hint);
    return result.then((evt)=>{
        if (evt) // We apply the debug_meta field only after all event processors have ran, so that if any event processors modified
        // file names (e.g.the RewriteFrames integration) the filename -> debug ID relationship isn't destroyed.
        // This should not cause any PII issues, since we're only moving data that is already on the event and not adding
        // any new data
        $315698ec5d770461$export$1be657ba8ef44ff0(evt);
        if (typeof normalizeDepth === 'number' && normalizeDepth > 0) return $315698ec5d770461$var$normalizeEvent(evt, normalizeDepth, normalizeMaxBreadth);
        return evt;
    });
}
/**
 *  Enhances event using the client configuration.
 *  It takes care of all "static" values like environment, release and `dist`,
 *  as well as truncating overly long values.
 * @param event event instance to be enhanced
 */ function $315698ec5d770461$var$applyClientOptions(event, options) {
    const { environment: environment, release: release, dist: dist, maxValueLength: maxValueLength = 250 } = options;
    if (!('environment' in event)) event.environment = 'environment' in options ? environment : (0, $kxRA4.DEFAULT_ENVIRONMENT);
    if (event.release === undefined && release !== undefined) event.release = release;
    if (event.dist === undefined && dist !== undefined) event.dist = dist;
    if (event.message) event.message = (0, $Reevt.truncate)(event.message, maxValueLength);
    const exception = event.exception && event.exception.values && event.exception.values[0];
    if (exception && exception.value) exception.value = (0, $Reevt.truncate)(exception.value, maxValueLength);
    const request = event.request;
    if (request && request.url) request.url = (0, $Reevt.truncate)(request.url, maxValueLength);
}
const $315698ec5d770461$var$debugIdStackParserCache = new WeakMap();
/**
 * Puts debug IDs into the stack frames of an error event.
 */ function $315698ec5d770461$export$63042efc86f043e7(event, stackParser) {
    const debugIdMap = (0, $7cDym.GLOBAL_OBJ)._sentryDebugIds;
    if (!debugIdMap) return;
    let debugIdStackFramesCache;
    const cachedDebugIdStackFrameCache = $315698ec5d770461$var$debugIdStackParserCache.get(stackParser);
    if (cachedDebugIdStackFrameCache) debugIdStackFramesCache = cachedDebugIdStackFrameCache;
    else {
        debugIdStackFramesCache = new Map();
        $315698ec5d770461$var$debugIdStackParserCache.set(stackParser, debugIdStackFramesCache);
    }
    // Build a map of filename -> debug_id
    const filenameDebugIdMap = Object.keys(debugIdMap).reduce((acc, debugIdStackTrace)=>{
        let parsedStack;
        const cachedParsedStack = debugIdStackFramesCache.get(debugIdStackTrace);
        if (cachedParsedStack) parsedStack = cachedParsedStack;
        else {
            parsedStack = stackParser(debugIdStackTrace);
            debugIdStackFramesCache.set(debugIdStackTrace, parsedStack);
        }
        for(let i = parsedStack.length - 1; i >= 0; i--){
            const stackFrame = parsedStack[i];
            if (stackFrame.filename) {
                acc[stackFrame.filename] = debugIdMap[debugIdStackTrace];
                break;
            }
        }
        return acc;
    }, {});
    try {
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        event.exception.values.forEach((exception)=>{
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            exception.stacktrace.frames.forEach((frame)=>{
                if (frame.filename) frame.debug_id = filenameDebugIdMap[frame.filename];
            });
        });
    } catch (e) {
    // To save bundle size we're just try catching here instead of checking for the existence of all the different objects.
    }
}
/**
 * Moves debug IDs from the stack frames of an error event into the debug_meta field.
 */ function $315698ec5d770461$export$1be657ba8ef44ff0(event) {
    // Extract debug IDs and filenames from the stack frames on the event.
    const filenameDebugIdMap = {};
    try {
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        event.exception.values.forEach((exception)=>{
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            exception.stacktrace.frames.forEach((frame)=>{
                if (frame.debug_id) {
                    if (frame.abs_path) filenameDebugIdMap[frame.abs_path] = frame.debug_id;
                    else if (frame.filename) filenameDebugIdMap[frame.filename] = frame.debug_id;
                    delete frame.debug_id;
                }
            });
        });
    } catch (e) {
    // To save bundle size we're just try catching here instead of checking for the existence of all the different objects.
    }
    if (Object.keys(filenameDebugIdMap).length === 0) return;
    // Fill debug_meta information
    event.debug_meta = event.debug_meta || {};
    event.debug_meta.images = event.debug_meta.images || [];
    const images = event.debug_meta.images;
    Object.keys(filenameDebugIdMap).forEach((filename)=>{
        images.push({
            type: 'sourcemap',
            code_file: filename,
            debug_id: filenameDebugIdMap[filename]
        });
    });
}
/**
 * This function adds all used integrations to the SDK info in the event.
 * @param event The event that will be filled with all integrations.
 */ function $315698ec5d770461$var$applyIntegrationsMetadata(event, integrationNames) {
    if (integrationNames.length > 0) {
        event.sdk = event.sdk || {};
        event.sdk.integrations = [
            ...event.sdk.integrations || [],
            ...integrationNames
        ];
    }
}
/**
 * Applies `normalize` function on necessary `Event` attributes to make them safe for serialization.
 * Normalized keys:
 * - `breadcrumbs.data`
 * - `user`
 * - `contexts`
 * - `extra`
 * @param event Event
 * @returns Normalized event
 */ function $315698ec5d770461$var$normalizeEvent(event, depth, maxBreadth) {
    if (!event) return null;
    const normalized = {
        ...event,
        ...event.breadcrumbs && {
            breadcrumbs: event.breadcrumbs.map((b)=>({
                    ...b,
                    ...b.data && {
                        data: (0, $89fDe.normalize)(b.data, depth, maxBreadth)
                    }
                }))
        },
        ...event.user && {
            user: (0, $89fDe.normalize)(event.user, depth, maxBreadth)
        },
        ...event.contexts && {
            contexts: (0, $89fDe.normalize)(event.contexts, depth, maxBreadth)
        },
        ...event.extra && {
            extra: (0, $89fDe.normalize)(event.extra, depth, maxBreadth)
        }
    };
    // event.contexts.trace stores information about a Transaction. Similarly,
    // event.spans[] stores information about child Spans. Given that a
    // Transaction is conceptually a Span, normalization should apply to both
    // Transactions and Spans consistently.
    // For now the decision is to skip normalization of Transactions and Spans,
    // so this block overwrites the normalized event to add back the original
    // Transaction information prior to normalization.
    if (event.contexts && event.contexts.trace && normalized.contexts) {
        normalized.contexts.trace = event.contexts.trace;
        // event.contexts.trace.data may contain circular/dangerous data so we need to normalize it
        if (event.contexts.trace.data) normalized.contexts.trace.data = (0, $89fDe.normalize)(event.contexts.trace.data, depth, maxBreadth);
    }
    // event.spans[].data may contain circular/dangerous data so we need to normalize it
    if (event.spans) normalized.spans = event.spans.map((span)=>{
        const data = (0, $gWxLP.spanToJSON)(span).data;
        if (data) // This is a bit weird, as we generally have `Span` instances here, but to be safe we do not assume so
        // eslint-disable-next-line deprecation/deprecation
        span.data = (0, $89fDe.normalize)(data, depth, maxBreadth);
        return span;
    });
    return normalized;
}
function $315698ec5d770461$var$getFinalScope(scope, captureContext) {
    if (!captureContext) return scope;
    const finalScope = scope ? scope.clone() : new (0, $1EIrE.Scope)();
    finalScope.update(captureContext);
    return finalScope;
}
/**
 * Parse either an `EventHint` directly, or convert a `CaptureContext` to an `EventHint`.
 * This is used to allow to update method signatures that used to accept a `CaptureContext` but should now accept an `EventHint`.
 */ function $315698ec5d770461$export$76b5f966996d1653(hint) {
    if (!hint) return undefined;
    // If you pass a Scope or `() => Scope` as CaptureContext, we just return this as captureContext
    if ($315698ec5d770461$var$hintIsScopeOrFunction(hint)) return {
        captureContext: hint
    };
    if ($315698ec5d770461$var$hintIsScopeContext(hint)) return {
        captureContext: hint
    };
    return hint;
}
function $315698ec5d770461$var$hintIsScopeOrFunction(hint) {
    return hint instanceof (0, $1EIrE.Scope) || typeof hint === 'function';
}
const $315698ec5d770461$var$captureContextKeys = [
    'user',
    'level',
    'extra',
    'contexts',
    'tags',
    'fingerprint',
    'requestSession',
    'propagationContext'
];
function $315698ec5d770461$var$hintIsScopeContext(hint) {
    return Object.keys(hint).some((key)=>$315698ec5d770461$var$captureContextKeys.includes(key));
}

});
parcelRegister("89fDe", function(module, exports) {

$parcel$export(module.exports, "normalize", () => $5eeb4a2055f93228$export$a3295358bff77e);

var $iILRy = parcelRequire("iILRy");

var $f89cW = parcelRequire("f89cW");

var $fGLXA = parcelRequire("fGLXA");

var $2Uu4G = parcelRequire("2Uu4G");
/**
 * Recursively normalizes the given object.
 *
 * - Creates a copy to prevent original input mutation
 * - Skips non-enumerable properties
 * - When stringifying, calls `toJSON` if implemented
 * - Removes circular references
 * - Translates non-serializable values (`undefined`/`NaN`/functions) to serializable format
 * - Translates known global objects/classes to a string representations
 * - Takes care of `Error` object serialization
 * - Optionally limits depth of final output
 * - Optionally limits number of properties/elements included in any single object/array
 *
 * @param input The object to be normalized.
 * @param depth The max depth to which to normalize the object. (Anything deeper stringified whole.)
 * @param maxProperties The max number of elements or properties to be included in any single array or
 * object in the normallized output.
 * @returns A normalized version of the object, or `"**non-serializable**"` if any errors are thrown during normalization.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $5eeb4a2055f93228$export$a3295358bff77e(input, depth = 100, maxProperties = Infinity) {
    try {
        // since we're at the outermost level, we don't provide a key
        return $5eeb4a2055f93228$export$588732934346abbf('', input, depth, maxProperties);
    } catch (err) {
        return {
            ERROR: `**non-serializable** (${err})`
        };
    }
}
/** JSDoc */ function $5eeb4a2055f93228$export$23fbbb20bed71033(// eslint-disable-next-line @typescript-eslint/no-explicit-any
object, // Default Node.js REPL depth
depth = 3, // 100kB, as 200kB is max payload size, so half sounds reasonable
maxSize = 102400) {
    const normalized = $5eeb4a2055f93228$export$a3295358bff77e(object, depth);
    if ($5eeb4a2055f93228$var$jsonSize(normalized) > maxSize) return $5eeb4a2055f93228$export$23fbbb20bed71033(object, depth - 1, maxSize);
    return normalized;
}
/**
 * Visits a node to perform normalization on it
 *
 * @param key The key corresponding to the given node
 * @param value The node to be visited
 * @param depth Optional number indicating the maximum recursion depth
 * @param maxProperties Optional maximum number of properties/elements included in any single object/array
 * @param memo Optional Memo class handling decycling
 */ function $5eeb4a2055f93228$export$588732934346abbf(key, value, depth = Infinity, maxProperties = Infinity, memo = (0, $f89cW.memoBuilder)()) {
    const [memoize, unmemoize] = memo;
    // Get the simple cases out of the way first
    if (value == null || // this matches null and undefined -> eqeq not eqeqeq
    [
        'number',
        'boolean',
        'string'
    ].includes(typeof value) && !(0, $iILRy.isNaN)(value)) return value;
    const stringified = $5eeb4a2055f93228$var$stringifyValue(key, value);
    // Anything we could potentially dig into more (objects or arrays) will have come back as `"[object XXXX]"`.
    // Everything else will have already been serialized, so if we don't see that pattern, we're done.
    if (!stringified.startsWith('[object ')) return stringified;
    // From here on, we can assert that `value` is either an object or an array.
    // Do not normalize objects that we know have already been normalized. As a general rule, the
    // "__sentry_skip_normalization__" property should only be used sparingly and only should only be set on objects that
    // have already been normalized.
    if (value['__sentry_skip_normalization__']) return value;
    // We can set `__sentry_override_normalization_depth__` on an object to ensure that from there
    // We keep a certain amount of depth.
    // This should be used sparingly, e.g. we use it for the redux integration to ensure we get a certain amount of state.
    const remainingDepth = typeof value['__sentry_override_normalization_depth__'] === 'number' ? value['__sentry_override_normalization_depth__'] : depth;
    // We're also done if we've reached the max depth
    if (remainingDepth === 0) // At this point we know `serialized` is a string of the form `"[object XXXX]"`. Clean it up so it's just `"[XXXX]"`.
    return stringified.replace('object ', '');
    // If we've already visited this branch, bail out, as it's circular reference. If not, note that we're seeing it now.
    if (memoize(value)) return '[Circular ~]';
    // If the value has a `toJSON` method, we call it to extract more information
    const valueWithToJSON = value;
    if (valueWithToJSON && typeof valueWithToJSON.toJSON === 'function') try {
        const jsonValue = valueWithToJSON.toJSON();
        // We need to normalize the return value of `.toJSON()` in case it has circular references
        return $5eeb4a2055f93228$export$588732934346abbf('', jsonValue, remainingDepth - 1, maxProperties, memo);
    } catch (err) {
    // pass (The built-in `toJSON` failed, but we can still try to do it ourselves)
    }
    // At this point we know we either have an object or an array, we haven't seen it before, and we're going to recurse
    // because we haven't yet reached the max depth. Create an accumulator to hold the results of visiting each
    // property/entry, and keep track of the number of items we add to it.
    const normalized = Array.isArray(value) ? [] : {};
    let numAdded = 0;
    // Before we begin, convert`Error` and`Event` instances into plain objects, since some of each of their relevant
    // properties are non-enumerable and otherwise would get missed.
    const visitable = (0, $fGLXA.convertToPlainObject)(value);
    for(const visitKey in visitable){
        // Avoid iterating over fields in the prototype if they've somehow been exposed to enumeration.
        if (!Object.prototype.hasOwnProperty.call(visitable, visitKey)) continue;
        if (numAdded >= maxProperties) {
            normalized[visitKey] = '[MaxProperties ~]';
            break;
        }
        // Recursively visit all the child nodes
        const visitValue = visitable[visitKey];
        normalized[visitKey] = $5eeb4a2055f93228$export$588732934346abbf(visitKey, visitValue, remainingDepth - 1, maxProperties, memo);
        numAdded++;
    }
    // Once we've visited all the branches, remove the parent from memo storage
    unmemoize(value);
    // Return accumulated values
    return normalized;
}
/* eslint-disable complexity */ /**
 * Stringify the given value. Handles various known special values and types.
 *
 * Not meant to be used on simple primitives which already have a string representation, as it will, for example, turn
 * the number 1231 into "[Object Number]", nor on `null`, as it will throw.
 *
 * @param value The value to stringify
 * @returns A stringified representation of the given value
 */ function $5eeb4a2055f93228$var$stringifyValue(key, // this type is a tiny bit of a cheat, since this function does handle NaN (which is technically a number), but for
// our internal use, it'll do
value) {
    try {
        if (key === 'domain' && value && typeof value === 'object' && value._events) return '[Domain]';
        if (key === 'domainEmitter') return '[DomainEmitter]';
        // It's safe to use `global`, `window`, and `document` here in this manner, as we are asserting using `typeof` first
        // which won't throw if they are not present.
        if (typeof $parcel$global !== 'undefined' && value === $parcel$global) return '[Global]';
        // eslint-disable-next-line no-restricted-globals
        if (typeof window !== 'undefined' && value === window) return '[Window]';
        // eslint-disable-next-line no-restricted-globals
        if (typeof document !== 'undefined' && value === document) return '[Document]';
        if ((0, $iILRy.isVueViewModel)(value)) return '[VueViewModel]';
        // React's SyntheticEvent thingy
        if ((0, $iILRy.isSyntheticEvent)(value)) return '[SyntheticEvent]';
        if (typeof value === 'number' && value !== value) return '[NaN]';
        if (typeof value === 'function') return `[Function: ${(0, $2Uu4G.getFunctionName)(value)}]`;
        if (typeof value === 'symbol') return `[${String(value)}]`;
        // stringified BigInts are indistinguishable from regular numbers, so we need to label them to avoid confusion
        if (typeof value === 'bigint') return `[BigInt: ${String(value)}]`;
        // Now that we've knocked out all the special cases and the primitives, all we have left are objects. Simply casting
        // them to strings means that instances of classes which haven't defined their `toStringTag` will just come out as
        // `"[object Object]"`. If we instead look at the constructor's name (which is the same as the name of the class),
        // we can make sure that only plain objects come out that way.
        const objName = $5eeb4a2055f93228$var$getConstructorName(value);
        // Handle HTML Elements
        if (/^HTML(\w*)Element$/.test(objName)) return `[HTMLElement: ${objName}]`;
        return `[object ${objName}]`;
    } catch (err) {
        return `**non-serializable** (${err})`;
    }
}
/* eslint-enable complexity */ function $5eeb4a2055f93228$var$getConstructorName(value) {
    const prototype = Object.getPrototypeOf(value);
    return prototype ? prototype.constructor.name : 'null prototype';
}
/** Calculates bytes size of input string */ function $5eeb4a2055f93228$var$utf8Length(value) {
    // eslint-disable-next-line no-bitwise
    return ~-encodeURI(value).split(/%..|./).length;
}
/** Calculates bytes size of input object */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $5eeb4a2055f93228$var$jsonSize(value) {
    return $5eeb4a2055f93228$var$utf8Length(JSON.stringify(value));
}
/**
 * Normalizes URLs in exceptions and stacktraces to a base path so Sentry can fingerprint
 * across platforms and working directory.
 *
 * @param url The URL to be normalized.
 * @param basePath The application base path.
 * @returns The normalized URL.
 */ function $5eeb4a2055f93228$export$472b29734be05be3(url, basePath) {
    const escapedBase = basePath// Backslash to forward
    .replace(/\\/g, '/')// Escape RegExp special characters
    .replace(/[|\\{}()[\]^$+*?.]/g, '\\$&');
    let newUrl = url;
    try {
        newUrl = decodeURI(url);
    } catch (_Oo) {
    // Sometime this breaks
    }
    return newUrl.replace(/\\/g, '/').replace(/webpack:\/?/g, '') // Remove intermediate base path
    // eslint-disable-next-line @sentry-internal/sdk/no-regexp-constructor
    .replace(new RegExp(`(file://)?/*${escapedBase}/*`, 'ig'), 'app:///');
}

});
parcelRegister("f89cW", function(module, exports) {

$parcel$export(module.exports, "memoBuilder", () => $b03ebed4065d8abe$export$8115b0b78e956ab3);
/* eslint-disable @typescript-eslint/no-unsafe-member-access */ /* eslint-disable @typescript-eslint/no-explicit-any */ /**
 * Helper to decycle json objects
 */ function $b03ebed4065d8abe$export$8115b0b78e956ab3() {
    const hasWeakSet = typeof WeakSet === 'function';
    const inner = hasWeakSet ? new WeakSet() : [];
    function memoize(obj) {
        if (hasWeakSet) {
            if (inner.has(obj)) return true;
            inner.add(obj);
            return false;
        }
        // eslint-disable-next-line @typescript-eslint/prefer-for-of
        for(let i = 0; i < inner.length; i++){
            const value = inner[i];
            if (value === obj) return true;
        }
        inner.push(obj);
        return false;
    }
    function unmemoize(obj) {
        if (hasWeakSet) inner.delete(obj);
        else {
            for(let i = 0; i < inner.length; i++)if (inner[i] === obj) {
                inner.splice(i, 1);
                break;
            }
        }
    }
    return [
        memoize,
        unmemoize
    ];
}

});

parcelRegister("2Uu4G", function(module, exports) {

$parcel$export(module.exports, "getFunctionName", () => $21e823e6938084e0$export$aad197c7121a6651);

var $iRIIh = parcelRequire("iRIIh");
const $21e823e6938084e0$var$STACKTRACE_FRAME_LIMIT = 50;
// Used to sanitize webpack (error: *) wrapped stack errors
const $21e823e6938084e0$var$WEBPACK_ERROR_REGEXP = /\(error: (.*)\)/;
const $21e823e6938084e0$var$STRIP_FRAME_REGEXP = /captureMessage|captureException/;
/**
 * Creates a stack parser with the supplied line parsers
 *
 * StackFrames are returned in the correct order for Sentry Exception
 * frames and with Sentry SDK internal frames removed from the top and bottom
 *
 */ function $21e823e6938084e0$export$a5739666fb2d03d4(...parsers) {
    const sortedParsers = parsers.sort((a, b)=>a[0] - b[0]).map((p)=>p[1]);
    return (stack, skipFirst = 0)=>{
        const frames = [];
        const lines = stack.split('\n');
        for(let i = skipFirst; i < lines.length; i++){
            const line = lines[i];
            // Ignore lines over 1kb as they are unlikely to be stack frames.
            // Many of the regular expressions use backtracking which results in run time that increases exponentially with
            // input size. Huge strings can result in hangs/Denial of Service:
            // https://github.com/getsentry/sentry-javascript/issues/2286
            if (line.length > 1024) continue;
            // https://github.com/getsentry/sentry-javascript/issues/5459
            // Remove webpack (error: *) wrappers
            const cleanedLine = $21e823e6938084e0$var$WEBPACK_ERROR_REGEXP.test(line) ? line.replace($21e823e6938084e0$var$WEBPACK_ERROR_REGEXP, '$1') : line;
            // https://github.com/getsentry/sentry-javascript/issues/7813
            // Skip Error: lines
            if (cleanedLine.match(/\S*Error: /)) continue;
            for (const parser of sortedParsers){
                const frame = parser(cleanedLine);
                if (frame) {
                    frames.push(frame);
                    break;
                }
            }
            if (frames.length >= $21e823e6938084e0$var$STACKTRACE_FRAME_LIMIT) break;
        }
        return $21e823e6938084e0$export$c55c24c0eeba0205(frames);
    };
}
/**
 * Gets a stack parser implementation from Options.stackParser
 * @see Options
 *
 * If options contains an array of line parsers, it is converted into a parser
 */ function $21e823e6938084e0$export$1d5cf88b347146d4(stackParser) {
    if (Array.isArray(stackParser)) return $21e823e6938084e0$export$a5739666fb2d03d4(...stackParser);
    return stackParser;
}
/**
 * Removes Sentry frames from the top and bottom of the stack if present and enforces a limit of max number of frames.
 * Assumes stack input is ordered from top to bottom and returns the reverse representation so call site of the
 * function that caused the crash is the last frame in the array.
 * @hidden
 */ function $21e823e6938084e0$export$c55c24c0eeba0205(stack) {
    if (!stack.length) return [];
    const localStack = Array.from(stack);
    // If stack starts with one of our API calls, remove it (starts, meaning it's the top of the stack - aka last call)
    if (/sentryWrapped/.test(localStack[localStack.length - 1].function || '')) localStack.pop();
    // Reversing in the middle of the procedure allows us to just pop the values off the stack
    localStack.reverse();
    // If stack ends with one of our internal API calls, remove it (ends, meaning it's the bottom of the stack - aka top-most call)
    if ($21e823e6938084e0$var$STRIP_FRAME_REGEXP.test(localStack[localStack.length - 1].function || '')) {
        localStack.pop();
        // When using synthetic events, we will have a 2 levels deep stack, as `new Error('Sentry syntheticException')`
        // is produced within the hub itself, making it:
        //
        //   Sentry.captureException()
        //   getCurrentHub().captureException()
        //
        // instead of just the top `Sentry` call itself.
        // This forces us to possibly strip an additional frame in the exact same was as above.
        if ($21e823e6938084e0$var$STRIP_FRAME_REGEXP.test(localStack[localStack.length - 1].function || '')) localStack.pop();
    }
    return localStack.slice(0, $21e823e6938084e0$var$STACKTRACE_FRAME_LIMIT).map((frame)=>({
            ...frame,
            filename: frame.filename || localStack[localStack.length - 1].filename,
            function: frame.function || '?'
        }));
}
const $21e823e6938084e0$var$defaultFunctionName = '<anonymous>';
/**
 * Safely extract function name from itself
 */ function $21e823e6938084e0$export$aad197c7121a6651(fn) {
    try {
        if (!fn || typeof fn !== 'function') return $21e823e6938084e0$var$defaultFunctionName;
        return fn.name || $21e823e6938084e0$var$defaultFunctionName;
    } catch (e) {
        // Just accessing custom props in some Selenium environments
        // can cause a "Permission denied" exception (see raven-js#495).
        return $21e823e6938084e0$var$defaultFunctionName;
    }
}
/**
 * Node.js stack line parser
 *
 * This is in @sentry/utils so it can be used from the Electron SDK in the browser for when `nodeIntegration == true`.
 * This allows it to be used without referencing or importing any node specific code which causes bundlers to complain
 */ function $21e823e6938084e0$export$673345a0da635a78(getModule) {
    return [
        90,
        (0, $iRIIh.node)(getModule)
    ];
}

});
parcelRegister("iRIIh", function(module, exports) {

$parcel$export(module.exports, "node", () => $dbbfdc5cd2007385$export$35059013cd4a06db);
/**
 * Does this filename look like it's part of the app code?
 */ function $dbbfdc5cd2007385$export$1de92f38f4de99a8(filename, isNative = false) {
    const isInternal = isNative || filename && // It's not internal if it's an absolute linux path
    !filename.startsWith('/') && // It's not internal if it's an absolute windows path
    !filename.match(/^[A-Z]:/) && // It's not internal if the path is starting with a dot
    !filename.startsWith('.') && // It's not internal if the frame has a protocol. In node, this is usually the case if the file got pre-processed with a bundler like webpack
    !filename.match(/^[a-zA-Z]([a-zA-Z0-9.\-+])*:\/\//); // Schema from: https://stackoverflow.com/a/3641782
    // in_app is all that's not an internal Node function or a module within node_modules
    // note that isNative appears to return true even for node core libraries
    // see https://github.com/getsentry/raven-node/issues/176
    return !isInternal && filename !== undefined && !filename.includes('node_modules/');
}
/** Node Stack line parser */ // eslint-disable-next-line complexity
function $dbbfdc5cd2007385$export$35059013cd4a06db(getModule) {
    const FILENAME_MATCH = /^\s*[-]{4,}$/;
    const FULL_MATCH = /at (?:async )?(?:(.+?)\s+\()?(?:(.+):(\d+):(\d+)?|([^)]+))\)?/;
    // eslint-disable-next-line complexity
    return (line)=>{
        const lineMatch = line.match(FULL_MATCH);
        if (lineMatch) {
            let object;
            let method;
            let functionName;
            let typeName;
            let methodName;
            if (lineMatch[1]) {
                functionName = lineMatch[1];
                let methodStart = functionName.lastIndexOf('.');
                if (functionName[methodStart - 1] === '.') methodStart--;
                if (methodStart > 0) {
                    object = functionName.slice(0, methodStart);
                    method = functionName.slice(methodStart + 1);
                    const objectEnd = object.indexOf('.Module');
                    if (objectEnd > 0) {
                        functionName = functionName.slice(objectEnd + 1);
                        object = object.slice(0, objectEnd);
                    }
                }
                typeName = undefined;
            }
            if (method) {
                typeName = object;
                methodName = method;
            }
            if (method === '<anonymous>') {
                methodName = undefined;
                functionName = undefined;
            }
            if (functionName === undefined) {
                methodName = methodName || '<anonymous>';
                functionName = typeName ? `${typeName}.${methodName}` : methodName;
            }
            let filename = lineMatch[2] && lineMatch[2].startsWith('file://') ? lineMatch[2].slice(7) : lineMatch[2];
            const isNative = lineMatch[5] === 'native';
            // If it's a Windows path, trim the leading slash so that `/C:/foo` becomes `C:/foo`
            if (filename && filename.match(/\/[A-Z]:/)) filename = filename.slice(1);
            if (!filename && lineMatch[5] && !isNative) filename = lineMatch[5];
            return {
                filename: filename,
                module: getModule ? getModule(filename) : undefined,
                function: functionName,
                lineno: parseInt(lineMatch[3], 10) || undefined,
                colno: parseInt(lineMatch[4], 10) || undefined,
                in_app: $dbbfdc5cd2007385$export$1de92f38f4de99a8(filename, isNative)
            };
        }
        if (line.match(FILENAME_MATCH)) return {
            filename: line
        };
        return undefined;
    };
}

});





parcelRegister("9iGPP", function(module, exports) {

$parcel$export(module.exports, "convertIntegrationFnToClass", () => $6c5705a00605a48e$export$afa219bf23651160);
$parcel$export(module.exports, "defineIntegration", () => $6c5705a00605a48e$export$2323046b9414659f);

var $dcmwb = parcelRequire("dcmwb");
var $dcNCf = parcelRequire("dcNCf");

var $eblj3 = parcelRequire("eblj3");

var $kB5Xz = parcelRequire("kB5Xz");

var $S1tY7 = parcelRequire("S1tY7");

var $5x0VR = parcelRequire("5x0VR");
const $6c5705a00605a48e$export$b14a8888f80a0b3e = [];
/** Map of integrations assigned to a client */ /**
 * Remove duplicates from the given array, preferring the last instance of any duplicate. Not guaranteed to
 * preseve the order of integrations in the array.
 *
 * @private
 */ function $6c5705a00605a48e$var$filterDuplicates(integrations) {
    const integrationsByName = {};
    integrations.forEach((currentInstance)=>{
        const { name: name } = currentInstance;
        const existingInstance = integrationsByName[name];
        // We want integrations later in the array to overwrite earlier ones of the same type, except that we never want a
        // default instance to overwrite an existing user instance
        if (existingInstance && !existingInstance.isDefaultInstance && currentInstance.isDefaultInstance) return;
        integrationsByName[name] = currentInstance;
    });
    return Object.keys(integrationsByName).map((k)=>integrationsByName[k]);
}
/** Gets integrations to install */ function $6c5705a00605a48e$export$68bc4c01ab8ae766(options) {
    const defaultIntegrations = options.defaultIntegrations || [];
    const userIntegrations = options.integrations;
    // We flag default instances, so that later we can tell them apart from any user-created instances of the same class
    defaultIntegrations.forEach((integration)=>{
        integration.isDefaultInstance = true;
    });
    let integrations;
    if (Array.isArray(userIntegrations)) integrations = [
        ...defaultIntegrations,
        ...userIntegrations
    ];
    else if (typeof userIntegrations === 'function') integrations = (0, $dcmwb.arrayify)(userIntegrations(defaultIntegrations));
    else integrations = defaultIntegrations;
    const finalIntegrations = $6c5705a00605a48e$var$filterDuplicates(integrations);
    // The `Debug` integration prints copies of the `event` and `hint` which will be passed to `beforeSend` or
    // `beforeSendTransaction`. It therefore has to run after all other integrations, so that the changes of all event
    // processors will be reflected in the printed values. For lack of a more elegant way to guarantee that, we therefore
    // locate it and, assuming it exists, pop it out of its current spot and shove it onto the end of the array.
    const debugIndex = $6c5705a00605a48e$var$findIndex(finalIntegrations, (integration)=>integration.name === 'Debug');
    if (debugIndex !== -1) {
        const [debugInstance] = finalIntegrations.splice(debugIndex, 1);
        finalIntegrations.push(debugInstance);
    }
    return finalIntegrations;
}
/**
 * Given a list of integration instances this installs them all. When `withDefaults` is set to `true` then all default
 * integrations are added unless they were already provided before.
 * @param integrations array of integration instances
 * @param withDefault should enable default integrations
 */ function $6c5705a00605a48e$export$51abed9797baa598(client, integrations) {
    const integrationIndex = {};
    integrations.forEach((integration)=>{
        // guard against empty provided integrations
        if (integration) $6c5705a00605a48e$export$e7390a03b70a6f2f(client, integration, integrationIndex);
    });
    return integrationIndex;
}
/**
 * Execute the `afterAllSetup` hooks of the given integrations.
 */ function $6c5705a00605a48e$export$35abcfd71227c6ca(client, integrations) {
    for (const integration of integrations)// guard against empty provided integrations
    if (integration && integration.afterAllSetup) integration.afterAllSetup(client);
}
/** Setup a single integration.  */ function $6c5705a00605a48e$export$e7390a03b70a6f2f(client, integration, integrationIndex) {
    if (integrationIndex[integration.name]) {
        (0, $eblj3.DEBUG_BUILD) && (0, $dcNCf.logger).log(`Integration skipped because it was already installed: ${integration.name}`);
        return;
    }
    integrationIndex[integration.name] = integration;
    // `setupOnce` is only called the first time
    if ($6c5705a00605a48e$export$b14a8888f80a0b3e.indexOf(integration.name) === -1) {
        // eslint-disable-next-line deprecation/deprecation
        integration.setupOnce((0, $kB5Xz.addGlobalEventProcessor), (0, $5x0VR.getCurrentHub));
        $6c5705a00605a48e$export$b14a8888f80a0b3e.push(integration.name);
    }
    // `setup` is run for each client
    if (integration.setup && typeof integration.setup === 'function') integration.setup(client);
    if (client.on && typeof integration.preprocessEvent === 'function') {
        const callback = integration.preprocessEvent.bind(integration);
        client.on('preprocessEvent', (event, hint)=>callback(event, hint, client));
    }
    if (client.addEventProcessor && typeof integration.processEvent === 'function') {
        const callback = integration.processEvent.bind(integration);
        const processor = Object.assign((event, hint)=>callback(event, hint, client), {
            id: integration.name
        });
        client.addEventProcessor(processor);
    }
    (0, $eblj3.DEBUG_BUILD) && (0, $dcNCf.logger).log(`Integration installed: ${integration.name}`);
}
/** Add an integration to the current hub's client. */ function $6c5705a00605a48e$export$2d8f5188773bcddd(integration) {
    const client = (0, $S1tY7.getClient)();
    if (!client || !client.addIntegration) {
        (0, $eblj3.DEBUG_BUILD) && (0, $dcNCf.logger).warn(`Cannot add integration "${integration.name}" because no SDK Client is available.`);
        return;
    }
    client.addIntegration(integration);
}
// Polyfill for Array.findIndex(), which is not supported in ES5
function $6c5705a00605a48e$var$findIndex(arr, callback) {
    for(let i = 0; i < arr.length; i++){
        if (callback(arr[i]) === true) return i;
    }
    return -1;
}
/**
 * Convert a new integration function to the legacy class syntax.
 * In v8, we can remove this and instead export the integration functions directly.
 *
 * @deprecated This will be removed in v8!
 */ function $6c5705a00605a48e$export$afa219bf23651160(name, fn) {
    return Object.assign(function ConvertedIntegration(...args) {
        return fn(...args);
    }, {
        id: name
    });
}
/**
 * Define an integration function that can be used to create an integration instance.
 * Note that this by design hides the implementation details of the integration, as they are considered internal.
 */ function $6c5705a00605a48e$export$2323046b9414659f(fn) {
    return fn;
}

});

parcelRegister("3iKOl", function(module, exports) {

$parcel$export(module.exports, "addConsoleInstrumentationHandler", () => $26775d3deb464ef7$export$1d6e0d073f9e6723);

var $dcNCf = parcelRequire("dcNCf");

var $fGLXA = parcelRequire("fGLXA");

var $7cDym = parcelRequire("7cDym");

var $g9e1j = parcelRequire("g9e1j");
/**
 * Add an instrumentation handler for when a console.xxx method is called.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $26775d3deb464ef7$export$1d6e0d073f9e6723(handler) {
    const type = 'console';
    (0, $g9e1j.addHandler)(type, handler);
    (0, $g9e1j.maybeInstrument)(type, $26775d3deb464ef7$var$instrumentConsole);
}
function $26775d3deb464ef7$var$instrumentConsole() {
    if (!('console' in (0, $7cDym.GLOBAL_OBJ))) return;
    (0, $dcNCf.CONSOLE_LEVELS).forEach(function(level) {
        if (!(level in (0, $7cDym.GLOBAL_OBJ).console)) return;
        (0, $fGLXA.fill)((0, $7cDym.GLOBAL_OBJ).console, level, function(originalConsoleMethod) {
            (0, $dcNCf.originalConsoleMethods)[level] = originalConsoleMethod;
            return function(...args) {
                const handlerData = {
                    args: args,
                    level: level
                };
                (0, $g9e1j.triggerHandlers)('console', handlerData);
                const log = (0, $dcNCf.originalConsoleMethods)[level];
                log && log.apply((0, $7cDym.GLOBAL_OBJ).console, args);
            };
        });
    });
}

});
parcelRegister("g9e1j", function(module, exports) {

$parcel$export(module.exports, "addHandler", () => $bc185cb8102f0e10$export$a4e09611e30da72e);
$parcel$export(module.exports, "maybeInstrument", () => $bc185cb8102f0e10$export$e18d6c5462c01368);
$parcel$export(module.exports, "triggerHandlers", () => $bc185cb8102f0e10$export$b18c893e424d3127);

var $hIqTc = parcelRequire("hIqTc");

var $dcNCf = parcelRequire("dcNCf");

var $2Uu4G = parcelRequire("2Uu4G");
// We keep the handlers globally
const $bc185cb8102f0e10$var$handlers = {};
const $bc185cb8102f0e10$var$instrumented = {};
/** Add a handler function. */ function $bc185cb8102f0e10$export$a4e09611e30da72e(type, handler) {
    $bc185cb8102f0e10$var$handlers[type] = $bc185cb8102f0e10$var$handlers[type] || [];
    $bc185cb8102f0e10$var$handlers[type].push(handler);
}
/**
 * Reset all instrumentation handlers.
 * This can be used by tests to ensure we have a clean slate of instrumentation handlers.
 */ function $bc185cb8102f0e10$export$b17eab759a1cb5fe() {
    Object.keys($bc185cb8102f0e10$var$handlers).forEach((key)=>{
        $bc185cb8102f0e10$var$handlers[key] = undefined;
    });
}
/** Maybe run an instrumentation function, unless it was already called. */ function $bc185cb8102f0e10$export$e18d6c5462c01368(type, instrumentFn) {
    if (!$bc185cb8102f0e10$var$instrumented[type]) {
        instrumentFn();
        $bc185cb8102f0e10$var$instrumented[type] = true;
    }
}
/** Trigger handlers for a given instrumentation type. */ function $bc185cb8102f0e10$export$b18c893e424d3127(type, data) {
    const typeHandlers = type && $bc185cb8102f0e10$var$handlers[type];
    if (!typeHandlers) return;
    for (const handler of typeHandlers)try {
        handler(data);
    } catch (e) {
        (0, $hIqTc.DEBUG_BUILD) && (0, $dcNCf.logger).error(`Error while triggering instrumentation handler.\nType: ${type}\nName: ${(0, $2Uu4G.getFunctionName)(handler)}\nError:`, e);
    }
}

});


parcelRegister("8VUti", function(module, exports) {

$parcel$export(module.exports, "severityLevelFromString", () => $680f73a6124d4a5e$export$d771ef054122c30a);
// Note: Ideally the `SeverityLevel` type would be derived from `validSeverityLevels`, but that would mean either
//
// a) moving `validSeverityLevels` to `@sentry/types`,
// b) moving the`SeverityLevel` type here, or
// c) importing `validSeverityLevels` from here into `@sentry/types`.
//
// Option A would make `@sentry/types` a runtime dependency of `@sentry/utils` (not good), and options B and C would
// create a circular dependency between `@sentry/types` and `@sentry/utils` (also not good). So a TODO accompanying the
// type, reminding anyone who changes it to change this list also, will have to do.
const $680f73a6124d4a5e$export$411d0ffdba845b6c = [
    'fatal',
    'error',
    'warning',
    'log',
    'info',
    'debug'
];
/**
 * Converts a string-based level into a member of the deprecated {@link Severity} enum.
 *
 * @deprecated `severityFromString` is deprecated. Please use `severityLevelFromString` instead.
 *
 * @param level String representation of Severity
 * @returns Severity
 */ function $680f73a6124d4a5e$export$e01cef29b4327697(level) {
    return $680f73a6124d4a5e$export$d771ef054122c30a(level);
}
/**
 * Converts a string-based level into a `SeverityLevel`, normalizing it along the way.
 *
 * @param level String representation of desired `SeverityLevel`.
 * @returns The `SeverityLevel` corresponding to the given string, or 'log' if the string isn't a valid level.
 */ function $680f73a6124d4a5e$export$d771ef054122c30a(level) {
    return level === 'warn' ? 'warning' : $680f73a6124d4a5e$export$411d0ffdba845b6c.includes(level) ? level : 'log';
}

});

parcelRegister("gBN4z", function(module, exports) {

$parcel$export(module.exports, "relative", () => $c1762ad6d98cfe37$export$f0e7d1106eeabbe6);
$parcel$export(module.exports, "basename", () => $c1762ad6d98cfe37$export$9bf319d8f74f51d1);
// Slightly modified (no IE8 support, ES6) and transcribed to TypeScript
// https://github.com/calvinmetcalf/rollup-plugin-node-builtins/blob/63ab8aacd013767445ca299e468d9a60a95328d7/src/es6/path.js
//
// Copyright Joyent, Inc.and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
/** JSDoc */ function $c1762ad6d98cfe37$var$normalizeArray(parts, allowAboveRoot) {
    // if the path tries to go above the root, `up` ends up > 0
    let up = 0;
    for(let i = parts.length - 1; i >= 0; i--){
        const last = parts[i];
        if (last === '.') parts.splice(i, 1);
        else if (last === '..') {
            parts.splice(i, 1);
            up++;
        } else if (up) {
            parts.splice(i, 1);
            up--;
        }
    }
    // if the path is allowed to go above the root, restore leading ..s
    if (allowAboveRoot) for(; up--; up)parts.unshift('..');
    return parts;
}
// Split a filename into [root, dir, basename, ext], unix version
// 'root' is just a slash, or nothing.
const $c1762ad6d98cfe37$var$splitPathRe = /^(\S+:\\|\/?)([\s\S]*?)((?:\.{1,2}|[^/\\]+?|)(\.[^./\\]*|))(?:[/\\]*)$/;
/** JSDoc */ function $c1762ad6d98cfe37$var$splitPath(filename) {
    // Truncate files names greater than 1024 characters to avoid regex dos
    // https://github.com/getsentry/sentry-javascript/pull/8737#discussion_r1285719172
    const truncated = filename.length > 1024 ? `<truncated>${filename.slice(-1024)}` : filename;
    const parts = $c1762ad6d98cfe37$var$splitPathRe.exec(truncated);
    return parts ? parts.slice(1) : [];
}
// path.resolve([from ...], to)
// posix version
/** JSDoc */ function $c1762ad6d98cfe37$export$f7ad0328861e2f03(...args) {
    let resolvedPath = '';
    let resolvedAbsolute = false;
    for(let i = args.length - 1; i >= -1 && !resolvedAbsolute; i--){
        const path = i >= 0 ? args[i] : '/';
        // Skip empty entries
        if (!path) continue;
        resolvedPath = `${path}/${resolvedPath}`;
        resolvedAbsolute = path.charAt(0) === '/';
    }
    // At this point the path should be resolved to a full absolute path, but
    // handle relative paths to be safe (might happen when process.cwd() fails)
    // Normalize the path
    resolvedPath = $c1762ad6d98cfe37$var$normalizeArray(resolvedPath.split('/').filter((p)=>!!p), !resolvedAbsolute).join('/');
    return (resolvedAbsolute ? '/' : '') + resolvedPath || '.';
}
/** JSDoc */ function $c1762ad6d98cfe37$var$trim(arr) {
    let start = 0;
    for(; start < arr.length; start++){
        if (arr[start] !== '') break;
    }
    let end = arr.length - 1;
    for(; end >= 0; end--){
        if (arr[end] !== '') break;
    }
    if (start > end) return [];
    return arr.slice(start, end - start + 1);
}
// path.relative(from, to)
// posix version
/** JSDoc */ function $c1762ad6d98cfe37$export$f0e7d1106eeabbe6(from, to) {
    /* eslint-disable no-param-reassign */ from = $c1762ad6d98cfe37$export$f7ad0328861e2f03(from).slice(1);
    to = $c1762ad6d98cfe37$export$f7ad0328861e2f03(to).slice(1);
    /* eslint-enable no-param-reassign */ const fromParts = $c1762ad6d98cfe37$var$trim(from.split('/'));
    const toParts = $c1762ad6d98cfe37$var$trim(to.split('/'));
    const length = Math.min(fromParts.length, toParts.length);
    let samePartsLength = length;
    for(let i = 0; i < length; i++)if (fromParts[i] !== toParts[i]) {
        samePartsLength = i;
        break;
    }
    let outputParts = [];
    for(let i = samePartsLength; i < fromParts.length; i++)outputParts.push('..');
    outputParts = outputParts.concat(toParts.slice(samePartsLength));
    return outputParts.join('/');
}
// path.normalize(path)
// posix version
/** JSDoc */ function $c1762ad6d98cfe37$export$6af368f973c74c5(path) {
    const isPathAbsolute = $c1762ad6d98cfe37$export$e434c7255acda994(path);
    const trailingSlash = path.slice(-1) === '/';
    // Normalize the path
    let normalizedPath = $c1762ad6d98cfe37$var$normalizeArray(path.split('/').filter((p)=>!!p), !isPathAbsolute).join('/');
    if (!normalizedPath && !isPathAbsolute) normalizedPath = '.';
    if (normalizedPath && trailingSlash) normalizedPath += '/';
    return (isPathAbsolute ? '/' : '') + normalizedPath;
}
// posix version
/** JSDoc */ function $c1762ad6d98cfe37$export$e434c7255acda994(path) {
    return path.charAt(0) === '/';
}
// posix version
/** JSDoc */ function $c1762ad6d98cfe37$export$f7e2c8231c57a8bd(...args) {
    return $c1762ad6d98cfe37$export$6af368f973c74c5(args.join('/'));
}
/** JSDoc */ function $c1762ad6d98cfe37$export$7f7b8152cc673abe(path) {
    const result = $c1762ad6d98cfe37$var$splitPath(path);
    const root = result[0];
    let dir = result[1];
    if (!root && !dir) // No dirname whatsoever
    return '.';
    if (dir) // It has a dirname, strip trailing slash
    dir = dir.slice(0, dir.length - 1);
    return root + dir;
}
/** JSDoc */ function $c1762ad6d98cfe37$export$9bf319d8f74f51d1(path, ext) {
    let f = $c1762ad6d98cfe37$var$splitPath(path)[2];
    if (ext && f.slice(ext.length * -1) === ext) f = f.slice(0, f.length - ext.length);
    return f;
}

});

parcelRegister("cv2et", function(module, exports) {

$parcel$export(module.exports, "default", () => $6456f5f0ce9d0241$export$2e2bcd8739ae039);
$parcel$export(module.exports, "useInteractionContext", () => $6456f5f0ce9d0241$export$11bcb6e9af2aca35);

var $eJOHy = parcelRequire("eJOHy");

var $ih0uO = parcelRequire("ih0uO");
var $6456f5f0ce9d0241$export$2e2bcd8739ae039 = (0, $ih0uO.default);
function $6456f5f0ce9d0241$export$11bcb6e9af2aca35() {
    return (0, $eJOHy.useContext)((0, $ih0uO.default));
}

});

parcelRegister("gC446", function(module, exports) {

$parcel$export(module.exports, "browserMetrics", () => $dbe210d940cbf29c$export$c08e7affcf78b064);

var $acpUf = parcelRequire("acpUf");

var $kDaME = parcelRequire("kDaME");

var $lezfJ = parcelRequire("lezfJ");

var $fRmN8 = parcelRequire("fRmN8");

var $aE7dm = parcelRequire("aE7dm");

var $fKqpR = parcelRequire("fKqpR");

var $5gTHh = parcelRequire("5gTHh");

var $5zeHM = parcelRequire("5zeHM");
const $dbe210d940cbf29c$var$makeBrowserMetrics = ()=>{
    const bm = {
        init (config) {
            (0, $fRmN8.visibilityChangeObserver).start();
            if (config.events[(0, $5zeHM.BMEventsType).WEB_VITALS]?.enabled) (0, $aE7dm.webVitalsObserver).start();
            if (config.debug) {
                (0, $kDaME.logger).enable();
                (0, $5gTHh.submitter).setDebug(true);
                (0, $lezfJ.pageLoadMetaMetric).setDebug(true);
            }
            (0, $5gTHh.submitter).configure(config);
            if (config.ssr?.getDoneMark) (0, $acpUf.SSRGetDoneMark).setGetDoneMark(config.ssr.getDoneMark);
        },
        setRoute (newRoute) {
            (0, $fKqpR.Route).setRoute(newRoute);
        },
        startPageLoad (params) {
            (0, $lezfJ.pageLoadMetaMetric).startPageLoad({
                isInitial: false,
                cancelStarted: true,
                ...params
            });
        },
        getPageLoadMetric () {
            return 0, $lezfJ.pageLoadMetaMetric;
        },
        experimental__addPageLoadTimingFromPerformanceMarks (name, startMark, stopMark, initialOnly = true) {
            if (initialOnly && !(0, $lezfJ.pageLoadMetaMetric).isInitialLoad()) return;
            const start = performance.getEntriesByName(startMark);
            const stop = performance.getEntriesByName(stopMark);
            if (start.length > 0 && stop.length > 0) {
                if ((0, $lezfJ.pageLoadMetaMetric).isDebugMode()) try {
                    performance.measure(name, startMark, stopMark);
                } catch (e) {}
                const pageLoadData = (0, $lezfJ.pageLoadMetaMetric).getData();
                if (pageLoadData.start !== null) {
                    const startMark = start[start.length - 1];
                    const timing = {
                        startTime: Math.round(startMark.startTime - pageLoadData.start),
                        duration: Math.round(stop[stop.length - 1].startTime - startMark.startTime)
                    };
                    (0, $lezfJ.pageLoadMetaMetric).experimental__addExplicitTiming(name, timing);
                }
            }
        }
    };
    return bm;
};
const $dbe210d940cbf29c$export$c08e7affcf78b064 = $dbe210d940cbf29c$var$makeBrowserMetrics();

});
parcelRegister("acpUf", function(module, exports) {

$parcel$export(module.exports, "SSRGetDoneMark", () => $79d97f6ca8be0a4a$export$9e87a201397ac0a9);
const $79d97f6ca8be0a4a$export$9e87a201397ac0a9 = {
    getDoneMark: ()=>null,
    setGetDoneMark: (fn)=>{
        $79d97f6ca8be0a4a$export$9e87a201397ac0a9.getDoneMark = fn;
    }
};

});

parcelRegister("kDaME", function(module, exports) {

$parcel$export(module.exports, "logger", () => $3f7360cca3d3be8d$export$af88d00dbe7f521);
const $3f7360cca3d3be8d$export$af88d00dbe7f521 = {
    enabled: false,
    enable () {
        this.enabled = true;
    },
    log (...args) {
        if (this.enabled) // eslint-disable-next-line no-console
        console.log('BM log: ', ...args);
    },
    logCond (condition, ...args) {
        if (this.enabled && condition && args.length > 1) this.log(...args);
    }
};

});

parcelRegister("lezfJ", function(module, exports) {

$parcel$export(module.exports, "pageLoadMetaMetric", () => $734731fd353cb036$export$24b7a1a311eb05dc);

var $5zeHM = parcelRequire("5zeHM");

var $bRM2E = parcelRequire("bRM2E");

var $b1CcL = parcelRequire("b1CcL");
class $734731fd353cb036$export$9609608c00ea5077 extends (0, $b1CcL.BasePageLoadMetric) {
    startPageLoad({ cancelStarted: cancelStarted, ...startPageLoadParams } = {
        isInitial: false,
        cancelStarted: false
    }) {
        if (cancelStarted || this.state !== (0, $bRM2E.MetricState).STARTED) super.startPageLoad(startPageLoadParams);
    }
    setActive(metric) {
        this.activePageLoadMetric = metric;
    }
    setDebug(debug) {
        this.config.debug = debug;
    }
    isDebugMode() {
        return this.config.debug;
    }
    isInitialLoad() {
        return this.isInitial;
    }
    clear() {
        this.activePageLoadMetric && this.activePageLoadMetric.cancel();
        super.clear();
    }
    include(metric) {
        if (!this.config.include) this.config.include = [
            metric
        ];
        else this.config.include.push(metric);
    }
    experimental__addExplicitTiming(name, timing) {
        if (this.explicitTimings === null) this.explicitTimings = {};
        this.explicitTimings[name] = timing;
    }
    constructor(...args){
        super(...args), this.activePageLoadMetric = null;
    }
}
const $734731fd353cb036$export$24b7a1a311eb05dc = new $734731fd353cb036$export$9609608c00ea5077({
    type: (0, $5zeHM.BMEventsType).PAGE_LOAD,
    key: 'page_load_meta_metric'
});

});
parcelRegister("5zeHM", function(module, exports) {

$parcel$export(module.exports, "BMEventsType", () => $e21732f3c639e2f5$export$9c73e297d4be9159);
$parcel$export(module.exports, "StorableBMEventsType", () => $e21732f3c639e2f5$export$9b7037ec30489597);
$parcel$export(module.exports, "BMPageLoadMetrics", () => $e21732f3c639e2f5$export$74c1fb0997d51e2a);
$parcel$export(module.exports, "BMPageSegmentLoadMetrics", () => $e21732f3c639e2f5$export$88195ac8200d03a6);
$parcel$export(module.exports, "BMInteractionMetrics", () => $e21732f3c639e2f5$export$6e28252a002afdb2);
$parcel$export(module.exports, "PageSegmentPageLoadMetricsOptions", () => $e21732f3c639e2f5$export$474154836bfd8dd9);
$parcel$export(module.exports, "PageVisibleFields", () => $e21732f3c639e2f5$export$e89802082dab5633);
$parcel$export(module.exports, "PageVisibleValueOrigin", () => $e21732f3c639e2f5$export$983b017156c2aee2);
$parcel$export(module.exports, "isDetailedPageLoadSlo", () => $e21732f3c639e2f5$export$5866f95702a15142);
$parcel$export(module.exports, "isDetailedPageSegmentLoadSlo", () => $e21732f3c639e2f5$export$f087a59bd717e49d);
$parcel$export(module.exports, "isInteractionMetricsSlo", () => $e21732f3c639e2f5$export$b10c1d9a7db7765b);
$parcel$export(module.exports, "IncludeSSRFeatureFlagsConfig", () => $e21732f3c639e2f5$export$60c0193054fc3040);

var $bRM2E = parcelRequire("bRM2E");
var $e21732f3c639e2f5$export$9c73e297d4be9159 = /*#__PURE__*/ function(BMEventsType) {
    BMEventsType["PAGE_LOAD"] = "PAGE_LOAD";
    BMEventsType["PAGE_SEGMENT_LOAD"] = "PAGE_SEGMENT_LOAD";
    BMEventsType["INLINE_RESULT"] = "INLINE_RESULT";
    BMEventsType["CUSTOM"] = "CUSTOM";
    BMEventsType["WEB_VITALS"] = "WEB_VITALS";
    return BMEventsType;
}({});
var $e21732f3c639e2f5$export$9b7037ec30489597 = /*#__PURE__*/ function(StorableBMEventsType) {
    StorableBMEventsType["PAGE_LOAD"] = "page-load";
    StorableBMEventsType["PAGE_SEGMENT_LOAD"] = "page-segment-load";
    StorableBMEventsType["INLINE_RESULT"] = "inline-result";
    StorableBMEventsType["CUSTOM"] = "custom";
    StorableBMEventsType["WEB_VITALS"] = "web-vitals";
    return StorableBMEventsType;
}({});
var $e21732f3c639e2f5$export$74c1fb0997d51e2a = /*#__PURE__*/ function(BMPageLoadMetrics) {
    BMPageLoadMetrics["fmp"] = "fmp";
    BMPageLoadMetrics["tti"] = "tti";
    return BMPageLoadMetrics;
}({});
var $e21732f3c639e2f5$export$88195ac8200d03a6 = /*#__PURE__*/ function(BMPageSegmentLoadMetrics) {
    BMPageSegmentLoadMetrics["fmp"] = "fmp";
    BMPageSegmentLoadMetrics["tti"] = "tti";
    return BMPageSegmentLoadMetrics;
}({});
var $e21732f3c639e2f5$export$6e28252a002afdb2 = /*#__PURE__*/ function(BMInteractionMetrics) {
    BMInteractionMetrics["response"] = "response";
    BMInteractionMetrics["result"] = "result";
    return BMInteractionMetrics;
}({});
var $e21732f3c639e2f5$export$474154836bfd8dd9 = /*#__PURE__*/ function(PageSegmentPageLoadMetricsOptions) {
    PageSegmentPageLoadMetricsOptions["OFF"] = "OFF";
    PageSegmentPageLoadMetricsOptions["IF_PRESENT"] = "IF_PRESENT";
    PageSegmentPageLoadMetricsOptions["WAIT_UNTIL_PRESENT"] = "WAIT_UNTIL_PRESENT";
    return PageSegmentPageLoadMetricsOptions;
}({});
var $e21732f3c639e2f5$export$e89802082dab5633 = /*#__PURE__*/ function(PageVisibleFields) {
    PageVisibleFields["pageVisibleState"] = "page-visible-state";
    PageVisibleFields["pageVisibleValue"] = "page-visible-value";
    return PageVisibleFields;
}({});
var $e21732f3c639e2f5$export$983b017156c2aee2 = /*#__PURE__*/ function(PageVisibleValueOrigin) {
    PageVisibleValueOrigin["documentHidden"] = "document-hidden";
    PageVisibleValueOrigin["pageVisibleState"] = "page-visible-state";
    return PageVisibleValueOrigin;
}({});
const $e21732f3c639e2f5$export$5866f95702a15142 = (data)=>{
    return Boolean(data.initial);
};
const $e21732f3c639e2f5$export$f087a59bd717e49d = (data)=>{
    return Boolean(data.initial);
};
const $e21732f3c639e2f5$export$153c4c72fa5eeece = (data)=>{
    const obj = data;
    return Boolean(obj.fmp !== undefined || obj.tti !== undefined);
};
const $e21732f3c639e2f5$export$b10c1d9a7db7765b = (data)=>{
    const obj = data;
    return Boolean(obj.result !== undefined || obj.response !== undefined);
};
var $e21732f3c639e2f5$export$60c0193054fc3040 = /*#__PURE__*/ function(IncludeSSRFeatureFlagsConfig) {
    IncludeSSRFeatureFlagsConfig["NEVER"] = "never";
    IncludeSSRFeatureFlagsConfig["WHEN_FMP"] = "when-fmp";
    IncludeSSRFeatureFlagsConfig["WHEN_AVAILABLE"] = "when-available";
    return IncludeSSRFeatureFlagsConfig;
}({});

});
parcelRegister("bRM2E", function(module, exports) {

$parcel$export(module.exports, "MetricState", () => $2e31a7146b2b3b48$export$1e458f18c0c7bfe3);
$parcel$export(module.exports, "PageVisibleState", () => $2e31a7146b2b3b48$export$a12c67b37a306b13);
$parcel$export(module.exports, "BaseMetric", () => $2e31a7146b2b3b48$export$2bce4ffdd840e878);

var $h2ifQ = parcelRequire("h2ifQ");

var $kDaME = parcelRequire("kDaME");

var $fRmN8 = parcelRequire("fRmN8");

var $17Tdl = parcelRequire("17Tdl");
var $2e31a7146b2b3b48$export$1e458f18c0c7bfe3 = /*#__PURE__*/ function(MetricState) {
    MetricState["NOT_STARTED"] = "not-started";
    MetricState["STARTED"] = "started";
    MetricState["FINISHED"] = "finished";
    MetricState["CANCELLED"] = "cancelled";
    return MetricState;
}({});
var $2e31a7146b2b3b48$export$a12c67b37a306b13 = /*#__PURE__*/ function(PageVisibleState) {
    PageVisibleState["VISIBLE"] = "visible";
    PageVisibleState["MIXED"] = "mixed";
    PageVisibleState["HIDDEN"] = "hidden";
    return PageVisibleState;
}({});
function $2e31a7146b2b3b48$var$getPageVisibleState() {
    return typeof document !== 'undefined' && document.visibilityState === 'visible' ? "visible" : "hidden";
}
class $2e31a7146b2b3b48$export$2bce4ffdd840e878 {
    static{
        this.FMP = 'fmp';
    }
    constructor(config){
        this.state = "not-started";
        this.startTime = null;
        this.stopTime = null;
        this.marks = {};
        this.onStopCallbacks = [];
        this.custom = null;
        this.submetrics = [];
        this.route = null;
        this.untilOnStopCallback = null;
        this.pageVisibleState = $2e31a7146b2b3b48$var$getPageVisibleState();
        this.setPageVisibleStateToMixed = ()=>{
            this.pageVisibleState = "mixed";
        };
        this.config = config;
        this.key = config.key.replace(/ /gi, '-');
        this.type = config.type;
        this.config.timings?.forEach((entry)=>{
            if ((0, $h2ifQ.restrictedTimingKeys).includes(entry.key)) {
                // eslint-disable-next-line no-console
                console.warn(`Entry ${entry.key} is restricted and has been renamed to custom__${entry.key}`);
                entry.key = `custom__${entry.key}`;
            }
        });
    }
    get untilMetrics() {
        const { until: until } = this.config;
        if (!until) return [];
        else if (Array.isArray(until)) return this.getConfiguredUntilMetricArray(until);
        return this.getConfiguredUntilMetricArray([
            until
        ]);
    }
    start({ startTime: startTime = window.performance.now() } = {}) {
        this.clear();
        (0, $kDaME.logger).logCond(!!this.config.debug, this.key, startTime);
        this.state = "started";
        this.startTime = startTime;
        this.pageVisibleState = $2e31a7146b2b3b48$var$getPageVisibleState();
        (0, $fRmN8.visibilityChangeObserver).subscribe(this.setPageVisibleStateToMixed);
        this.watchUntil();
    }
    stop(stopArguments = {}) {
        const { stopTime: stopTime = window.performance.now() } = stopArguments;
        if (this.state !== "started" || this.startTime === null) {
            (0, $kDaME.logger).log(`metric ${this.config.key} has been stopped while not being started before; current state: ${this.state}`);
            return false;
        }
        if (stopTime < this.startTime) {
            (0, $kDaME.logger).log(`metric ${this.config.key} has been stopped with stopTime lower than startTime; startTime: ${this.startTime}; stopTime: ${stopTime}`);
            return false;
        }
        this.stopTime = stopTime;
        this.state = "finished";
        this.handleStop(stopArguments);
        (0, $fRmN8.visibilityChangeObserver).unsubscribe(this.setPageVisibleStateToMixed);
        return true;
    }
    handleStop(stopArguments) {
        const { customData: customData = null } = stopArguments;
        if (customData) this.custom = {
            ...this.custom,
            ...customData
        };
        this.config.include && this.config.include.forEach((metric)=>{
            const included = metric.getData();
            if (included.state === "finished" && included.start !== null && included.start >= (this.startTime || 0)) this.addSubMetric(metric.getData());
        });
        this.onStopCallbacks.forEach(([success])=>{
            success(stopArguments);
        });
        this.onStopCallbacks = [];
        (0, $kDaME.logger).logCond(!!this.config.debug, this.key, this.config.debug && this.getData());
    }
    mark(mark, timestamp = window.performance.now()) {
        this.marks[mark] = timestamp;
    }
    cancel() {
        if (this.state !== "started") return;
        this.state = "cancelled";
        this.cancelUntil();
        this.onStopCallbacks.forEach(([, cancel])=>{
            cancel();
        });
        this.onStopCallbacks = [];
        (0, $fRmN8.visibilityChangeObserver).unsubscribe(this.setPageVisibleStateToMixed);
    }
    merge(mergeData) {
        this.state = mergeData.state;
        this.pageVisibleState = mergeData.pageVisibleState;
        this.startTime = mergeData.start;
        this.stopTime = mergeData.stop;
        this.marks = {
            ...this.marks,
            ...mergeData.marks
        };
        this.submetrics = [
            ...this.submetrics,
            ...mergeData.submetrics
        ];
        this.onStopCallbacks = [
            ...this.onStopCallbacks,
            ...mergeData.onStopCallbacks
        ];
    }
    onStop(success, cancel) {
        this.onStopCallbacks.push([
            success,
            cancel
        ]);
    }
    removeOnStopCallback(success) {
        const index = this.onStopCallbacks.findIndex(([successCallback])=>{
            return success === successCallback;
        });
        if (index > -1) this.onStopCallbacks.splice(index, 1);
    }
    getData() {
        return {
            key: this.key,
            state: this.state,
            start: this.startTime,
            stop: this.stopTime,
            //todo ranges
            // ranges: this.makeRanges()
            marks: this.marks,
            // todo make copy
            custom: this.custom,
            submetrics: this.submetrics,
            config: this.config,
            route: this.route,
            pageVisibleState: this.pageVisibleState,
            type: this.config.type
        };
    }
    getDataToMerge() {
        return {
            ...this.getData(),
            onStopCallbacks: this.onStopCallbacks
        };
    }
    addSubMetric(data) {
        this.submetrics.push(data);
    }
    /**
	 *
	 * @param metric
	 * The array of Until metrics can be of two types
	 * This function returns an UntilExperience
	 */ getConfiguredUntilMetric(metricOrConfig) {
        return metricOrConfig instanceof $2e31a7146b2b3b48$export$2bce4ffdd840e878 ? (0, $17Tdl.UntilExperience).fromMetric(metricOrConfig) : (0, $17Tdl.UntilExperience).fromConfig(metricOrConfig);
    }
    getConfiguredUntilMetricArray(metricArray) {
        if (!metricArray.length) return [];
        return metricArray.map((metric)=>this.getConfiguredUntilMetric(metric));
    }
    isUntilFinished() {
        return this.untilMetrics.every((metric)=>metric.experience.getData().state === "finished");
    }
    handleAllUntilFinished() {
        // Order by ascending stop time
        const sorted = [
            ...this.untilMetrics
        ].sort((m1, m2)=>{
            return m1.getDependencyStopTime() - m2.getDependencyStopTime();
        });
        // Find the latest page segment to become fully interactive
        const latestFullyInteractiveSegment = [
            ...this.untilMetrics
        ].reduce((currentLatestSegment, metric)=>{
            const currentLatestStopTime = currentLatestSegment?.getFullyInteractiveStopTime() ?? 0;
            const metricStopTime = metric.getFullyInteractiveStopTime() ?? 0;
            return metricStopTime > currentLatestStopTime ? metric : currentLatestSegment;
        }, undefined);
        // Accumulate the custom data from each metric, later metrics take priority
        const accumulatedCustomData = {};
        sorted.forEach((metric)=>{
            Object.assign(accumulatedCustomData, metric.experience.getData().custom);
        });
        const latestSegment = sorted[sorted.length - 1];
        const latestFullyInteractiveStopTime = latestFullyInteractiveSegment?.getFullyInteractiveStopTime();
        this.stop({
            stopTime: latestSegment.getDependencyStopTime(),
            customData: {
                ...accumulatedCustomData,
                segment: latestSegment.getKey(),
                segmentOverrided: latestSegment.getIsSegmentLoadOverrided(),
                ...latestFullyInteractiveStopTime ? {
                    latestFullyInteractiveSegment: latestFullyInteractiveSegment?.getKey(),
                    latestFullyInteractiveStopTime: latestFullyInteractiveStopTime
                } : {}
            }
        });
    }
    watchUntil() {
        if (!this.untilMetrics.length) return;
        if (this.isUntilFinished()) {
            // Already finished, handle it immediately
            this.handleAllUntilFinished();
            return;
        }
        // If not currently finished, register stop callbacks to re-check
        this.untilOnStopCallback = ()=>{
            if (this.isUntilFinished()) this.handleAllUntilFinished();
        };
        this.untilMetrics.forEach((metric)=>{
            if (metric.experience.getData().state !== "finished") metric.experience.onStop(this.untilOnStopCallback, ()=>this.cancel());
        });
    }
    cancelUntil() {
        this.untilMetrics.forEach((metric)=>{
            if (metric.experience.getData().state !== "cancelled" && this.untilOnStopCallback) metric.experience.removeOnStopCallback(this.untilOnStopCallback);
        });
    }
    clear() {
        // todo before clearing - handle cancelling existing onStop / unsubscribe submetrics
        this.cancelUntil();
        this.state = "not-started";
        this.startTime = null;
        this.stopTime = null;
        this.marks = {};
        this.custom = null;
        this.submetrics = [];
        this.route = null;
        this.pageVisibleState = $2e31a7146b2b3b48$var$getPageVisibleState();
    }
}

});
parcelRegister("h2ifQ", function(module, exports) {

$parcel$export(module.exports, "restrictedTimingKeys", () => $d5682944818c1755$export$1d17377365286b00);
$parcel$export(module.exports, "clsWaitTimeMs", () => $d5682944818c1755$export$df21d285cfcda81e);
const $d5682944818c1755$export$1d17377365286b00 = [
    'ssr'
];
const $d5682944818c1755$export$df21d285cfcda81e = 7500;

});

parcelRegister("fRmN8", function(module, exports) {

$parcel$export(module.exports, "visibilityChangeObserver", () => $8676be0efe9721a6$export$13e680397ec8f3eb);
class $8676be0efe9721a6$var$VisibilityChangeObserver {
    start() {
        document.addEventListener('visibilitychange', this.broadcast);
        /**
		 * According to https://developer.mozilla.org/en-US/docs/Web/API/Document/visibilitychange_event
		 * Safari doesn’t fire visibilitychange as expected when the value of the visibilityState property transitions to hidden;
		 * so for that case, you need to also include code to listen for the pagehide event.
		 */ window.addEventListener('pagehide', this.broadcast);
    }
    subscribe(callback) {
        this.observers.push(callback);
    }
    unsubscribe(callback) {
        this.observers = this.observers.filter((fn)=>fn !== callback);
    }
    constructor(){
        this.observers = [];
        this.broadcast = ()=>{
            this.observers.forEach((fn)=>fn());
            this.observers = [];
        };
    }
}
const $8676be0efe9721a6$export$13e680397ec8f3eb = new $8676be0efe9721a6$var$VisibilityChangeObserver();

});

parcelRegister("17Tdl", function(module, exports) {

$parcel$export(module.exports, "UntilExperience", () => $c019b4778c93fc02$export$3fcc0936ee2cc852);
class $c019b4778c93fc02$export$3fcc0936ee2cc852 {
    static{
        this.FMP = 'fmp';
    }
    static fromConfig(config) {
        return new $c019b4778c93fc02$export$3fcc0936ee2cc852(config.experience, config.useFmpAsUntilStopTime);
    }
    static fromMetric(metric) {
        return new $c019b4778c93fc02$export$3fcc0936ee2cc852(metric);
    }
    constructor(experience, useFmpAsUntilStopTime){
        this.experience = experience;
        this.useFmpAsUntilStopTime = useFmpAsUntilStopTime;
    }
    /**
	 * If FMP mark is present, return that
	 * otherwise return the eventual load
	 */ getFmp() {
        const { marks: marks, stop: stop } = this.experience.getData();
        return marks[$c019b4778c93fc02$export$3fcc0936ee2cc852.FMP] ?? stop;
    }
    getDependencyStopTime() {
        if (this.useFmpAsUntilStopTime) return this.getFmp();
        return this.experience.getData().stop;
    }
    /**
	 * Get the time it takes for a segment to become fully interactable,
	 * regardless of whether it uses the FMP as the stop time. (Eventual load)
	 */ getFullyInteractiveStopTime() {
        return this.experience.getData().stop;
    }
    getIsSegmentLoadOverrided() {
        if (this.useFmpAsUntilStopTime) {
            const { marks: marks } = this.experience.getData();
            return marks[$c019b4778c93fc02$export$3fcc0936ee2cc852.FMP] ? true : false;
        }
        return false;
    }
    getKey() {
        return this.experience.getData().key;
    }
}

});



parcelRegister("b1CcL", function(module, exports) {

$parcel$export(module.exports, "BasePageLoadMetric", () => $d6c70fe51734e648$export$fd1447b187f590fe);

var $kDaME = parcelRequire("kDaME");

var $bRM2E = parcelRequire("bRM2E");
class $d6c70fe51734e648$export$fd1447b187f590fe extends (0, $bRM2E.BaseMetric) {
    static{
        this.FMP = 'fmp';
    }
    constructor(args){
        super(args), this.isInitial = true, this.explicitTimings = null;
        this.config = args;
    }
    start({} = {}) {
        // please use startPageLoad
        return;
    }
    startPageLoad(params = {
        isInitial: false
    }) {
        // todo this should update meta page load metric
        this.isInitial = params.isInitial;
        if (params.isInitial) super.start({
            startTime: 0
        });
        else super.start(params);
        (0, $kDaME.logger).logCond(!!this.config.debug, this.key, this.startTime);
    }
    stopPageLoad(pageLoadMetaMetricData, stopArguments = {
        stopTime: window.performance.now()
    }) {
        if (pageLoadMetaMetricData.state !== (0, $bRM2E.MetricState).STARTED || pageLoadMetaMetricData.start === null || stopArguments.stopTime === undefined) {
            (0, $kDaME.logger).log(`meta metric has been stopped while not being started before; current state: ${this.state}`);
            return false;
        }
        if (stopArguments.stopTime < pageLoadMetaMetricData.start) {
            (0, $kDaME.logger).log(`metric ${this.config.key} has been stopped with stopTime lower than startTime; startTime: ${pageLoadMetaMetricData.start}; stopTime: ${stopArguments.stopTime}`);
            return false;
        }
        this.merge(pageLoadMetaMetricData);
        this.stopTime = stopArguments.stopTime;
        this.state = (0, $bRM2E.MetricState).FINISHED;
        this.handleStop(stopArguments);
        return true;
    }
    handleStop(stopArguments) {
        const { until: until } = this.config;
        const fmpWasMarked = $d6c70fe51734e648$export$fd1447b187f590fe.FMP in this.marks;
        if (!fmpWasMarked && until) {
            // Extract the maximum FMP value from the until metrics
            const untilArr = Array.isArray(until) ? this.getConfiguredUntilMetricArray(until) : this.getConfiguredUntilMetricArray([
                until
            ]);
            const untilFmpMarks = untilArr.map((metric)=>metric.getFmp());
            if (untilFmpMarks.every(Number.isFinite)) this.markFMP(Math.max(...untilFmpMarks));
        }
        super.handleStop(stopArguments);
    }
    mark(mark, timestamp = window.performance.now()) {
        if (mark === $d6c70fe51734e648$export$fd1447b187f590fe.FMP) return;
        super.mark(mark, timestamp);
    }
    merge(mergeData) {
        super.merge(mergeData);
        this.isInitial = mergeData.isInitial;
        this.explicitTimings = this.explicitTimings || mergeData.explicitTimings ? {
            ...mergeData.explicitTimings,
            ...this.explicitTimings
        } : null;
    }
    markFMP(timestamp) {
        super.mark($d6c70fe51734e648$export$fd1447b187f590fe.FMP, timestamp);
    }
    getPageLoadData() {
        return {
            isInitial: this.isInitial,
            explicitTimings: this.explicitTimings
        };
    }
    getData() {
        return {
            ...super.getData(),
            ...this.getPageLoadData()
        };
    }
    getDataToMerge() {
        return {
            ...super.getDataToMerge(),
            ...this.getPageLoadData()
        };
    }
    clear() {
        this.explicitTimings = null;
        super.clear();
    }
}

});


parcelRegister("aE7dm", function(module, exports) {

$parcel$export(module.exports, "webVitalsObserver", () => $e82802a345a20d1c$export$253d38dccbb37615);


class $e82802a345a20d1c$var$WebVitalsObserver {
    start() {
        this.ttciDetermined = this.registerTTCI();
        this.webVitalsDetermined = this.registerWebVitals();
    }
    async registerWebVitals() {
        try {
            const { getCLS: getCLS, getFCP: getFCP, getFID: getFID, getLCP: getLCP, getTTFB: getTTFB } = await (parcelRequire("coGmf"));
            await Promise.all([
                getTTFB,
                getFID,
                getFCP,
                getLCP,
                getCLS
            ].map((fx)=>new Promise((resolve)=>{
                    fx(({ name: name, value: value })=>{
                        // round FCP, FID, LCP, TTFB to nearest integer.
                        // CLS is rounded to two decimal places.
                        const metricName = name.toLowerCase();
                        const metricValue = metricName === 'cls' ? parseFloat(value.toFixed(2)) : Math.round(value);
                        this.data[`metric:${metricName}`] = metricValue;
                        resolve();
                    });
                })));
        } catch (e) {}
    }
    async registerTTCI() {
        try {
            const ttiPolyfill = await (parcelRequire("isoht"));
            await ttiPolyfill.getFirstConsistentlyInteractive().then((value)=>{
                // according to the docs:
                // If no TTI value can be found, or if the browser doesn't support all the APIs required to detect TTI,
                // the promise resolves to null.
                this.data['metric:ttci'] = typeof value === 'number' ? Math.round(value) : value;
                return true;
            });
        } catch (e) {}
    }
    constructor(){
        this.data = {
            'metric:ttci': null,
            'metric:ttfb': null,
            'metric:fid': null,
            'metric:fcp': null,
            'metric:lcp': null,
            'metric:cls': null
        };
    }
}
const $e82802a345a20d1c$export$253d38dccbb37615 = new $e82802a345a20d1c$var$WebVitalsObserver();

});
parcelRegister("coGmf", function(module, exports) {

let $9068954ae86f4720$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $9068954ae86f4720$var$load("i4IY1").then(()=>parcelRequire('6CpHo'));

});
parcelRegister("gLHA4", function(module, exports) {
"use strict";


let $c352d75ef50f2116$var$load = (maxShards)=>(id)=>{
        // eslint-disable-next-line no-undef
        return import((parcelRequire("dc6w4")).shardUrl((parcelRequire("iTG8W")).resolve(id), maxShards));
    };
module.exports = $c352d75ef50f2116$var$load;

});
parcelRegister("dc6w4", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.applyShardToDomain = $99b1735a765f87b1$var$applyShardToDomain;
module.exports.domainShardingKey = void 0;
module.exports.getDomainShardIndex = $99b1735a765f87b1$var$getDomainShardIndex;
module.exports.shardUrl = $99b1735a765f87b1$var$shardUrl;
module.exports.shardUrlUnchecked = $99b1735a765f87b1$var$shardUrlUnchecked;
const $99b1735a765f87b1$var$globalKeyName = '__ATLASPACK_ENABLE_DOMAIN_SHARDS';
/**
 * Extracts the file name from a static asset path.
 * Will throw if the path doesn't have segments or ends in a trailing slash.
 */ function $99b1735a765f87b1$var$getFilenameFromUrlPath(pathname) {
    const lastSlashIdx = pathname.lastIndexOf('/');
    if (lastSlashIdx === -1 || lastSlashIdx === pathname.length - 1) throw new Error(`Expected an absolute URL with a file name, unable to apply sharding.`);
    // Add 1 to skip over the / itself
    return pathname.slice(lastSlashIdx + 1);
}
/**
 * Generates a bounded numeric hash in [0, maxShards)
 */ function $99b1735a765f87b1$var$getDomainShardIndex(str, maxShards) {
    // As we include the base domain as a shard option then we add 1 to maxShards
    // to account for that.
    const totalShards = maxShards + 1;
    let shard = str.split('').reduce((a, b)=>{
        const n = (a << totalShards) - a + b.charCodeAt(0);
        // The value returned by << is 64 bit, the & operator coerces to 32,
        // prevents overflow as we iterate.
        return n & n;
    }, 0);
    shard = shard % totalShards;
    // Make number positive
    if (shard < 0) shard += totalShards;
    return shard;
}
const $99b1735a765f87b1$var$trailingShardRegex = /-\d+$/;
/**
 * Removes trailing shard number from subdomain
 */ function $99b1735a765f87b1$var$removeTrailingShard(subdomain) {
    if (!$99b1735a765f87b1$var$trailingShardRegex.test(subdomain)) return subdomain;
    const shardIdx = subdomain.lastIndexOf('-');
    return subdomain.slice(0, shardIdx);
}
/**
 * Given a shard number, inserts that shard in the expected pattern within the
 * domain
 */ function $99b1735a765f87b1$var$applyShardToDomain(domain, shard) {
    const i = domain.indexOf('.');
    // If the shard is 0, then just use the base domain.
    // If the shard is > 0, then remove 1 as the shards domains index from 0
    const shardSuffix = shard === 0 ? '' : `-${shard - 1}`;
    // Domains like localhost have no . separators
    if (i === -1) return `${$99b1735a765f87b1$var$removeTrailingShard(domain)}${shardSuffix}`;
    // If this domain already has a shard number in it, strip it
    // out before adding the new one
    const firstSubdomain = $99b1735a765f87b1$var$removeTrailingShard(domain.slice(0, i));
    return `${firstSubdomain}${shardSuffix}${domain.slice(i)}`;
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * Unlike `shardUrl`, this function will always apply sharding, without any
 * conditional logic.
 */ function $99b1735a765f87b1$var$shardUrlUnchecked(url, maxShards) {
    const parsedUrl = new URL(url);
    const fileName = $99b1735a765f87b1$var$getFilenameFromUrlPath(parsedUrl.pathname);
    const shardNumber = $99b1735a765f87b1$var$getDomainShardIndex(fileName, maxShards);
    parsedUrl.hostname = $99b1735a765f87b1$var$applyShardToDomain(parsedUrl.hostname, shardNumber);
    return parsedUrl.toString();
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * This function only applies the sharding if the
 * __ATLASPACK_ENABLE_DOMAIN_SHARDS global variable has been set to true
 */ function $99b1735a765f87b1$var$shardUrl(url, maxShards) {
    // Global variable is set by SSR servers when HTTP1.1 traffic is detected
    if (!globalThis[$99b1735a765f87b1$var$globalKeyName]) return url;
    return $99b1735a765f87b1$var$shardUrlUnchecked(url, maxShards);
}
const $99b1735a765f87b1$var$domainShardingKey = module.exports.domainShardingKey = $99b1735a765f87b1$var$globalKeyName;

});

parcelRegister("iTG8W", function(module, exports) {

$parcel$export(module.exports, "register", () => $dc1e0dd440d9db39$export$6503ec6e8aabbaf, (v) => $dc1e0dd440d9db39$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $dc1e0dd440d9db39$export$f7ad0328861e2f03, (v) => $dc1e0dd440d9db39$export$f7ad0328861e2f03 = v);
var $dc1e0dd440d9db39$export$6503ec6e8aabbaf;
var $dc1e0dd440d9db39$export$f7ad0328861e2f03;
"use strict";
var $dc1e0dd440d9db39$var$mapping = new Map();
function $dc1e0dd440d9db39$var$register(/** @type {string} */ baseUrl, /** @type {Array<string>} */ manifest // ['id', 'path', 'id2', 'path2']
) {
    for(var i = 0; i < manifest.length - 1; i += 2)$dc1e0dd440d9db39$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $dc1e0dd440d9db39$var$resolve(id) {
    var resolved = $dc1e0dd440d9db39$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$dc1e0dd440d9db39$export$6503ec6e8aabbaf = $dc1e0dd440d9db39$var$register;
$dc1e0dd440d9db39$export$f7ad0328861e2f03 = $dc1e0dd440d9db39$var$resolve;

});



parcelRegister("isoht", function(module, exports) {

let $d6fdad33a903035d$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $d6fdad33a903035d$var$load("O8ji7").then(()=>parcelRequire('esyh1'));

});


parcelRegister("fKqpR", function(module, exports) {

$parcel$export(module.exports, "Route", () => $fe2e9009e4775196$export$e7b0ac011bb776c6);
const $fe2e9009e4775196$export$e7b0ac011bb776c6 = {
    route: '',
    setRoute (newRoute) {
        this.route = newRoute;
    },
    getRoute () {
        return this.route;
    }
};

});

parcelRegister("5gTHh", function(module, exports) {

$parcel$export(module.exports, "submitter", () => $5e1f7e7b67fdab7f$export$c21a25872e3f5a2b);

var $3TY2E = parcelRequire("3TY2E");

var $5zeHM = parcelRequire("5zeHM");

var $dsRXm = parcelRequire("dsRXm");

var $c0TQq = parcelRequire("c0TQq");
const $5e1f7e7b67fdab7f$export$c21a25872e3f5a2b = {
    debug: false,
    config: {
        gasv3: undefined,
        configChunk: null,
        useVisibleState: false,
        histogram: {},
        enableReactUFOTracker: false
    },
    configure (config) {
        this.config.gasv3 = config.endpoints.eventPipelineClient;
        this.config.enableReactUFOTracker = config.enableReactUFOTracker;
        this.config.configChunk = (0, $c0TQq.makeShareableGlobalConfig)(config);
        if (config.events.all && config.events.all.sfxEvents) this.config.useVisibleState = config.events.all.sfxEvents.activeTab === (0, $5zeHM.PageVisibleFields).pageVisibleState;
    },
    setDebug (debug) {
        this.debug = debug;
    },
    async queue (data) {
        if (this.config.enableReactUFOTracker) (0, $3TY2E.addBrowserMetricEvent)(data);
        if (!this.config.configChunk) {
            // eslint-disable-next-line no-console
            this.debug && console.warn('Submitter is not configured');
            return null;
        }
        const chunk = await this.config.configChunk;
        const payload = await (0, $dsRXm.eventDataProcessor)(chunk[data.config.type], data);
        if (payload === null) return;
        if (this.config.gasv3 !== undefined) {
            const client = await this.config.gasv3;
            const attributes = {
                task: payload['event:key'],
                properties: payload
            };
            client && client.sendOperationalEvent({
                actionSubject: 'performance',
                attributes: attributes,
                source: 'performance',
                action: 'measured'
            });
        }
    }
};

});
parcelRegister("dsRXm", function(module, exports) {

$parcel$export(module.exports, "eventDataProcessor", () => $f83ed5c1e0c19d78$export$896b6e121bbaec25);

var $h2ifQ = parcelRequire("h2ifQ");

var $kDaME = parcelRequire("kDaME");

var $16cBc = parcelRequire("16cBc");

var $awTXb = parcelRequire("awTXb");

var $8iJqJ = parcelRequire("8iJqJ");

var $46f6J = parcelRequire("46f6J");

var $hIc80 = parcelRequire("hIc80");

var $jOlYq = parcelRequire("jOlYq");

var $1CQi7 = parcelRequire("1CQi7");

var $254Bj = parcelRequire("254Bj");

var $5DUEE = parcelRequire("5DUEE");

var $4emgb = parcelRequire("4emgb");

var $bQ1zZ = parcelRequire("bQ1zZ");

var $ktVd0 = parcelRequire("ktVd0");

var $kP0mC = parcelRequire("kP0mC");

var $aIZZZ = parcelRequire("aIZZZ");

var $VEw64 = parcelRequire("VEw64");

var $1NbLG = parcelRequire("1NbLG");

var $8t1cg = parcelRequire("8t1cg");

var $4kP2v = parcelRequire("4kP2v");

var $7khsW = parcelRequire("7khsW");

var $78yAc = parcelRequire("78yAc");

var $UUwSR = parcelRequire("UUwSR");

var $f3ajJ = parcelRequire("f3ajJ");

var $cVEqZ = parcelRequire("cVEqZ");

var $a1HdS = parcelRequire("a1HdS");

var $61DiZ = parcelRequire("61DiZ");

var $4Qftf = parcelRequire("4Qftf");

var $6m6zl = parcelRequire("6m6zl");

var $9o2nw = parcelRequire("9o2nw");

var $iJuoQ = parcelRequire("iJuoQ");

var $bqaN8 = parcelRequire("bqaN8");

var $lytqq = parcelRequire("lytqq");

var $e1cWf = parcelRequire("e1cWf");

var $8OzJH = parcelRequire("8OzJH");

var $iGCEo = parcelRequire("iGCEo");

var $5zeHM = parcelRequire("5zeHM");
const $f83ed5c1e0c19d78$var$defaultSet = [
    (0, $254Bj.eventKey),
    (0, $kP0mC.eventType),
    (0, $4emgb.eventProduct),
    (0, $ktVd0.eventRoute),
    (0, $jOlYq.eventId),
    (0, $5DUEE.eventLocalTime),
    (0, $bQ1zZ.eventRegion),
    (0, $awTXb.appFramework),
    (0, $8iJqJ.appVersion),
    (0, $46f6J.bmVersion),
    (0, $9o2nw.telemetryBrowser),
    (0, $iJuoQ.telemetryCpu),
    (0, $bqaN8.telemetryMemory),
    (0, $lytqq.telemetryNetwork),
    (0, $hIc80.customData),
    (0, $aIZZZ.featureFlags),
    (0, $VEw64.hostname),
    (0, $61DiZ.productCustomData),
    (0, $e1cWf.appTimings),
    (0, $iGCEo.resourceTimings)
];
const $f83ed5c1e0c19d78$var$pageLoadCommon = [
    ...$f83ed5c1e0c19d78$var$defaultSet,
    (0, $cVEqZ.pageVisibleState),
    (0, $a1HdS.pageVisibleValue),
    (0, $1CQi7.eventInitial),
    (0, $78yAc.pageLoadMetrics),
    (0, $8OzJH.bundleEvalTimings)
];
const $f83ed5c1e0c19d78$var$initialPageLoadSet = [
    ...$f83ed5c1e0c19d78$var$pageLoadCommon,
    (0, $8t1cg.initialPageLoadMetrics),
    (0, $7khsW.navigationMetrics),
    (0, $6m6zl.ssrSuccess),
    (0, $4Qftf.ssrFeatureFlags)
];
const $f83ed5c1e0c19d78$var$spaTransitionSet = [
    ...$f83ed5c1e0c19d78$var$pageLoadCommon
];
const $f83ed5c1e0c19d78$var$pageSegmentLoadSet = [
    ...$f83ed5c1e0c19d78$var$defaultSet,
    (0, $UUwSR.pageSegmentLoadMetrics),
    (0, $cVEqZ.pageVisibleState),
    (0, $a1HdS.pageVisibleValue),
    (0, $1CQi7.eventInitial),
    (0, $8OzJH.bundleEvalTimings)
];
const $f83ed5c1e0c19d78$var$interactionSet = [
    ...$f83ed5c1e0c19d78$var$defaultSet,
    (0, $cVEqZ.pageVisibleState),
    (0, $a1HdS.pageVisibleValue),
    (0, $4kP2v.interactionMetrics)
];
const $f83ed5c1e0c19d78$var$customMetricSet = [
    ...$f83ed5c1e0c19d78$var$defaultSet,
    (0, $cVEqZ.pageVisibleState),
    (0, $a1HdS.pageVisibleValue),
    (0, $1NbLG.customEventMetrics)
];
// pageVisibleState and pageVisibleValue has been handled within webVitalsMetrics.
const $f83ed5c1e0c19d78$var$webVitalsMetricSet = [
    ...$f83ed5c1e0c19d78$var$defaultSet,
    (0, $f3ajJ.webVitalsMetrics)
];
// Function that returns a promise which resolves after clsWaitTimeMs + 500ms
// so that clsData is guaranteed to be attached to window
const $f83ed5c1e0c19d78$var$waitForCLS = (delay = (0, $h2ifQ.clsWaitTimeMs) + 500)=>{
    return new Promise((resolve)=>setTimeout(resolve, delay));
};
const $f83ed5c1e0c19d78$export$896b6e121bbaec25 = async (globalConfig, data)=>{
    if (data.start === null || data.stop === null) {
        (0, $kDaME.logger).log(`eventDataProcessor: Metric "${data.key}" start or stop are incorrect; start: ${data.start}; stop: ${data.stop}`);
        return null;
    }
    let set = [];
    if (data.config.type === (0, $5zeHM.BMEventsType).PAGE_LOAD && (0, $16cBc.isPageLoadMetricData)(data) && data.isInitial) set = $f83ed5c1e0c19d78$var$initialPageLoadSet;
    if (data.config.type === (0, $5zeHM.BMEventsType).PAGE_LOAD && (0, $16cBc.isPageLoadMetricData)(data) && !data.isInitial) set = $f83ed5c1e0c19d78$var$spaTransitionSet;
    if (data.config.type === (0, $5zeHM.BMEventsType).PAGE_SEGMENT_LOAD && (0, $16cBc.isPageSegmentLoadMetricData)(data)) set = $f83ed5c1e0c19d78$var$pageSegmentLoadSet;
    if (data.config.type === (0, $5zeHM.BMEventsType).INLINE_RESULT) set = $f83ed5c1e0c19d78$var$interactionSet;
    if (data.config.type === (0, $5zeHM.BMEventsType).CUSTOM) set = $f83ed5c1e0c19d78$var$customMetricSet;
    if (data.config.type === (0, $5zeHM.BMEventsType).WEB_VITALS) {
        set = $f83ed5c1e0c19d78$var$webVitalsMetricSet;
        // Wait for CLS to be recorded before proceeding to run plugin and attach CLS data
        await $f83ed5c1e0c19d78$var$waitForCLS();
    }
    //TODO if type is different - do not send at all
    const plugins = [];
    for (const plugin of set){
        const result = await plugin(data.config, data, globalConfig);
        if (result) plugins.push(result);
    }
    const pluginResults = await Promise.all(plugins);
    const generated = {};
    pluginResults.forEach((pluginResult)=>{
        if (pluginResult === null) return;
        Object.keys(pluginResult).forEach((key)=>{
            const keyResult = pluginResult[key];
            if (keyResult !== null && keyResult !== undefined) generated[key] = keyResult;
        });
    });
    return generated;
};

});
parcelRegister("16cBc", function(module, exports) {

$parcel$export(module.exports, "isPageLoadMetricData", () => $e0771d694e0302c5$export$b0e12e7abb0bff11);
$parcel$export(module.exports, "isPageSegmentLoadMetricData", () => $e0771d694e0302c5$export$83d0099ee6dbb5b0);
$parcel$export(module.exports, "isPageLoadConfig", () => $e0771d694e0302c5$export$8672fa27ba8bba88);
$parcel$export(module.exports, "isPageSegmentLoadConfig", () => $e0771d694e0302c5$export$abe063537ef4987b);
$parcel$export(module.exports, "isInteractionConfig", () => $e0771d694e0302c5$export$ae68674b6a9353be);
$parcel$export(module.exports, "isCustomConfig", () => $e0771d694e0302c5$export$b493eb8b2ba87421);

var $5zeHM = parcelRequire("5zeHM");
const $e0771d694e0302c5$export$b0e12e7abb0bff11 = (data)=>{
    return data.type === (0, $5zeHM.BMEventsType).PAGE_LOAD;
};
const $e0771d694e0302c5$export$83d0099ee6dbb5b0 = (data)=>{
    return data.type === (0, $5zeHM.BMEventsType).PAGE_SEGMENT_LOAD;
};
const $e0771d694e0302c5$export$8672fa27ba8bba88 = (data)=>{
    return data.type === (0, $5zeHM.BMEventsType).PAGE_LOAD;
};
const $e0771d694e0302c5$export$abe063537ef4987b = (data)=>{
    return data.type === (0, $5zeHM.BMEventsType).PAGE_SEGMENT_LOAD;
};
const $e0771d694e0302c5$export$ae68674b6a9353be = (data)=>{
    return data.type === (0, $5zeHM.BMEventsType).INLINE_RESULT;
};
const $e0771d694e0302c5$export$b493eb8b2ba87421 = (data)=>{
    return data.type === (0, $5zeHM.BMEventsType).CUSTOM;
};

});

parcelRegister("awTXb", function(module, exports) {

$parcel$export(module.exports, "appFramework", () => $2c80752fc06a2e8f$export$e34e4529b979f74c);
const $2c80752fc06a2e8f$export$e34e4529b979f74c = (_config, _data, globalConfig)=>{
    if (!globalConfig.app.framework) return null;
    return {
        'app:framework:name': globalConfig.app.framework.name,
        'app:framework:version': globalConfig.app.framework.version
    };
};

});

parcelRegister("8iJqJ", function(module, exports) {

$parcel$export(module.exports, "appVersion", () => $9bf09d42680a16e0$export$82ae485178b37419);
const $9bf09d42680a16e0$export$82ae485178b37419 = (_config, _data, globalConfig)=>{
    const pluginData = {
        'app:web:version': globalConfig.app.version.web
    };
    if (globalConfig.app.version.ssr) pluginData['app:ssr:version'] = globalConfig.app.version.ssr;
    return pluginData;
};

});

parcelRegister("46f6J", function(module, exports) {

$parcel$export(module.exports, "bmVersion", () => $b2234338124f0142$export$5cafa465fc876895);
const $b2234338124f0142$export$5cafa465fc876895 = ()=>{
    return {
        'bm:version': 3
    };
};

});

parcelRegister("hIc80", function(module, exports) {

$parcel$export(module.exports, "customData", () => $8b2a81e14d7869f2$export$f7e743c7db162193);
const $8b2a81e14d7869f2$export$f7e743c7db162193 = (_config, data)=>{
    const custom = {};
    let changed = false;
    if (data.custom) Object.entries(data.custom).forEach(([key, value])=>{
        changed = true;
        custom[`custom:${key}`] = value;
    });
    return changed ? custom : null;
};

});

parcelRegister("jOlYq", function(module, exports) {

$parcel$export(module.exports, "eventId", () => $58f8948cb9e24c6e$export$aed28df7ac07d79a);
const $58f8948cb9e24c6e$export$aed28df7ac07d79a = (config)=>{
    return {
        'event:id': config.key
    };
};

});

parcelRegister("1CQi7", function(module, exports) {

$parcel$export(module.exports, "eventInitial", () => $cea22b9b88812491$export$fa8e91d436b3ef8b);

var $16cBc = parcelRequire("16cBc");
const $cea22b9b88812491$export$fa8e91d436b3ef8b = (_config, data)=>{
    if (!(0, $16cBc.isPageLoadMetricData)(data) && !(0, $16cBc.isPageSegmentLoadMetricData)(data)) return null;
    return {
        'event:initial': data.isInitial
    };
};

});

parcelRegister("254Bj", function(module, exports) {

$parcel$export(module.exports, "eventKey", () => $907e1899319437ae$export$10be2d3a558d3f88);

var $9NF2W = parcelRequire("9NF2W");
const $907e1899319437ae$export$10be2d3a558d3f88 = (config, _data, globalConfig)=>{
    return {
        'event:key': `${globalConfig.product}.fe.${(0, $9NF2W.mapEventType)(config.type)}.${config.key}`
    };
};

});
parcelRegister("9NF2W", function(module, exports) {

$parcel$export(module.exports, "mapEventType", () => $fe2d0ad0c55015e5$export$b334d07f11140768);

var $5zeHM = parcelRequire("5zeHM");
const $fe2d0ad0c55015e5$export$b334d07f11140768 = (type)=>{
    switch(type){
        case (0, $5zeHM.BMEventsType).CUSTOM:
            return (0, $5zeHM.StorableBMEventsType).CUSTOM;
        case (0, $5zeHM.BMEventsType).INLINE_RESULT:
            return (0, $5zeHM.StorableBMEventsType).INLINE_RESULT;
        case (0, $5zeHM.BMEventsType).PAGE_LOAD:
            return (0, $5zeHM.StorableBMEventsType).PAGE_LOAD;
        case (0, $5zeHM.BMEventsType).PAGE_SEGMENT_LOAD:
            return (0, $5zeHM.StorableBMEventsType).PAGE_SEGMENT_LOAD;
        case (0, $5zeHM.BMEventsType).WEB_VITALS:
            return (0, $5zeHM.StorableBMEventsType).WEB_VITALS;
        default:
            return 'unknown';
    }
};

});


parcelRegister("5DUEE", function(module, exports) {

$parcel$export(module.exports, "eventLocalTime", () => $4fa8619e583de9b8$export$5219854ae7ec45da);

var $57raR = parcelRequire("57raR");
const $4fa8619e583de9b8$export$5219854ae7ec45da = ()=>({
        'event:localHour': parseInt((0, $57raR.default)(new Date(), 'H'), 10),
        'event:localDayOfWeek': parseInt((0, $57raR.default)(new Date(), 'i'), 10)
    });

});

parcelRegister("4emgb", function(module, exports) {

$parcel$export(module.exports, "eventProduct", () => $76fc265bc3a04650$export$a7df4e8088db8843);
const $76fc265bc3a04650$export$a7df4e8088db8843 = (_config, _data, globalConfig)=>{
    return {
        'event:product': `${globalConfig.product}`
    };
};

});

parcelRegister("bQ1zZ", function(module, exports) {

$parcel$export(module.exports, "eventRegion", () => $a70f302e1e037080$export$d0117b71adcdebc0);
const $a70f302e1e037080$export$d0117b71adcdebc0 = (_config, _data, globalConfig)=>{
    return {
        'event:region': `${globalConfig.region}`
    };
};

});

parcelRegister("ktVd0", function(module, exports) {

$parcel$export(module.exports, "eventRoute", () => $e8598c3cb4a7b583$export$44d3627af289ca16);
const $e8598c3cb4a7b583$export$44d3627af289ca16 = (_config, data)=>{
    if (!data.route) return null;
    return {
        'event:route': data.route
    };
};

});

parcelRegister("kP0mC", function(module, exports) {

$parcel$export(module.exports, "eventType", () => $502f3b0c858c1de9$export$4c045e605d532c98);

var $9NF2W = parcelRequire("9NF2W");
const $502f3b0c858c1de9$export$4c045e605d532c98 = (config)=>{
    return {
        'event:type': (0, $9NF2W.mapEventType)(config.type)
    };
};

});

parcelRegister("aIZZZ", function(module, exports) {

$parcel$export(module.exports, "featureFlags", () => $4933d45ce81af4a2$export$e62953d023125748);
const $4933d45ce81af4a2$export$e62953d023125748 = (config, _data, globalConfig)=>{
    const localFeatureFlags = config.featureFlags?.reduce((acc, ffName)=>{
        acc[ffName] = globalConfig.ffClient.getValue(ffName);
        return acc;
    }, {}) || null;
    if ((!globalConfig.featureFlags || Object.keys(globalConfig.featureFlags).length === 0) && (!localFeatureFlags || Object.keys(localFeatureFlags).length === 0)) return null;
    return {
        featureFlags: {
            ...localFeatureFlags,
            ...globalConfig.featureFlags
        }
    };
};

});

parcelRegister("VEw64", function(module, exports) {

$parcel$export(module.exports, "hostname", () => $38ac2563c64a2c26$export$640106f6dc7d2706);
const $38ac2563c64a2c26$export$640106f6dc7d2706 = (_config, _data, globalConfig)=>{
    return {
        hostname: globalConfig.hostname
    };
};

});

parcelRegister("1NbLG", function(module, exports) {

$parcel$export(module.exports, "customEventMetrics", () => $6b3a0c2c4794fbbf$export$cab039265c52a2e9);

var $16cBc = parcelRequire("16cBc");
const $6b3a0c2c4794fbbf$export$cab039265c52a2e9 = (config, data, globalConfig)=>{
    if (!(0, $16cBc.isCustomConfig)(config)) return null;
    const payload = {
        'metric:duration': Math.round(data.stop - data.start)
    };
    if (config.slo?.threshold !== undefined) {
        payload['metric:duration:slo'] = payload['metric:duration'] <= config.slo?.threshold;
        payload['metric:duration:slo:threshold'] = config.slo?.threshold;
    }
    if (config.histogram?.duration) payload['metric:duration:histogramBuckets'] = config.histogram.duration;
    else if (globalConfig.histogram) payload['metric:duration:histogramBuckets'] = globalConfig.histogram.duration;
    return payload;
};

});

parcelRegister("8t1cg", function(module, exports) {

$parcel$export(module.exports, "initialPageLoadMetrics", () => $b1576cbd9f43c7aa$export$cc95aa3f6ea8e5cb);
const $b1576cbd9f43c7aa$export$cc95aa3f6ea8e5cb = ()=>{
    const metrics = {};
    performance.getEntriesByType('paint').forEach((entry)=>{
        if (entry.name === 'first-paint') metrics['metric:fp'] = Math.round(entry.startTime);
        if (entry.name === 'first-contentful-paint') metrics['metric:fcp'] = Math.round(entry.startTime);
    });
    return metrics;
};

});

parcelRegister("4kP2v", function(module, exports) {

$parcel$export(module.exports, "interactionMetrics", () => $e3052ee87e8f44da$export$86db56030b57ba34);

var $16cBc = parcelRequire("16cBc");

var $5zeHM = parcelRequire("5zeHM");
const $e3052ee87e8f44da$export$86db56030b57ba34 = (config, data, globalConfig)=>{
    if (!(0, $16cBc.isInteractionConfig)(config)) return null;
    const result = {
        'metric:result': Math.round(data.stop - data.start)
    };
    if (config.histogram?.result) result['metric:result:histogramBuckets'] = config.histogram.result;
    else if (globalConfig.histogram) {
        const histogram = globalConfig.histogram;
        if (histogram.result !== undefined) result['metric:result:histogramBuckets'] = histogram[(0, $5zeHM.BMInteractionMetrics).result];
    }
    if (config.slo && (0, $5zeHM.isInteractionMetricsSlo)(config.slo) && config.slo.result) {
        result['metric:result:slo'] = result['metric:result'] <= config.slo.result.threshold;
        result['metric:result:slo:threshold'] = config.slo.result.threshold;
    }
    if (data.marks['feedback']) {
        result['metric:response'] = Math.round((data.marks['feedback'] || data.stop) - data.start);
        if (config.histogram?.response) result['metric:response:histogramBuckets'] = config.histogram[(0, $5zeHM.BMInteractionMetrics).response];
        else if (globalConfig.histogram) {
            const histogram = globalConfig.histogram;
            if (histogram.result !== undefined) result['metric:response:histogramBuckets'] = histogram[(0, $5zeHM.BMInteractionMetrics).response];
        }
        if (config.slo && (0, $5zeHM.isInteractionMetricsSlo)(config.slo) && config.slo.response) {
            result['metric:response:slo'] = result['metric:response'] <= config.slo.response.threshold;
            result['metric:response:slo:threshold'] = config.slo.response.threshold;
        }
    }
    return result;
};

});

parcelRegister("7khsW", function(module, exports) {

$parcel$export(module.exports, "navigationMetrics", () => $4ab8906158da2f39$export$b88d990436be0f8a);
const $4ab8906158da2f39$export$b88d990436be0f8a = ()=>{
    const entries = performance.getEntriesByType('navigation');
    if (entries.length === 0) return null;
    const navigation = entries[0];
    const metrics = {
        // From https://www.w3.org/TR/resource-timing/
        redirectStart: Math.round(navigation.redirectStart),
        redirectEnd: Math.round(navigation.redirectEnd),
        fetchStart: Math.round(navigation.fetchStart),
        domainLookupStart: Math.round(navigation.domainLookupStart),
        domainLookupEnd: Math.round(navigation.domainLookupEnd),
        connectStart: Math.round(navigation.connectStart),
        connectEnd: Math.round(navigation.connectEnd),
        secureConnectionStart: Math.round(navigation.secureConnectionStart),
        requestStart: Math.round(navigation.requestStart),
        responseStart: Math.round(navigation.responseStart),
        responseEnd: Math.round(navigation.responseEnd),
        encodedBodySize: Math.round(navigation.encodedBodySize),
        decodedBodySize: Math.round(navigation.decodedBodySize),
        transferSize: Math.round(navigation.transferSize),
        // From https://www.w3.org/TR/navigation-timing-2/
        redirectCount: navigation.redirectCount,
        type: navigation.type,
        unloadEventEnd: Math.round(navigation.unloadEventEnd),
        unloadEventStart: Math.round(navigation.unloadEventStart),
        workerStart: Math.round(navigation.workerStart)
    };
    return {
        'metrics:navigation': metrics
    };
};

});

parcelRegister("78yAc", function(module, exports) {

$parcel$export(module.exports, "pageLoadMetrics", () => $5583bba0242dd484$export$2878bf482e539059);

var $16cBc = parcelRequire("16cBc");

var $5zeHM = parcelRequire("5zeHM");
const $5583bba0242dd484$var$getThreshold = (isInitial, metric)=>{
    return (0, $5zeHM.isDetailedPageLoadSlo)(metric) ? isInitial ? metric.initial.threshold : metric.transition.threshold : metric.threshold;
};
const $5583bba0242dd484$var$getHistogram = (isInitial, metric, histogram)=>{
    return isInitial ? histogram.initial[metric] : histogram.transition[metric];
};
const $5583bba0242dd484$export$2878bf482e539059 = (config, data, globalConfig)=>{
    if (!(0, $16cBc.isPageLoadConfig)(config)) throw new Error('Browser Metrics: cannot gather page load data for non-page-load config');
    const fmp = data.marks[(0, $5zeHM.BMPageLoadMetrics).fmp] || data.stop;
    const result = {
        'metric:fmp': Math.round(fmp - data.start),
        'metric:tti': Math.round(data.stop - data.start)
    };
    if (config.histogram) {
        result['metric:fmp:histogramBuckets'] = $5583bba0242dd484$var$getHistogram(data.isInitial, (0, $5zeHM.BMPageLoadMetrics).fmp, config.histogram);
        result['metric:tti:histogramBuckets'] = $5583bba0242dd484$var$getHistogram(data.isInitial, (0, $5zeHM.BMPageLoadMetrics).tti, config.histogram);
    } else if (globalConfig.histogram) {
        const histogram = globalConfig.histogram;
        result['metric:fmp:histogramBuckets'] = $5583bba0242dd484$var$getHistogram(data.isInitial, (0, $5zeHM.BMPageLoadMetrics).fmp, histogram);
        result['metric:tti:histogramBuckets'] = $5583bba0242dd484$var$getHistogram(data.isInitial, (0, $5zeHM.BMPageLoadMetrics).tti, histogram);
    }
    if (config.slo && config.slo.fmp) {
        const threshold = $5583bba0242dd484$var$getThreshold(data.isInitial, config.slo.fmp);
        result['metric:fmp:slo'] = result['metric:fmp'] <= threshold;
        result['metric:fmp:slo:threshold'] = threshold;
    }
    if (config.slo && config.slo.tti) {
        const threshold = $5583bba0242dd484$var$getThreshold(data.isInitial, config.slo.tti);
        result['metric:tti:slo'] = result['metric:tti'] <= threshold;
        result['metric:tti:slo:threshold'] = threshold;
    }
    return result;
};

});

parcelRegister("UUwSR", function(module, exports) {

$parcel$export(module.exports, "pageSegmentLoadMetrics", () => $39140968a63eacbe$export$ba86cb47f2f22db5);

var $lezfJ = parcelRequire("lezfJ");

var $16cBc = parcelRequire("16cBc");

var $5zeHM = parcelRequire("5zeHM");
const $39140968a63eacbe$var$getThreshold = (isInitial, metric)=>{
    return (0, $5zeHM.isDetailedPageSegmentLoadSlo)(metric) ? isInitial ? metric.initial.threshold : metric.transition.threshold : metric.threshold;
};
const $39140968a63eacbe$var$getHistogram = (isInitial, metric, histogram)=>{
    return isInitial ? histogram.initial[metric] : histogram.transition[metric];
};
const $39140968a63eacbe$export$ba86cb47f2f22db5 = (config, data, globalConfig)=>{
    if (!(0, $16cBc.isPageSegmentLoadConfig)(config)) throw new Error('Browser Metrics: cannot gather page segment load data for non-page-segment-load config');
    const fmp = data.marks[(0, $5zeHM.BMPageSegmentLoadMetrics).fmp] || data.stop;
    const result = {
        'metric:fmp': Math.round(fmp - data.start),
        'metric:tti': Math.round(data.stop - data.start)
    };
    if (config.histogram) {
        result['metric:fmp:histogramBuckets'] = $39140968a63eacbe$var$getHistogram(data.isInitial, (0, $5zeHM.BMPageSegmentLoadMetrics).fmp, config.histogram);
        result['metric:tti:histogramBuckets'] = $39140968a63eacbe$var$getHistogram(data.isInitial, (0, $5zeHM.BMPageSegmentLoadMetrics).tti, config.histogram);
    } else if (globalConfig.histogram) {
        const histogram = globalConfig.histogram;
        result['metric:fmp:histogramBuckets'] = $39140968a63eacbe$var$getHistogram(data.isInitial, (0, $5zeHM.BMPageSegmentLoadMetrics).fmp, histogram);
        result['metric:tti:histogramBuckets'] = $39140968a63eacbe$var$getHistogram(data.isInitial, (0, $5zeHM.BMPageSegmentLoadMetrics).tti, histogram);
    }
    if (config.slo?.fmp) {
        const threshold = $39140968a63eacbe$var$getThreshold(data.isInitial, config.slo.fmp);
        result['metric:fmp:slo'] = result['metric:fmp'] <= threshold;
        result['metric:fmp:slo:threshold'] = threshold;
    }
    if (config.slo?.tti) {
        const threshold = $39140968a63eacbe$var$getThreshold(data.isInitial, config.slo.tti);
        result['metric:tti:slo'] = result['metric:tti'] <= threshold;
        result['metric:tti:slo:threshold'] = threshold;
    }
    if (config.includePageLoadTimings === (0, $5zeHM.PageSegmentPageLoadMetricsOptions).IF_PRESENT || config.includePageLoadTimings === (0, $5zeHM.PageSegmentPageLoadMetricsOptions).WAIT_UNTIL_PRESENT) {
        const pageLoadData = (0, $lezfJ.pageLoadMetaMetric).getData();
        const fmp = pageLoadData.stop !== null && pageLoadData.start !== null ? Math.round((pageLoadData.marks[(0, $5zeHM.BMPageLoadMetrics).fmp] || pageLoadData.stop) - pageLoadData.start) : null;
        const tti = pageLoadData.stop !== null && pageLoadData.start !== null ? Math.round(pageLoadData.stop - pageLoadData.start) : null;
        result['pageLoad'] = {
            fmp: fmp,
            tti: tti
        };
    }
    return result;
};

});

parcelRegister("f3ajJ", function(module, exports) {

$parcel$export(module.exports, "webVitalsMetrics", () => $cae8f5b3e93113bc$export$3731db279f590f30);

var $bRM2E = parcelRequire("bRM2E");

var $fRmN8 = parcelRequire("fRmN8");

var $aE7dm = parcelRequire("aE7dm");

var $a1HdS = parcelRequire("a1HdS");
const $cae8f5b3e93113bc$export$3731db279f590f30 = async (config, data, globalConfig)=>{
    let pageVisibleState = data.pageVisibleState;
    const setPageVisibleStateToMixed = ()=>{
        pageVisibleState = (0, $bRM2E.PageVisibleState).MIXED;
    };
    (0, $fRmN8.visibilityChangeObserver).subscribe(setPageVisibleStateToMixed);
    const ttciEnabled = globalConfig.webVitals?.ttciEnabled !== undefined ? globalConfig.webVitals?.ttciEnabled : true;
    const webVitalMetrics = await $cae8f5b3e93113bc$export$193ae490b52081dd(ttciEnabled, globalConfig.webVitals?.timeout || 30000);
    (0, $fRmN8.visibilityChangeObserver).unsubscribe(setPageVisibleStateToMixed);
    return {
        ...webVitalMetrics,
        'pageVisible:state': pageVisibleState,
        ...(0, $a1HdS.pageVisibleValue)(config, data, globalConfig)
    };
};
const $cae8f5b3e93113bc$export$193ae490b52081dd = async (ttciEnabled, timeout)=>{
    // wait for webVitalsObserver.ttciDetermined if ttciEnabled is true
    await (ttciEnabled ? (0, $aE7dm.webVitalsObserver).ttciDetermined : Promise.resolve());
    // wait up to $timeout ms longer for web-vitals until returning
    const timeoutWindow = new Promise((resolve)=>setTimeout(resolve, timeout));
    await Promise.race([
        timeoutWindow,
        (0, $aE7dm.webVitalsObserver).webVitalsDetermined
    ]);
    return (0, $aE7dm.webVitalsObserver).data;
};

});
parcelRegister("a1HdS", function(module, exports) {

$parcel$export(module.exports, "pageVisibleValue", () => $cc34216dadd1e4ed$export$177b923114656380);

var $bRM2E = parcelRequire("bRM2E");
var $5zeHM = parcelRequire("5zeHM");
const $cc34216dadd1e4ed$export$177b923114656380 = (_config, data, globalConfig)=>{
    const value = globalConfig.pageVisibleValueOrigin === (0, $5zeHM.PageVisibleValueOrigin).documentHidden ? !document.hidden || false : data.pageVisibleState === (0, $bRM2E.PageVisibleState).VISIBLE;
    return {
        'pageVisible:value': value
    };
};

});


parcelRegister("cVEqZ", function(module, exports) {

$parcel$export(module.exports, "pageVisibleState", () => $670c8f270410b14e$export$723b4c298aca63af);
const $670c8f270410b14e$export$723b4c298aca63af = (_config, data)=>{
    return {
        'pageVisible:state': data.pageVisibleState
    };
};

});

parcelRegister("61DiZ", function(module, exports) {

$parcel$export(module.exports, "productCustomData", () => $48cb663bc84c8537$export$fa2af6e412815a74);
const $48cb663bc84c8537$export$fa2af6e412815a74 = async (_config, data, globalConfig)=>{
    if (!globalConfig.custom && !globalConfig.plugins) return null;
    const result = {};
    if (globalConfig.custom) Object.entries(globalConfig.custom).forEach(([key, value])=>{
        result[`${globalConfig.product}:${key}`] = value;
    });
    if (globalConfig.plugins) {
        const pluginOutputs = await Promise.all(globalConfig.plugins.map((plugin)=>plugin({
                start: data.start,
                stop: data.stop,
                key: data.key
            })));
        pluginOutputs.forEach((pluginOutput)=>{
            if (pluginOutput === null) return;
            Object.entries(pluginOutput).forEach(([key, value])=>{
                result[`${globalConfig.product}:${key}`] = value;
            });
        });
    }
    return result;
};

});

parcelRegister("4Qftf", function(module, exports) {

$parcel$export(module.exports, "ssrFeatureFlags", () => $4080318dbbaf72e5$export$fdbea518c19dfa8);

var $5zeHM = parcelRequire("5zeHM");
const $4080318dbbaf72e5$var$retrieveFeatureFlags = async (getFeatureFlags)=>{
    try {
        const featureFlags = await getFeatureFlags();
        if (featureFlags) return {
            'ssr:featureFlags': featureFlags
        };
    } catch (e) {}
    return null;
};
const $4080318dbbaf72e5$export$fdbea518c19dfa8 = async (config, _data, globalConfig)=>{
    // no config or missing
    if (!globalConfig.ssr?.getFeatureFlags) return null;
    const includeFeatureFlags = config.ssr?.includeFeatureFlags || globalConfig.ssr?.includeFeatureFlags || (0, $5zeHM.IncludeSSRFeatureFlagsConfig).WHEN_FMP;
    if (includeFeatureFlags === (0, $5zeHM.IncludeSSRFeatureFlagsConfig).WHEN_AVAILABLE || config.ssr?.doneAsFmp && includeFeatureFlags === (0, $5zeHM.IncludeSSRFeatureFlagsConfig).WHEN_FMP) return await $4080318dbbaf72e5$var$retrieveFeatureFlags(globalConfig.ssr.getFeatureFlags);
    return null;
};

});

parcelRegister("6m6zl", function(module, exports) {

$parcel$export(module.exports, "ssrSuccess", () => $de24957a41ff54c0$export$a3dc8251cf55b2e0);
const $de24957a41ff54c0$export$a3dc8251cf55b2e0 = (config, _data, globalConfig)=>{
    if (config.ssr && config.ssr.doneAsFmp && globalConfig.ssr && globalConfig.ssr.getDoneMark && globalConfig.ssr.getDoneMark()) return {
        'ssr:success': true
    };
    return null;
};

});

parcelRegister("9o2nw", function(module, exports) {

$parcel$export(module.exports, "telemetryBrowser", () => $3c1346fbe0951031$export$386b10ac64a50b1);

var $3nEAz = parcelRequire("3nEAz");
const $3c1346fbe0951031$export$386b10ac64a50b1 = ()=>{
    if (!(0, (/*@__PURE__*/$parcel$interopDefault($3nEAz))).getParser) return null;
    const browser = (0, (/*@__PURE__*/$parcel$interopDefault($3nEAz))).getParser(window.navigator.userAgent);
    return {
        'telemetry:browser:name': browser.getBrowserName(),
        'telemetry:browser:version': browser.getBrowserVersion()
    };
};

});

parcelRegister("iJuoQ", function(module, exports) {

$parcel$export(module.exports, "telemetryCpu", () => $938855bb4a9f14cf$export$9f84cb359ed29139);
const $938855bb4a9f14cf$export$9f84cb359ed29139 = ()=>{
    if (!navigator.hardwareConcurrency) return null;
    return {
        'telemetry:cpus': navigator.hardwareConcurrency
    };
};

});

parcelRegister("bqaN8", function(module, exports) {

$parcel$export(module.exports, "telemetryMemory", () => $06f15d10451d6298$export$496c14d72b257e07);
const $06f15d10451d6298$export$496c14d72b257e07 = ()=>{
    // @ts-ignore: deviceMemory is exposed in some browsers
    if (!navigator.deviceMemory) return null;
    return {
        // @ts-ignore
        'telemetry:memory': navigator.deviceMemory
    };
};

});

parcelRegister("lytqq", function(module, exports) {

$parcel$export(module.exports, "telemetryNetwork", () => $49b93ff909028dcd$export$88bf7b55f7fc4e8e);
const $49b93ff909028dcd$export$88bf7b55f7fc4e8e = ()=>{
    // @ts-ignore: connection is available in some browsers
    // eslint-disable-next-line compat/compat
    if (!navigator.connection) return null;
    return {
        // @ts-ignore: connection is available in some browsers
        // eslint-disable-next-line compat/compat
        'telemetry:network:effectiveType': navigator.connection.effectiveType,
        // @ts-ignore: connection is available in some browsers
        // eslint-disable-next-line compat/compat
        'telemetry:network:rtt': navigator.connection.rtt,
        // @ts-ignore: connection is available in some browsers
        // eslint-disable-next-line compat/compat
        'telemetry:network:downlink': navigator.connection.downlink
    };
};

});

parcelRegister("e1cWf", function(module, exports) {

$parcel$export(module.exports, "appTimings", () => $33e7d0a1b1fe81c8$export$e952f50a4f2d02da);

var $5zeHM = parcelRequire("5zeHM");

var $itdak = parcelRequire("itdak");

var $8us4z = parcelRequire("8us4z");
const $33e7d0a1b1fe81c8$export$e952f50a4f2d02da = (config, data, globalConfig)=>{
    const explicitTimings = config.type === (0, $5zeHM.BMEventsType).PAGE_LOAD && data.explicitTimings || null;
    const timings = (0, $itdak.customTimings)(config, data);
    const ssr = config.type === (0, $5zeHM.BMEventsType).PAGE_LOAD && data.isInitial ? (0, $8us4z.ssrTimings)(config, data, globalConfig) : null;
    const timingsApp = (explicitTimings || timings || ssr) && {
        ...explicitTimings,
        ...timings,
        ...ssr
    };
    if (!timingsApp) return null;
    return {
        'timings:app': timingsApp
    };
};

});
parcelRegister("itdak", function(module, exports) {

$parcel$export(module.exports, "customTimings", () => $f80ddea2c634a3ed$export$6126f85083a72c6e);

const $f80ddea2c634a3ed$var$retrieveTimings = (config, data, relativeTo = 0, prefix = '')=>{
    const configTimings = config.timings || [];
    const timings = configTimings.reduce((entries, timing)=>{
        if (timing.startMark && !data.marks[timing.startMark]) return entries;
        if (timing.endMark && !data.marks[timing.endMark]) return entries;
        if (data.start === null || data.stop === null) return null;
        const startTime = Math.round((data.marks[timing.startMark] !== undefined ? data.marks[timing.startMark] : data.start) - data.start + relativeTo);
        const duration = Math.round((data.marks[timing.endMark] !== undefined ? data.marks[timing.endMark] : data.stop) - data.start - startTime + relativeTo);
        entries[`${prefix}${timing.key}`] = {
            startTime: startTime,
            duration: duration
        };
        return entries;
    }, {});
    return timings;
};
const $f80ddea2c634a3ed$export$6126f85083a72c6e = (config, data)=>{
    if (!config.timings && data.submetrics.length === 0) return null;
    const timings = $f80ddea2c634a3ed$var$retrieveTimings(config, data);
    data.submetrics.forEach((submetric)=>{
        if (submetric.start !== null && submetric.stop !== null) {
            const submetricPrefix = `include:${submetric.config.key}`;
            timings[submetricPrefix] = {
                startTime: Math.round(submetric.start - data.start),
                duration: Math.round(submetric.stop - submetric.start)
            };
            Object.assign(timings, $f80ddea2c634a3ed$var$retrieveTimings(submetric.config, submetric, submetric.start - data.start, submetricPrefix + (0, $29b56c7cfb47df9e$export$b98e411ae80c806f)));
        }
    });
    if (Object.keys(timings).length === 0) return null;
    return timings;
};

});
const $29b56c7cfb47df9e$export$b98e411ae80c806f = '/';


parcelRegister("8us4z", function(module, exports) {

$parcel$export(module.exports, "ssrTimings", () => $9a3d57dd1820cfdf$export$130f411261a599c5);

const $9a3d57dd1820cfdf$var$filterEntry = (entry)=>{
    return !(!entry || typeof entry !== 'object' || entry.startTime < 0 || entry.duration < 0);
};
const $9a3d57dd1820cfdf$var$mapEntry = (entry)=>{
    return {
        startTime: Math.round(entry.startTime),
        duration: Math.round(entry.duration)
    };
};
const $9a3d57dd1820cfdf$var$SSR_PREFIX = 'ssr';
const $9a3d57dd1820cfdf$var$mapKey = (key)=>{
    if (key === 'total') return $9a3d57dd1820cfdf$var$SSR_PREFIX;
    return `${$9a3d57dd1820cfdf$var$SSR_PREFIX}${0, $29b56c7cfb47df9e$export$b98e411ae80c806f}${key}`;
};
const $9a3d57dd1820cfdf$export$130f411261a599c5 = (_config, _data, globalConfig)=>{
    if (!globalConfig.ssr || !globalConfig.ssr.getTimings) return null;
    const timings = globalConfig.ssr.getTimings();
    if (!timings) return null;
    const ssrTimings = Object.entries(timings).reduce((acc, entry)=>{
        if ($9a3d57dd1820cfdf$var$filterEntry(entry[1])) acc[$9a3d57dd1820cfdf$var$mapKey(entry[0])] = $9a3d57dd1820cfdf$var$mapEntry(entry[1]);
        return acc;
    }, {});
    if (!ssrTimings || Object.keys(ssrTimings).length === 0) return null;
    return ssrTimings;
};

});


parcelRegister("8OzJH", function(module, exports) {

$parcel$export(module.exports, "bundleEvalTimings", () => $76714ed0d5e694f5$export$1a2bb347935fc536);
const $76714ed0d5e694f5$var$bundleEvalTimingsInternal = (_config, data, globalConfig, performance = window.performance)=>{
    const started = {};
    const timings = {};
    const enableBundleEvalTimings = globalConfig?.enableBundleEvalTimings ?? true;
    performance.getEntriesByType('mark').forEach((mark)=>{
        if (!globalConfig.bundleEvalTimings) return;
        const result = globalConfig.bundleEvalTimings.mapPerformanceMark(mark.name);
        if (!result) return;
        const { type: type, name: name } = result;
        if (type === 'start' && data.start !== null && mark.startTime >= data.start) {
            started[name] = mark;
            return;
        }
        if (type === 'end' && started[name]) {
            timings[name] = {
                startTime: Math.round(started[name].startTime - data.start),
                duration: Math.round(mark.startTime - started[name].startTime)
            };
            delete started[name];
        }
    });
    if (globalConfig.bundleEvalTimings && globalConfig.bundleEvalTimings.additionalTimings && data.start !== null && enableBundleEvalTimings) {
        const result = globalConfig.bundleEvalTimings.additionalTimings(data.start);
        if (result) Object.entries(result).forEach(([key, value])=>{
            timings[key] = value;
        });
    }
    if (Object.keys(timings).length === 0) return null;
    return {
        'timings:bundleEval': timings
    };
};
const $76714ed0d5e694f5$export$1a2bb347935fc536 = (...args)=>{
    return new Promise((resolve)=>{
        setTimeout(()=>{
            resolve($76714ed0d5e694f5$var$bundleEvalTimingsInternal(...args));
        });
    });
};

});

parcelRegister("iGCEo", function(module, exports) {

$parcel$export(module.exports, "resourceTimings", () => $e88a389596209510$export$81a7d52441a06b50);
const $e88a389596209510$var$cacheableTypes = [
    'script',
    'link'
];
const $e88a389596209510$var$resourceTypes = [
    'fetch',
    'xmlhttprequest'
];
const $e88a389596209510$var$CACHE_NETWORK = 'network';
const $e88a389596209510$var$CACHE_MEMORY = 'memory';
const $e88a389596209510$var$CACHE_DISK = 'disk';
const $e88a389596209510$var$calculateTransferType = (type, duration, size)=>{
    if (!$e88a389596209510$var$cacheableTypes.includes(type)) return $e88a389596209510$var$CACHE_NETWORK;
    if ((size === undefined || size === 0) && duration === 0) return $e88a389596209510$var$CACHE_MEMORY;
    if (size === 0 && duration > 0) return $e88a389596209510$var$CACHE_DISK;
    if (size === undefined) return null;
    return $e88a389596209510$var$CACHE_NETWORK;
};
const $e88a389596209510$var$hasAccessToResourceSize = (url, type, hasTimingHeaders)=>{
    return !$e88a389596209510$var$cacheableTypes.includes(type) || url.includes('localhost') || url.includes(window.location.hostname) || hasTimingHeaders(url);
};
const $e88a389596209510$var$getReportedInitiatorTypes = (xhrEnabled)=>{
    if (xhrEnabled) return [
        'script',
        'link',
        'fetch',
        'xmlhttprequest'
    ];
    return [
        'script',
        'link',
        'fetch'
    ];
};
const $e88a389596209510$var$withoutHeaders = ()=>false;
const $e88a389596209510$var$evaluateAccessToResourceTimings = (entry)=>{
    if (entry.responseStart === 0 && entry.startTime > entry.responseStart) return false;
    return true;
};
const $e88a389596209510$var$getEvaluatedTimingHeader = (entry, enabled = false, hasTimingHeaders = $e88a389596209510$var$withoutHeaders)=>{
    if (!enabled) return null;
    const manualResolution = entry.name.includes('localhost') || entry.name.includes(window.location.hostname) || hasTimingHeaders(entry.name);
    const autoResolution = $e88a389596209510$var$evaluateAccessToResourceTimings(entry);
    return {
        m_h: manualResolution,
        a_h: autoResolution
    };
};
const $e88a389596209510$var$getSizeObject = (size)=>size !== undefined ? {
        size: size
    } : null;
const $e88a389596209510$var$getNetworkData = (item, eventStart, hasTimingHeaders = $e88a389596209510$var$withoutHeaders)=>{
    const { name: name, duration: duration, transferSize: size, initiatorType: type, responseStart: responseStart } = item;
    const ttfb = Math.round(responseStart - eventStart);
    if (!$e88a389596209510$var$hasAccessToResourceSize(name, type, hasTimingHeaders)) return {};
    if ($e88a389596209510$var$cacheableTypes.includes(type)) {
        const transferType = $e88a389596209510$var$calculateTransferType(type, duration, size);
        if (!transferType) return {
            ttfb: ttfb,
            ...$e88a389596209510$var$getSizeObject(size)
        };
        if (transferType !== $e88a389596209510$var$CACHE_NETWORK) return {
            transferType: transferType
        };
        return {
            ttfb: ttfb,
            transferType: transferType,
            ...$e88a389596209510$var$getSizeObject(size)
        };
    }
    return {
        ttfb: ttfb,
        ...$e88a389596209510$var$getSizeObject(size)
    };
};
const $e88a389596209510$export$81a7d52441a06b50 = (_config, data, globalConfig, performance = window.performance)=>{
    if (data.start === null) return null;
    const resources = performance.getEntriesByType('resource').filter((entry)=>entry.startTime >= data.start);
    if (!resources.length) return null;
    const resourceTiming = {};
    const { xhrFilter: xhrFilter } = globalConfig.resourceTimings;
    const reportedInitiatorTypes = $e88a389596209510$var$getReportedInitiatorTypes(!!xhrFilter);
    resources.forEach((item)=>{
        if (!reportedInitiatorTypes.includes(item.initiatorType)) return;
        const { name: name, startTime: startTime, duration: duration, workerStart: workerStart, fetchStart: fetchStart, initiatorType: type } = item;
        if (!name) return;
        if (type === 'xmlhttprequest' && (xhrFilter === undefined || xhrFilter(name) === false)) return;
        const url = $e88a389596209510$var$resourceTypes.includes(type) ? globalConfig.resourceTimings.sanitiseEndpoints(name) : globalConfig.resourceTimings.mapResources(name);
        if (resourceTiming[url]) return;
        resourceTiming[url] = {
            startTime: Math.round(startTime - data.start),
            duration: Math.round(duration),
            workerStart: Math.max(Math.round(workerStart - data.start), 0),
            fetchStart: Math.max(Math.round(fetchStart - data.start), 0),
            type: type,
            ...$e88a389596209510$var$getNetworkData(item, data.start, globalConfig.resourceTimings.hasTimingHeaders),
            ...$e88a389596209510$var$getEvaluatedTimingHeader(item, globalConfig.resourceTimings.experimental__reportEvaluatedTimingHeaders, globalConfig.resourceTimings.hasTimingHeaders)
        };
    });
    return {
        'timings:resource': resourceTiming
    };
};

});


parcelRegister("c0TQq", function(module, exports) {

$parcel$export(module.exports, "makeShareableGlobalConfig", () => $eafda1554524493c$export$5b4fb14409a2a825);

var $5zeHM = parcelRequire("5zeHM");
const $eafda1554524493c$var$makeFeatureFlags = (allFeatureFlags, eventTypeFeatureFlags)=>{
    const featureFlagsForType = [];
    if (allFeatureFlags) featureFlagsForType.push(...allFeatureFlags);
    if (eventTypeFeatureFlags) featureFlagsForType.push(...eventTypeFeatureFlags);
    return featureFlagsForType;
};
const $eafda1554524493c$var$makeGlobalConfigPerType = (global, ffClient, allEventsConfig, eventConfig)=>{
    const allEventsConfigCustom = allEventsConfig && allEventsConfig.custom;
    const eventConfigCustom = eventConfig && eventConfig.custom;
    const custom = (allEventsConfigCustom || eventConfigCustom) && {
        ...allEventsConfigCustom,
        ...eventConfigCustom
    } || undefined;
    const allEventsConfigPlugins = allEventsConfig && allEventsConfig.plugins;
    const eventConfigPlugins = eventConfig && eventConfig.plugins;
    const plugins = (allEventsConfigPlugins || eventConfigPlugins) && [
        ...allEventsConfigPlugins || [],
        ...eventConfigPlugins || []
    ] || undefined;
    const pageVisibleValueOrigin = eventConfig?.pageVisibleValueOrigin ?? allEventsConfig?.pageVisibleValueOrigin ?? (0, $5zeHM.PageVisibleValueOrigin).documentHidden;
    return Object.freeze({
        ...global,
        featureFlags: Object.freeze($eafda1554524493c$var$makeFeatureFlags(allEventsConfig && allEventsConfig.featureFlags, eventConfig && eventConfig.featureFlags).reduce((acc, value)=>{
            acc[value] = ffClient.getValue(value);
            return acc;
        }, {})),
        custom: custom,
        plugins: plugins,
        histogram: eventConfig?.histogram,
        pageVisibleValueOrigin: pageVisibleValueOrigin,
        enableBundleEvalTimings: eventConfig?.enableBundleEvalTimings
    });
};
const $eafda1554524493c$export$5b4fb14409a2a825 = async (globalConfig)=>{
    const ffClient = await globalConfig.plugins.featureFlags.client;
    const global = {
        app: globalConfig.info.app,
        product: globalConfig.info.product,
        region: globalConfig.info.region,
        resourceTimings: globalConfig.plugins.resourceTimings,
        bundleEvalTimings: globalConfig.plugins.bundleEvalTimings,
        ffClient: ffClient,
        hostname: globalConfig.info.hostname || window.location.hostname,
        ssr: globalConfig.ssr,
        enableReactUFOTracker: globalConfig.enableReactUFOTracker,
        webVitals: {
            enabled: globalConfig.events[(0, $5zeHM.BMEventsType).WEB_VITALS]?.enabled,
            timeout: globalConfig.events[(0, $5zeHM.BMEventsType).WEB_VITALS]?.timeout,
            ttciEnabled: globalConfig.events[(0, $5zeHM.BMEventsType).WEB_VITALS]?.ttciEnabled
        }
    };
    return {
        [(0, $5zeHM.BMEventsType).PAGE_LOAD]: $eafda1554524493c$var$makeGlobalConfigPerType(global, ffClient, globalConfig.events.all, globalConfig.events[(0, $5zeHM.BMEventsType).PAGE_LOAD]),
        [(0, $5zeHM.BMEventsType).PAGE_SEGMENT_LOAD]: $eafda1554524493c$var$makeGlobalConfigPerType(global, ffClient, globalConfig.events.all, globalConfig.events[(0, $5zeHM.BMEventsType).PAGE_SEGMENT_LOAD]),
        [(0, $5zeHM.BMEventsType).INLINE_RESULT]: $eafda1554524493c$var$makeGlobalConfigPerType(global, ffClient, globalConfig.events.all, globalConfig.events[(0, $5zeHM.BMEventsType).INLINE_RESULT]),
        [(0, $5zeHM.BMEventsType).CUSTOM]: $eafda1554524493c$var$makeGlobalConfigPerType(global, ffClient, globalConfig.events.all, globalConfig.events[(0, $5zeHM.BMEventsType).CUSTOM]),
        [(0, $5zeHM.BMEventsType).WEB_VITALS]: $eafda1554524493c$var$makeGlobalConfigPerType(global, ffClient, globalConfig.events.all, globalConfig.events[(0, $5zeHM.BMEventsType).WEB_VITALS])
    };
};

});



parcelRegister("4Y9NK", function(module, exports) {

$parcel$export(module.exports, "ufologger", () => $1cd5c7b1887808aa$export$4ab84f6f04f6566d);
$parcel$export(module.exports, "ufolog", () => $1cd5c7b1887808aa$export$b4958caff08a0960);
$parcel$export(module.exports, "ufowarn", () => $1cd5c7b1887808aa$export$d53d07b6034c4560);
class $1cd5c7b1887808aa$var$UFOLogger {
    static{
        this.UFOprefix = "[ufo\uD83D\uDEF8]";
    }
    log(...args) {
        // eslint-disable-next-line no-console
        this.enabled && console.log($1cd5c7b1887808aa$var$UFOLogger.UFOprefix, ...args);
    }
    warn(...args) {
        // eslint-disable-next-line no-console
        this.enabled && console.warn($1cd5c7b1887808aa$var$UFOLogger.UFOprefix, ...args);
    }
    enable() {
        this.enabled = true;
    }
    disable() {
        this.enabled = false;
    }
    constructor(){
        this.enabled = false;
    }
}
const $1cd5c7b1887808aa$export$4ab84f6f04f6566d = new $1cd5c7b1887808aa$var$UFOLogger();
const $1cd5c7b1887808aa$export$b4958caff08a0960 = (...args)=>{
    $1cd5c7b1887808aa$export$4ab84f6f04f6566d.log(...args);
};
const $1cd5c7b1887808aa$export$d53d07b6034c4560 = (...args)=>{
    $1cd5c7b1887808aa$export$4ab84f6f04f6566d.warn(...args);
};

});

parcelRegister("3Aj5i", function(module, exports) {

$parcel$export(module.exports, "isWindowObjectAvailable", () => $c4b068a8f0fb134b$export$15e172712955e18f);
const $c4b068a8f0fb134b$export$15e172712955e18f = ()=>{
    return typeof window !== 'undefined';
};

});

parcelRegister("9ONoC", function(module, exports) {

$parcel$export(module.exports, "getGlobalEventStream", () => $6527403feebefb8a$export$6123a44dc2384540);
$parcel$export(module.exports, "setGlobalEventStream", () => $6527403feebefb8a$export$c1522520b417b066);
$parcel$export(module.exports, "subscribeEvent", () => $6527403feebefb8a$export$37863216db4b714d);
$parcel$export(module.exports, "unsubscribeEvent", () => $6527403feebefb8a$export$ee1a7bd1fc9ea85e);
$parcel$export(module.exports, "experiencePayloadEvent", () => $6527403feebefb8a$export$7c957416596ca127);

var $4Y9NK = parcelRequire("4Y9NK");

var $iPwfg = parcelRequire("iPwfg");
const $6527403feebefb8a$var$MAX_EARLY_QUEUE_LENGTH = 250;
const $6527403feebefb8a$export$6123a44dc2384540 = ()=>{
    if (!globalThis.__UFO_GLOBAL_EVENT_STREAM__) {
        const earlyStream = (()=>{
            const stream = [];
            return {
                __buffer_only__: true,
                push: (event)=>{
                    if (stream.length < $6527403feebefb8a$var$MAX_EARLY_QUEUE_LENGTH) stream.push(event);
                },
                getStream: ()=>stream
            };
        })();
        globalThis.__UFO_GLOBAL_EVENT_STREAM__ = earlyStream;
    }
    return globalThis.__UFO_GLOBAL_EVENT_STREAM__;
};
const $6527403feebefb8a$export$c1522520b417b066 = (eventStream)=>{
    if (globalThis.__UFO_GLOBAL_EVENT_STREAM__ && !globalThis.__UFO_GLOBAL_EVENT_STREAM__?.__buffer_only__) {
        (0, $4Y9NK.ufowarn)('Global Event Stream already initialised. Ignoring new event stream setup');
        return;
    }
    if (globalThis.__UFO_GLOBAL_EVENT_STREAM__?.__buffer_only__) globalThis.__UFO_GLOBAL_EVENT_STREAM__.getStream().forEach(eventStream.push.bind(eventStream));
    globalThis.__UFO_GLOBAL_EVENT_STREAM__ = eventStream;
};
const $6527403feebefb8a$export$37863216db4b714d = (experienceId, callback)=>{
    return {
        type: (0, $iPwfg.UFOGlobalEventStreamEventType).SUBSCRIBE,
        payload: {
            experienceId: experienceId,
            callback: callback
        }
    };
};
const $6527403feebefb8a$export$ee1a7bd1fc9ea85e = (experienceId, callback)=>{
    return {
        type: (0, $iPwfg.UFOGlobalEventStreamEventType).UNSUBSCRIBE,
        payload: {
            experienceId: experienceId,
            callback: callback
        }
    };
};
const $6527403feebefb8a$export$7c957416596ca127 = (data)=>{
    return {
        type: (0, $iPwfg.UFOGlobalEventStreamEventType).EXPERIENCE_PAYLOAD,
        payload: data
    };
};

});
parcelRegister("iPwfg", function(module, exports) {

$parcel$export(module.exports, "UFOGlobalEventStreamEventType", () => $6a90602d8f7fe4a0$export$96253c35c37cf96b);
$parcel$export(module.exports, "PageVisibleState", () => $6a90602d8f7fe4a0$export$a12c67b37a306b13);
$parcel$export(module.exports, "SUBSCRIBE_ALL", () => $6a90602d8f7fe4a0$export$79bf131685ad41d7);
$parcel$export(module.exports, "FMP_MARK", () => $6a90602d8f7fe4a0$export$9f2bf58999404c75);
$parcel$export(module.exports, "INLINE_RESPONSE_MARK", () => $6a90602d8f7fe4a0$export$837e0f79a8056912);
var $6a90602d8f7fe4a0$export$96253c35c37cf96b = /*#__PURE__*/ function(UFOGlobalEventStreamEventType) {
    UFOGlobalEventStreamEventType[UFOGlobalEventStreamEventType["EXPERIENCE_PAYLOAD"] = 0] = "EXPERIENCE_PAYLOAD";
    UFOGlobalEventStreamEventType[UFOGlobalEventStreamEventType["SUBSCRIBE"] = 1] = "SUBSCRIBE";
    UFOGlobalEventStreamEventType[UFOGlobalEventStreamEventType["UNSUBSCRIBE"] = 2] = "UNSUBSCRIBE";
    return UFOGlobalEventStreamEventType;
}({});
var $6a90602d8f7fe4a0$export$a12c67b37a306b13 = /*#__PURE__*/ function(PageVisibleState) {
    PageVisibleState["VISIBLE"] = "visible";
    PageVisibleState["HIDDEN"] = "hidden";
    PageVisibleState["MIXED"] = "mixed";
    return PageVisibleState;
}({});
var $6a90602d8f7fe4a0$export$66b33c055cbb625e = /*#__PURE__*/ function(PageLoadMetrics) {
    PageLoadMetrics["fmp"] = "fmp";
    PageLoadMetrics["tti"] = "tti";
    return PageLoadMetrics;
}({});
var $6a90602d8f7fe4a0$export$3ce489cbe02dc21b = /*#__PURE__*/ function(PageSegmentLoadMetrics) {
    PageSegmentLoadMetrics["fmp"] = "fmp";
    PageSegmentLoadMetrics["tti"] = "tti";
    return PageSegmentLoadMetrics;
}({});
var $6a90602d8f7fe4a0$export$341b330828bd3906 = /*#__PURE__*/ function(InteractionMetrics) {
    InteractionMetrics["response"] = "response";
    InteractionMetrics["result"] = "result";
    return InteractionMetrics;
}({});
var $6a90602d8f7fe4a0$export$b9b20160f581e4f8 = /*#__PURE__*/ function(CustomMetrics) {
    CustomMetrics["duration"] = "duration";
    return CustomMetrics;
}({});
const $6a90602d8f7fe4a0$export$79bf131685ad41d7 = '__SUBSCRIBE_ALL__';
const $6a90602d8f7fe4a0$export$9f2bf58999404c75 = 'fmp';
const $6a90602d8f7fe4a0$export$837e0f79a8056912 = 'inline-response';

});


parcelRegister("4Lpom", function(module, exports) {

$parcel$export(module.exports, "visibilityChangeObserver", () => $c2b62e69d944d00a$export$13e680397ec8f3eb);

var $3Aj5i = parcelRequire("3Aj5i");
class $c2b62e69d944d00a$var$VisibilityChangeObserver {
    start() {
        if (this.started) return;
        this.started = true;
        document.addEventListener('visibilitychange', this.broadcast);
        /**
		 * According to https://developer.mozilla.org/en-US/docs/Web/API/Document/visibilitychange_event
		 * Safari doesn’t fire visibilitychange as expected when the value of the visibilityState property transitions to hidden;
		 * so for that case, you need to also include code to listen for the pagehide event.
		 */ if ((0, $3Aj5i.isWindowObjectAvailable)()) window.addEventListener('pagehide', this.broadcast);
    }
    subscribe(callback) {
        this.observers.push(callback);
    }
    unsubscribe(callback) {
        this.observers = this.observers.filter((fn)=>fn !== callback);
    }
    constructor(){
        this.started = false;
        this.observers = [];
        this.broadcast = ()=>{
            this.observers.forEach((fn)=>fn());
            this.observers = [];
        };
    }
}
const $c2b62e69d944d00a$export$13e680397ec8f3eb = new $c2b62e69d944d00a$var$VisibilityChangeObserver();

});

parcelRegister("aRK4c", function(module, exports) {

$parcel$export(module.exports, "ExperienceTypes", () => $59d09c68562504f0$export$994164cf3ae1cc9a);
$parcel$export(module.exports, "ExperiencePerformanceTypes", () => $59d09c68562504f0$export$cc26007c03242fff);
var $59d09c68562504f0$export$994164cf3ae1cc9a = /*#__PURE__*/ function(ExperienceTypes) {
    ExperienceTypes["Load"] = "load";
    ExperienceTypes["Experience"] = "experience";
    ExperienceTypes["Operation"] = "operation";
    return ExperienceTypes;
}({});
var $59d09c68562504f0$export$cc26007c03242fff = /*#__PURE__*/ function(ExperiencePerformanceTypes) {
    ExperiencePerformanceTypes["PageLoad"] = "page-load";
    ExperiencePerformanceTypes["PageSegmentLoad"] = "page-segment-load";
    ExperiencePerformanceTypes["InlineResult"] = "inline-result";
    ExperiencePerformanceTypes["Custom"] = "custom";
    return ExperiencePerformanceTypes;
}({});

});

parcelRegister("3fZJx", function(module, exports) {

$parcel$export(module.exports, "default", () => $6499e84b7fa59165$export$2e2bcd8739ae039);

var $kjwqB = parcelRequire("kjwqB");
var $6499e84b7fa59165$export$2e2bcd8739ae039 = (0, $kjwqB.default);

});
parcelRegister("kjwqB", function(module, exports) {

$parcel$export(module.exports, "default", () => $406aa8f00b180d77$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $h1VbR = parcelRequire("h1VbR");

var $fKzuJ = parcelRequire("fKzuJ");
var $cKNzv = parcelRequire("cKNzv");
function $406aa8f00b180d77$export$2e2bcd8739ae039({ name: name, children: children, fallback: fallback = null }) {
    const waitContext = (0, $eJOHy.useContext)((0, $cKNzv.WaitContext));
    const shouldHold = !waitContext || !!waitContext.currentValue();
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $fKzuJ.LazySuspense), {
        fallback: /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $gt9Am.Fragment), {
            children: [
                fallback,
                /*#__PURE__*/ (0, $gt9Am.jsx)((0, $h1VbR.default), {
                    name: name,
                    hold: shouldHold
                })
            ]
        }),
        name: name,
        children: children
    });
}

});
parcelRegister("h1VbR", function(module, exports) {

$parcel$export(module.exports, "default", () => $c649bfeb19c1cb6d$export$2e2bcd8739ae039);

var $2AAlW = parcelRequire("2AAlW");
var $c649bfeb19c1cb6d$export$2e2bcd8739ae039 = (0, $2AAlW.default);

});
parcelRegister("2AAlW", function(module, exports) {

$parcel$export(module.exports, "default", () => $020e257f1b9dd285$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $cv2et = parcelRequire("cv2et");

var $1JCFI = parcelRequire("1JCFI");
const $020e257f1b9dd285$var$useLayoutEffectSAFE = typeof window === 'undefined' ? (0, $eJOHy.useEffect) : (0, $eJOHy.useLayoutEffect);
/**
 * Custom hook to track changes to the interaction ID.
 * Uses a subscription system to automatically update when the interaction ID changes.
 */ function $020e257f1b9dd285$var$useInteractionIdValue() {
    const interactionId = (0, $eJOHy.useContext)((0, $1JCFI.default));
    const [currentId, setCurrentId] = (0, $eJOHy.useState)(interactionId?.current || null);
    $020e257f1b9dd285$var$useLayoutEffectSAFE(()=>{
        setCurrentId(interactionId?.current || null);
        const unsubscribe = (0, $1JCFI.subscribeToInteractionIdChanges)((newId)=>{
            setCurrentId(newId);
        });
        return unsubscribe;
    }, [
        interactionId
    ]);
    return currentId;
}
function $020e257f1b9dd285$export$2e2bcd8739ae039({ children: children, name: name, hold: hold = true, experimental: experimental = false }) {
    const currentInteractionId = $020e257f1b9dd285$var$useInteractionIdValue();
    // react-18: useId instead
    const context = (0, $eJOHy.useContext)((0, $cv2et.default));
    $020e257f1b9dd285$var$useLayoutEffectSAFE(()=>{
        if (hold && context != null) {
            if (experimental && context.holdExperimental) return context.holdExperimental(name);
            return context.hold(name);
        }
    }, [
        hold,
        context,
        name,
        currentInteractionId
    ]);
    // react-18: can return children directly
    return children != null ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $gt9Am.Fragment), {
        children: children
    }) : null;
}

});


parcelRegister("fKzuJ", function(module, exports) {

$parcel$export(module.exports, "LazySuspense", () => $c0d0b6f41a19c21a$export$256c542058532d6f);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");
const $c0d0b6f41a19c21a$var$isNodeEnvironment = ()=>{
    return typeof window === 'undefined' || window.name === 'nodejs';
};
const $c0d0b6f41a19c21a$var$LazySuspenseContext = /*#__PURE__*/ (0, $eJOHy.createContext)({
    fallback: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $eJOHy.Fragment), {}),
    setFallback: ()=>{
        // eslint-disable-next-line no-console
        console.warn('Missing <LooselySuspense /> boundary');
    },
    name: ''
});
const $c0d0b6f41a19c21a$var$DynamicFallback = ({ children: children, outsideSuspense: outsideSuspense })=>{
    const { fallback: fallback, setFallback: setFallback } = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useContext($c0d0b6f41a19c21a$var$LazySuspenseContext);
    (0, $eJOHy.useLayoutEffect)(()=>{
        return ()=>{
            if (!outsideSuspense) setFallback(null);
        };
    }, [
        outsideSuspense,
        setFallback
    ]);
    return children(outsideSuspense ? null : fallback);
};
$c0d0b6f41a19c21a$var$DynamicFallback.displayName = 'DynamicFallback';
const $c0d0b6f41a19c21a$export$256c542058532d6f = ({ fallback: fallback, children: children, name: name })=>{
    const [hydrationFallback, setHydrationFallback] = (0, $eJOHy.useState)(null);
    const mountedRef = (0, $eJOHy.useRef)(false);
    (0, $eJOHy.useLayoutEffect)(()=>{
        mountedRef.current = true;
        return ()=>{
            mountedRef.current = false;
        };
    }, []);
    const contextValue = (0, $eJOHy.useMemo)(()=>({
            fallback: fallback,
            setFallback: (newFallback)=>{
                if (hydrationFallback === newFallback) return;
                setHydrationFallback(newFallback);
            },
            name: name
        }), [
        fallback,
        hydrationFallback,
        name
    ]);
    const renderFallback = (outsideSuspense)=>/*#__PURE__*/ (0, $gt9Am.jsx)($c0d0b6f41a19c21a$var$DynamicFallback, {
            outsideSuspense: outsideSuspense,
            children: (resolvedFallback)=>outsideSuspense && hydrationFallback ? hydrationFallback : resolvedFallback
        });
    return /*#__PURE__*/ (0, $gt9Am.jsx)($c0d0b6f41a19c21a$var$LazySuspenseContext.Provider, {
        value: contextValue,
        children: $c0d0b6f41a19c21a$var$isNodeEnvironment() ? children : /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $gt9Am.Fragment), {
            children: [
                /*#__PURE__*/ (0, $gt9Am.jsx)((0, $eJOHy.Suspense), {
                    fallback: renderFallback(false),
                    children: children
                }),
                (!mountedRef.current || hydrationFallback) && renderFallback(true)
            ]
        })
    });
};
$c0d0b6f41a19c21a$export$256c542058532d6f.displayName = 'LazySuspense';

});

parcelRegister("cKNzv", function(module, exports) {

$parcel$export(module.exports, "WaitContext", () => $2aec83c5cd8db406$export$9ba3fe09d15de47b);

var $eJOHy = parcelRequire("eJOHy");
const $2aec83c5cd8db406$export$9ba3fe09d15de47b = /*#__PURE__*/ (0, $eJOHy.createContext)({
    subscribe: ()=>()=>{},
    currentValue: ()=>1
});

});



parcelRegister("fi4iN", function(module, exports) {

$parcel$export(module.exports, "payloadPublisher", () => $318829fa8f1e6655$export$edb879ae55bb9be3);

var $aRK4c = parcelRequire("aRK4c");
var $4Lpom = parcelRequire("4Lpom");

var $9ONoC = parcelRequire("9ONoC");

var $4Y9NK = parcelRequire("4Y9NK");

var $iPwfg = parcelRequire("iPwfg");


var $aSbms = parcelRequire("aSbms");

var $jDTRw = parcelRequire("jDTRw");

var $k0rcb = parcelRequire("k0rcb");

var $avGph = parcelRequire("avGph");

var $kkhLR = parcelRequire("kkhLR");

var $aGiji = parcelRequire("aGiji");

var $7A9GV = parcelRequire("7A9GV");

var $e7KPV = parcelRequire("e7KPV");

var $78eNh = parcelRequire("78eNh");

var $eTZpK = parcelRequire("eTZpK");

var $lpC06 = parcelRequire("lpC06");

var $3xrw2 = parcelRequire("3xrw2");

var $MPirS = parcelRequire("MPirS");

var $blLYJ = parcelRequire("blLYJ");

var $1aRah = parcelRequire("1aRah");

var $kWmpU = parcelRequire("kWmpU");

var $eA0BY = parcelRequire("eA0BY");
const $318829fa8f1e6655$var$UNKNOWN_VALUE = 'unknown';
const $318829fa8f1e6655$var$DEFAULT_PAYLOAD_DATA = {
    schemaVersion: $318829fa8f1e6655$var$UNKNOWN_VALUE,
    id: $318829fa8f1e6655$var$UNKNOWN_VALUE,
    uuid: $318829fa8f1e6655$var$UNKNOWN_VALUE,
    state: {
        id: $318829fa8f1e6655$var$UNKNOWN_VALUE
    },
    result: {
        startTime: 0,
        duration: 0,
        success: false
    },
    type: (0, $aRK4c.ExperienceTypes).Experience,
    category: $318829fa8f1e6655$var$UNKNOWN_VALUE,
    performanceType: (0, $aRK4c.ExperiencePerformanceTypes).Custom,
    metadata: {},
    explicitTimings: {},
    metrics: {
        startTime: 0,
        endTime: 0,
        marks: []
    },
    platform: null,
    children: [],
    pageVisibleState: (0, $iPwfg.PageVisibleState).MIXED,
    isSSROutputAsFMP: false,
    timings: [],
    featureFlags: []
};
class $318829fa8f1e6655$var$Publisher {
    publish(data) {
        const payloadStart = (0, $eA0BY.getPerformanceObject)()?.now() || 0;
        const experienceKey = this.getExperienceKey(data);
        if (!this.allowlist(experienceKey, data)) {
            (0, $4Y9NK.ufowarn)(`experience ${experienceKey} does not meet requirements of allowlist`);
            return;
        }
        // it is used to setup default properties on the data to prevent errors
        const supportedData = {
            ...$318829fa8f1e6655$var$DEFAULT_PAYLOAD_DATA,
            ...data
        };
        const payload = {
            actionSubject: 'experience',
            action: 'measured',
            source: 'measured',
            tags: [
                'observability'
            ],
            attributes: {
                properties: {
                    'event:source': {
                        name: 'ufo/web',
                        version: supportedData.schemaVersion
                    },
                    'event:schema': (0, $94a8d665ce7cee64$export$93809551debf385f) || $318829fa8f1e6655$var$UNKNOWN_VALUE,
                    'event:product': this.product,
                    'event:region': this.region,
                    'event:hostname': this.hostname,
                    'event:route': this.route.getRoute(),
                    ...(0, $e7KPV.eventBrowserPlugin)(),
                    ...(0, $78eNh.eventCpusPlugin)(),
                    ...(0, $lpC06.eventMemoryPlugin)(),
                    ...(0, $3xrw2.eventNetworkPlugin)(),
                    ...(0, $aGiji.appFramework)(this.app),
                    ...(0, $7A9GV.appVersion)(this.app),
                    'experience:name': supportedData.id,
                    // platform.fe.page-load|interaction|custom|page-segment.editor
                    'experience:key': experienceKey,
                    'experience:status': supportedData.state.id,
                    'experience:duration': supportedData.result.duration,
                    ...supportedData.result.startTime !== null ? {
                        'experience:startTime': supportedData.result.startTime
                    } : null,
                    ...supportedData.uuid ? {
                        'experience:spanId': supportedData.uuid
                    } : null,
                    ...this.tenantType !== (0, $aSbms.TenantType).RealUser ? {
                        'event:tenantType': this.tenantType
                    } : null,
                    ...this.mapMetadataToPayload(supportedData.metadata),
                    ...this.extractPageLoadData(supportedData),
                    ...(0, $avGph.pageVisibleState)(supportedData),
                    ...(0, $kWmpU.isInitialPageLoad)(supportedData) && (0, $blLYJ.ssrSuccess)(this.ssr),
                    ...(0, $kWmpU.isInitialPageLoad)(supportedData) && (0, $MPirS.ssrFeatureFlags)(this.ssr),
                    ...this.featureFlagClient && (0, $eTZpK.featureFlags)(this.featureFlagClient, this.featureFlags, supportedData)
                },
                performance: this.getPerformanceMetrics(supportedData),
                task: supportedData.id
            }
        };
        const payloadEnd = (0, $eA0BY.getPerformanceObject)()?.now() || 0;
        payload.attributes.performance.payloadTime = payloadEnd - payloadStart;
        if (this.gasv3) this.gasv3.sendOperationalEvent(payload);
        else this.buffer.push(payload);
        (0, $4Y9NK.ufolog)('PAYLOAD:', JSON.stringify(payload, null, 2));
    }
    setGlobalEventStream() {
        if (!((0, $9ONoC.getGlobalEventStream)() instanceof (0, $jDTRw.UFOGlobalEventStream))) {
            const eventStream = new (0, $jDTRw.UFOGlobalEventStream)();
            eventStream.push({
                type: (0, $iPwfg.UFOGlobalEventStreamEventType).SUBSCRIBE,
                payload: {
                    experienceId: '__SUBSCRIBE_ALL__',
                    callback: this.publish.bind(this)
                }
            });
            (0, $9ONoC.setGlobalEventStream)(eventStream);
        }
    }
    setRoute(newRoute) {
        this.route.setRoute(newRoute);
    }
    setup(config) {
        (0, $4Lpom.visibilityChangeObserver).start();
        (0, $kkhLR.resourceTimingBuffer).start();
        if (!this.product) this.product = config.product || '';
        if (config.allowlist) this.allowlist = config.allowlist;
        if (config.tenantType) this.tenantType = config.tenantType;
        if (config.hostname) this.hostname = config.hostname;
        if (config.region) this.region = config.region;
        if (config.app) this.app = config.app;
        if (config.featureFlagClient) this.featureFlagClient = config.featureFlagClient;
        if (config.featureFlags) this.featureFlags = config.featureFlags;
        if (config.ssr) this.ssr = config.ssr;
        if (config.bundleEvalTimings) this.bundleEvalTimings = config.bundleEvalTimings;
        if (config.resourceTimings) this.resourceTimings = config.resourceTimings;
        if (config.performanceConfig) this.performanceConfig = config.performanceConfig;
        if (config.plugins) this.plugins = config.plugins;
        this.setGlobalEventStream();
        if (!this.gasv3) {
            this.gasv3 = config.gasv3;
            this.buffer.forEach(this.gasv3.sendOperationalEvent);
        }
    }
    mapMetadataToPayload(metadata) {
        const payload = {};
        Object.entries(metadata).forEach(([key, value])=>{
            if (value !== undefined) payload[`custom:${key}`] = value;
        });
        return payload;
    }
    extractPageLoadData(data) {
        if ('initial' in data) return {
            'experience:pageLoadType': data.initial ? 'initial' : 'transition'
        };
        return {};
    }
    getPrefix(data) {
        if (data.platform !== null) return 'platform';
        return this.product;
    }
    getExperienceKey(data) {
        const keyParts = [
            this.getPrefix(data),
            'fe',
            data.type
        ];
        if (data.platform) keyParts.push(data.platform.component);
        keyParts.push(data.id);
        return keyParts.join('.');
    }
    getExperiencePerformanceKey(data) {
        const keyParts = [
            this.getPrefix(data),
            'fe',
            data.performanceType
        ];
        if (data.platform) keyParts.push(data.platform.component);
        keyParts.push(data.id);
        return keyParts.join('.');
    }
    getExperiencePerformanceType(data) {
        return data.performanceType;
    }
    getPerformanceMetrics(data) {
        return {
            'event:key': this.getExperiencePerformanceKey(data),
            'event:type': this.getExperiencePerformanceType(data),
            ...(0, $k0rcb.getPerformancePayload)(data, this.ssr, this.bundleEvalTimings, this.resourceTimings, this.performanceConfig),
            ...this.getPluginsMetrics(data)
        };
    }
    constructor(){
        this.gasv3 = null;
        this.product = '';
        this.region = $318829fa8f1e6655$var$UNKNOWN_VALUE;
        this.hostname = (0, $eA0BY.getWindowObject)()?.location?.hostname || '';
        this.tenantType = (0, $aSbms.TenantType).RealUser;
        this.app = {
            version: {
                web: $318829fa8f1e6655$var$UNKNOWN_VALUE
            }
        };
        this.performanceConfig = {};
        this.buffer = [];
        this.featureFlagClient = null;
        this.featureFlags = [];
        this.ssr = null;
        this.resourceTimings = null;
        this.bundleEvalTimings = null;
        this.route = (0, $1aRah.Route);
        this.plugins = null;
        this.allowlist = ()=>true;
        this.getPluginsMetrics = (data)=>{
            const result = {};
            if (this.plugins) this.plugins.forEach((plugin)=>{
                const pluginOutput = plugin({
                    ...data
                });
                if (pluginOutput === null || typeof pluginOutput !== 'object') return;
                Object.entries(pluginOutput).forEach(([key, value])=>{
                    result[`${this.product}:${key}`] = value;
                });
            });
            return result;
        };
    }
}
const $318829fa8f1e6655$export$edb879ae55bb9be3 = new $318829fa8f1e6655$var$Publisher();

});
// temp solution until a proper versioning
const $94a8d665ce7cee64$export$93809551debf385f = '0.1.7';

parcelRegister("aSbms", function(module, exports) {

$parcel$export(module.exports, "TenantType", () => $eb482f2d9cdf0010$export$92a757ac1398962f);

var $eb482f2d9cdf0010$export$92a757ac1398962f = /*#__PURE__*/ function(TenantType) {
    TenantType["RealUser"] = "real-user";
    TenantType["Synthetic"] = "synthetic";
    return TenantType;
}({});

});

parcelRegister("jDTRw", function(module, exports) {

$parcel$export(module.exports, "UFOGlobalEventStream", () => $4d73f32d6485c9d4$export$faf4c91b80fc830e);

var $4Y9NK = parcelRequire("4Y9NK");

var $iPwfg = parcelRequire("iPwfg");
class $4d73f32d6485c9d4$export$faf4c91b80fc830e {
    push(event) {
        (0, $4Y9NK.ufolog)('EVENT STREAM push', event.type, event.payload);
        if (event.type === (0, $iPwfg.UFOGlobalEventStreamEventType).EXPERIENCE_PAYLOAD) this.publish(event.payload);
        if (event.type === (0, $iPwfg.UFOGlobalEventStreamEventType).SUBSCRIBE) this.subscribe(event.payload.experienceId, event.payload.callback);
        if (event.type === (0, $iPwfg.UFOGlobalEventStreamEventType).UNSUBSCRIBE) this.unsubscribe(event.payload.experienceId, event.payload.callback);
    }
    publish(eventPayload) {
        if (this.subscribers[0, $iPwfg.SUBSCRIBE_ALL]) this.subscribers[0, $iPwfg.SUBSCRIBE_ALL].forEach((fn)=>{
            fn(eventPayload);
        });
        this.subscribers[eventPayload.id]?.forEach((fn)=>{
            fn(eventPayload);
        });
    }
    subscribe(experienceId, fn) {
        (0, $4Y9NK.ufolog)('EVENT STREAM subscribe', experienceId);
        if (!this.subscribers[experienceId]) this.subscribers[experienceId] = [];
        this.subscribers[experienceId].push(fn);
    }
    unsubscribe(experienceId, fn) {
        const index = this.subscribers[experienceId].findIndex((entry)=>entry === fn);
        if (index !== -1) this.subscribers[experienceId].splice(index, 1);
    }
    constructor(){
        this.__buffer_only__ = false;
        this.subscribers = {};
    }
}

});

parcelRegister("k0rcb", function(module, exports) {

$parcel$export(module.exports, "getPerformancePayload", () => $8cc07ee0fef4e638$export$738d24377baf6a5e);

var $aRK4c = parcelRequire("aRK4c");

var $iPwfg = parcelRequire("iPwfg");

var $kWmpU = parcelRequire("kWmpU");

var $l3RvI = parcelRequire("l3RvI");

var $9EOmu = parcelRequire("9EOmu");

var $jjxIT = parcelRequire("jjxIT");

var $hLsQ8 = parcelRequire("hLsQ8");
const $8cc07ee0fef4e638$var$LoadMetricKeys = {
    tti: 'metric:tti',
    fmp: 'metric:fmp',
    ttiHistograms: 'metric:tti:histogramBuckets',
    fmpHistograms: 'metric:fmp:histogramBuckets'
};
const $8cc07ee0fef4e638$var$InlineResultMetricKeys = {
    result: 'metric:result',
    response: 'metric:response',
    resultHistograms: 'metric:result:histogramBuckets',
    responseHistograms: 'metric:response:histogramBuckets'
};
const $8cc07ee0fef4e638$var$CustomMetricKeys = {
    duration: 'metric:duration',
    durationHistograms: 'metric:duration:histogramBuckets'
};
const $8cc07ee0fef4e638$var$getHistogram = (data, performanceConfig, isInitial)=>{
    let histogram = {};
    if (data.performanceConfig?.histogram) histogram = data.performanceConfig.histogram;
    else if (performanceConfig?.histogram) histogram = performanceConfig.histogram;
    if (histogram) {
        const histograms = histogram[data.performanceType];
        switch(data.performanceType){
            case (0, $aRK4c.ExperiencePerformanceTypes).PageLoad:
            case (0, $aRK4c.ExperiencePerformanceTypes).PageSegmentLoad:
                const histogramType = isInitial !== undefined && isInitial === true ? 'initial' : 'transition';
                return histograms ? {
                    [$8cc07ee0fef4e638$var$LoadMetricKeys.ttiHistograms]: histograms[histogramType].tti,
                    [$8cc07ee0fef4e638$var$LoadMetricKeys.fmpHistograms]: histograms[histogramType].fmp
                } : {};
            case (0, $aRK4c.ExperiencePerformanceTypes).InlineResult:
                return histograms ? {
                    [$8cc07ee0fef4e638$var$InlineResultMetricKeys.resultHistograms]: histograms.result,
                    [$8cc07ee0fef4e638$var$InlineResultMetricKeys.responseHistograms]: histograms.response
                } : {};
            case (0, $aRK4c.ExperiencePerformanceTypes).Custom:
                return histograms ? {
                    [$8cc07ee0fef4e638$var$CustomMetricKeys.durationHistograms]: histograms.duration
                } : {};
        }
    }
    return undefined;
};
const $8cc07ee0fef4e638$export$bd4e6d81a822ece6 = (data, ssr, performanceConfig)=>{
    if (data.metrics.endTime === null || data.metrics.startTime === null) return null;
    const fmpMark = data.metrics.marks.find((mark)=>mark.name === (0, $iPwfg.FMP_MARK))?.time || (0, $kWmpU.isInitialPageLoad)(data) && ssr?.getDoneMark();
    const tti = data.metrics.endTime - data.metrics.startTime;
    const fmp = typeof fmpMark === 'number' ? fmpMark - data.metrics.startTime : tti;
    return {
        [$8cc07ee0fef4e638$var$LoadMetricKeys.tti]: Math.round(tti),
        [$8cc07ee0fef4e638$var$LoadMetricKeys.fmp]: Math.round(fmp),
        ...$8cc07ee0fef4e638$var$getHistogram(data, performanceConfig)
    };
};
const $8cc07ee0fef4e638$export$47f0208fd62dffce = (data, performanceConfig)=>{
    if (data.metrics.endTime === null || data.metrics.startTime === null) return null;
    const responseMark = data.metrics.marks.find((mark)=>mark.name === (0, $iPwfg.INLINE_RESPONSE_MARK));
    const result = data.metrics.endTime - data.metrics.startTime;
    const response = responseMark ? responseMark.time - data.metrics.startTime : result;
    return {
        [$8cc07ee0fef4e638$var$InlineResultMetricKeys.result]: Math.round(result),
        [$8cc07ee0fef4e638$var$InlineResultMetricKeys.response]: Math.round(response),
        ...$8cc07ee0fef4e638$var$getHistogram(data, performanceConfig)
    };
};
const $8cc07ee0fef4e638$export$c25c1b3ff2ce92cf = (data, performanceConfig)=>{
    if (data.metrics.endTime === null || data.metrics.startTime === null) return null;
    const duration = data.metrics.endTime - data.metrics.startTime;
    return {
        [$8cc07ee0fef4e638$var$CustomMetricKeys.duration]: Math.round(duration),
        ...$8cc07ee0fef4e638$var$getHistogram(data, performanceConfig)
    };
};
const $8cc07ee0fef4e638$var$getPerformanceMetrics = (data, ssr, performanceConfig)=>{
    switch(data.performanceType){
        case (0, $aRK4c.ExperiencePerformanceTypes).PageLoad:
        case (0, $aRK4c.ExperiencePerformanceTypes).PageSegmentLoad:
            return $8cc07ee0fef4e638$export$bd4e6d81a822ece6(data, ssr, performanceConfig);
        case (0, $aRK4c.ExperiencePerformanceTypes).InlineResult:
            return $8cc07ee0fef4e638$export$47f0208fd62dffce(data, performanceConfig);
        case (0, $aRK4c.ExperiencePerformanceTypes).Custom:
            return $8cc07ee0fef4e638$export$c25c1b3ff2ce92cf(data, performanceConfig);
    }
};
const $8cc07ee0fef4e638$export$738d24377baf6a5e = (data, ssr, bundleEvalConfig, resourceConfig, performanceConfig)=>{
    return {
        ...$8cc07ee0fef4e638$var$getPerformanceMetrics(data, ssr, performanceConfig),
        ...(0, $hLsQ8.resourceTimings)(data, resourceConfig),
        ...(0, $jjxIT.bundleEvalTimings)(data, bundleEvalConfig),
        ...(0, $9EOmu.appTimings)(data, ssr),
        ...(0, $kWmpU.isInitialPageLoad)(data) ? (0, $l3RvI.navigationMetrics)() : null
    };
};

});
parcelRegister("kWmpU", function(module, exports) {

$parcel$export(module.exports, "isInitialPageLoad", () => $7192e8ff840fcb5a$export$7167d96e9881d500);

var $aRK4c = parcelRequire("aRK4c");
const $7192e8ff840fcb5a$export$7167d96e9881d500 = (data)=>{
    return data.performanceType === (0, $aRK4c.ExperiencePerformanceTypes).PageLoad && data.initial === true;
};

});

parcelRegister("l3RvI", function(module, exports) {

$parcel$export(module.exports, "navigationMetrics", () => $d46dcdd825de1b51$export$b88d990436be0f8a);
const $d46dcdd825de1b51$export$b88d990436be0f8a = ()=>{
    const entries = performance.getEntriesByType('navigation');
    if (entries.length === 0) return null;
    const navigation = entries[0];
    const metrics = {
        // From https://www.w3.org/TR/resource-timing/
        redirectStart: Math.round(navigation.redirectStart),
        redirectEnd: Math.round(navigation.redirectEnd),
        fetchStart: Math.round(navigation.fetchStart),
        domainLookupStart: Math.round(navigation.domainLookupStart),
        domainLookupEnd: Math.round(navigation.domainLookupEnd),
        connectStart: Math.round(navigation.connectStart),
        connectEnd: Math.round(navigation.connectEnd),
        secureConnectionStart: Math.round(navigation.secureConnectionStart),
        requestStart: Math.round(navigation.requestStart),
        responseStart: Math.round(navigation.responseStart),
        responseEnd: Math.round(navigation.responseEnd),
        encodedBodySize: Math.round(navigation.encodedBodySize),
        decodedBodySize: Math.round(navigation.decodedBodySize),
        transferSize: Math.round(navigation.transferSize),
        // From https://www.w3.org/TR/navigation-timing-2/
        redirectCount: navigation.redirectCount,
        type: navigation.type,
        unloadEventEnd: Math.round(navigation.unloadEventEnd),
        unloadEventStart: Math.round(navigation.unloadEventStart),
        workerStart: Math.round(navigation.workerStart)
    };
    return {
        'metrics:navigation': metrics
    };
};

});

parcelRegister("9EOmu", function(module, exports) {

$parcel$export(module.exports, "appTimings", () => $1802ac08714fdd95$export$e952f50a4f2d02da);

var $aRK4c = parcelRequire("aRK4c");

var $kWmpU = parcelRequire("kWmpU");

var $gNfdK = parcelRequire("gNfdK");

var $9N38r = parcelRequire("9N38r");
const $1802ac08714fdd95$export$e952f50a4f2d02da = (data, ssrConfig)=>{
    const explicitTimings = data.performanceType === (0, $aRK4c.ExperiencePerformanceTypes).PageLoad && data.explicitTimings || null;
    const timings = (0, $gNfdK.customTimings)(data);
    const ssr = (0, $kWmpU.isInitialPageLoad)(data) ? (0, $9N38r.ssrTimings)(ssrConfig) : null;
    const timingsApp = (explicitTimings || timings || ssr) && {
        ...explicitTimings,
        ...timings,
        ...ssr
    };
    if (!timingsApp || Object.keys(timingsApp).length === 0) return null;
    return {
        'timings:app': timingsApp
    };
};

});
parcelRegister("gNfdK", function(module, exports) {

$parcel$export(module.exports, "customTimings", () => $a3a75490b3d54bbd$export$6126f85083a72c6e);
const $a3a75490b3d54bbd$var$retrieveTimings = (data)=>{
    const configTimings = data.timings || [];
    const timings = configTimings.reduce((entries, timing)=>{
        const startMark = data.metrics.marks.find((mark)=>mark.name === timing.startMark);
        if (timing.startMark && !startMark) return entries;
        const endMark = data.metrics.marks.find((mark)=>mark.name === timing.endMark);
        if (timing.endMark && !endMark) return entries;
        if (data.metrics.startTime === null || data.metrics.endTime === null) return null;
        const startTime = Math.round((startMark ? startMark.time : data.metrics.startTime) - data.metrics.startTime);
        const duration = Math.round((endMark ? endMark.time : data.metrics.endTime) - data.metrics.startTime - startTime);
        entries[`${timing.key}`] = {
            startTime: startTime,
            duration: duration
        };
        return entries;
    }, {});
    return timings;
};
const $a3a75490b3d54bbd$export$6126f85083a72c6e = (data)=>{
    if (!data.timings) return null;
    const timings = $a3a75490b3d54bbd$var$retrieveTimings(data);
    if (Object.keys(timings).length === 0) return null;
    return timings;
};

});

parcelRegister("9N38r", function(module, exports) {

$parcel$export(module.exports, "ssrTimings", () => $f90a6d00fe842ad2$export$130f411261a599c5);

const $f90a6d00fe842ad2$var$filterEntry = (entry)=>{
    return !(!entry || typeof entry !== 'object' || entry.startTime < 0 || entry.duration < 0);
};
const $f90a6d00fe842ad2$var$mapEntry = (entry)=>{
    return {
        startTime: Math.round(entry.startTime),
        duration: Math.round(entry.duration)
    };
};
const $f90a6d00fe842ad2$var$SSR_PREFIX = 'ssr';
const $f90a6d00fe842ad2$var$mapKey = (key)=>{
    if (key === 'total') return $f90a6d00fe842ad2$var$SSR_PREFIX;
    return `${$f90a6d00fe842ad2$var$SSR_PREFIX}${0, $f9117187f05b18f0$export$b98e411ae80c806f}${key}`;
};
const $f90a6d00fe842ad2$export$130f411261a599c5 = (ssr)=>{
    if (!ssr?.getTimings) return null;
    const timings = ssr.getTimings();
    if (!timings) return null;
    const ssrTimings = Object.entries(timings).reduce((acc, entry)=>{
        if ($f90a6d00fe842ad2$var$filterEntry(entry[1])) acc[$f90a6d00fe842ad2$var$mapKey(entry[0])] = $f90a6d00fe842ad2$var$mapEntry(entry[1]);
        return acc;
    }, {});
    if (!ssrTimings || Object.keys(ssrTimings).length === 0) return null;
    return ssrTimings;
};

});
const $f9117187f05b18f0$export$b98e411ae80c806f = '/';



parcelRegister("jjxIT", function(module, exports) {

$parcel$export(module.exports, "bundleEvalTimings", () => $8b74bb831e38cd82$export$1a2bb347935fc536);

var $eA0BY = parcelRequire("eA0BY");
const $8b74bb831e38cd82$export$1a2bb347935fc536 = (data, bundleEvalTimings, performance = (0, $eA0BY.getPerformanceObject)() || undefined)=>{
    if (!bundleEvalTimings) return null;
    const started = {};
    const timings = {};
    performance?.getEntriesByType('mark').forEach((mark)=>{
        const result = bundleEvalTimings.mapPerformanceMark(mark.name);
        if (!result || data.result.startTime === null) return;
        const { type: type, name: name } = result;
        if (type === 'start' && mark.startTime >= data.result.startTime) {
            started[name] = mark;
            return;
        }
        if (type === 'end' && started[name]) {
            timings[name] = {
                startTime: Math.round(started[name].startTime - data.result.startTime),
                duration: Math.round(mark.startTime - started[name].startTime)
            };
            delete started[name];
        }
    });
    if (bundleEvalTimings?.additionalTimings && data.result.startTime !== null) {
        const result = bundleEvalTimings.additionalTimings(data.result.startTime);
        if (result) Object.entries(result).forEach(([key, value])=>{
            timings[key] = value;
        });
    }
    if (Object.keys(timings).length === 0) return null;
    return {
        'timings:bundleEval': timings
    };
};

});
parcelRegister("eA0BY", function(module, exports) {

$parcel$export(module.exports, "getWindowObject", () => $6950ae0b4bba52b3$export$9aa44f85591248d9);
$parcel$export(module.exports, "getPerformanceObject", () => $6950ae0b4bba52b3$export$8cd0c777b0eb66a0);
$parcel$export(module.exports, "getPerformanceObserverObject", () => $6950ae0b4bba52b3$export$74560fd4e61fd440);
const $6950ae0b4bba52b3$export$9aa44f85591248d9 = ()=>{
    return typeof window !== 'undefined' && !!window ? window : undefined;
};
const $6950ae0b4bba52b3$export$8cd0c777b0eb66a0 = ()=>{
    const { performance: performance } = $6950ae0b4bba52b3$export$9aa44f85591248d9() || {};
    return performance;
};
const $6950ae0b4bba52b3$export$74560fd4e61fd440 = ()=>{
    const { PerformanceObserver: PerformanceObserver } = $6950ae0b4bba52b3$export$9aa44f85591248d9() || {};
    return PerformanceObserver;
};

});


parcelRegister("hLsQ8", function(module, exports) {

$parcel$export(module.exports, "resourceTimings", () => $468c33b8568cee1e$export$81a7d52441a06b50);

var $eA0BY = parcelRequire("eA0BY");

var $kkhLR = parcelRequire("kkhLR");
const $468c33b8568cee1e$var$cacheableTypes = [
    'script',
    'link'
];
const $468c33b8568cee1e$var$resourceTypes = [
    'fetch',
    'xmlhttprequest'
];
const $468c33b8568cee1e$var$CACHE_NETWORK = 'network';
const $468c33b8568cee1e$var$CACHE_MEMORY = 'memory';
const $468c33b8568cee1e$var$CACHE_DISK = 'disk';
const $468c33b8568cee1e$var$calculateTransferType = (type, duration, size)=>{
    if (!$468c33b8568cee1e$var$cacheableTypes.includes(type)) return $468c33b8568cee1e$var$CACHE_NETWORK;
    if ((size === undefined || size === 0) && duration === 0) return $468c33b8568cee1e$var$CACHE_MEMORY;
    if (size === 0 && duration > 0) return $468c33b8568cee1e$var$CACHE_DISK;
    if (size === undefined) return null;
    return $468c33b8568cee1e$var$CACHE_NETWORK;
};
const $468c33b8568cee1e$var$hasAccessToResourceSize = (url, type, entry, hasTimingHeaders)=>{
    return !$468c33b8568cee1e$var$cacheableTypes.includes(type) || url.includes('localhost') || !!(0, $eA0BY.getWindowObject)() && url.includes(window.location.hostname) || hasTimingHeaders(url, entry);
};
const $468c33b8568cee1e$var$getReportedInitiatorTypes = (xhrEnabled)=>{
    if (xhrEnabled) return [
        'script',
        'link',
        'fetch',
        'xmlhttprequest'
    ];
    return [
        'script',
        'link',
        'fetch'
    ];
};
const $468c33b8568cee1e$var$evaluateAccessToResourceTimings = (_url, entry)=>{
    return !(entry.responseStart === 0 && entry.startTime > entry.responseStart);
};
const $468c33b8568cee1e$var$getSizeObject = (size)=>size !== undefined ? {
        size: size
    } : null;
const $468c33b8568cee1e$var$getNetworkData = (item, eventStart, hasTimingHeaders = $468c33b8568cee1e$var$evaluateAccessToResourceTimings)=>{
    const { name: name, duration: duration, transferSize: transferSize, initiatorType: initiatorType, responseStart: responseStart } = item;
    const ttfb = Math.round(responseStart - eventStart);
    if (!$468c33b8568cee1e$var$hasAccessToResourceSize(name, initiatorType, item, hasTimingHeaders)) return {};
    if ($468c33b8568cee1e$var$cacheableTypes.includes(initiatorType)) {
        const transferType = $468c33b8568cee1e$var$calculateTransferType(initiatorType, duration, transferSize);
        if (!transferType) return {
            ttfb: ttfb,
            ...$468c33b8568cee1e$var$getSizeObject(transferSize)
        };
        if (transferType !== $468c33b8568cee1e$var$CACHE_NETWORK) return {
            transferType: transferType
        };
        return {
            ttfb: ttfb,
            transferType: transferType,
            ...$468c33b8568cee1e$var$getSizeObject(transferSize)
        };
    }
    return {
        ttfb: ttfb,
        ...$468c33b8568cee1e$var$getSizeObject(transferSize)
    };
};
const $468c33b8568cee1e$export$81a7d52441a06b50 = (data, resourceTimings, performance = (0, $eA0BY.getPerformanceObject)() || undefined)=>{
    if (data.result.startTime === null || !resourceTimings?.sanitiseEndpoints) return null;
    const resources = (0, $kkhLR.getResourceTimings)(data.result.startTime, performance);
    if (!resources?.length) return null;
    const resourceTiming = {};
    const { xhrFilter: xhrFilter } = resourceTimings;
    const reportedInitiatorTypes = $468c33b8568cee1e$var$getReportedInitiatorTypes(!!xhrFilter);
    resources.forEach((item)=>{
        if (!reportedInitiatorTypes.includes(item.initiatorType)) return;
        const { name: name, startTime: startTime, duration: duration, workerStart: workerStart, fetchStart: fetchStart, initiatorType: initiatorType } = item;
        if (!name || data.result.startTime === null) return;
        if (initiatorType === 'xmlhttprequest' && (xhrFilter === undefined || xhrFilter(name) === false)) return;
        const url = $468c33b8568cee1e$var$resourceTypes.includes(initiatorType) ? resourceTimings.sanitiseEndpoints(name) : resourceTimings.mapResources(name);
        if (!url || resourceTiming[url]) return;
        resourceTiming[url] = {
            startTime: Math.round(startTime - data.result.startTime),
            duration: Math.round(duration),
            workerStart: Math.max(Math.round(workerStart - data.result.startTime), 0),
            fetchStart: Math.max(Math.round(fetchStart - data.result.startTime), 0),
            type: initiatorType,
            ...$468c33b8568cee1e$var$getNetworkData(item, data.result.startTime, resourceTimings.hasTimingHeaders)
        };
    });
    return {
        'timings:resource': resourceTiming
    };
};

});
parcelRegister("kkhLR", function(module, exports) {

$parcel$export(module.exports, "resourceTimingBuffer", () => $5ba1df2048e39b42$export$bea963256235a63e);
$parcel$export(module.exports, "getResourceTimings", () => $5ba1df2048e39b42$export$9eebb59359c2e9e5);
// @flow strict-local

var $4Y9NK = parcelRequire("4Y9NK");

var $eA0BY = parcelRequire("eA0BY");
const $5ba1df2048e39b42$export$bea963256235a63e = {
    timings: [],
    maxSize: 1000,
    observer: null,
    transformResource: (entry)=>({
            name: entry.name,
            initiatorType: entry.initiatorType,
            transferSize: entry.transferSize,
            startTime: Math.round(entry.startTime),
            duration: Math.round(entry.duration),
            fetchStart: Math.round(entry.fetchStart || 0),
            workerStart: Math.round(entry.workerStart || 0),
            responseStart: Math.round(entry.responseStart || 0)
        }),
    start: (performance = (0, $eA0BY.getPerformanceObject)(), PerformanceObserver1 = (0, $eA0BY.getPerformanceObserverObject)())=>{
        if (!PerformanceObserver1 || !performance || typeof PerformanceObserver1 === 'undefined') return;
        if ($5ba1df2048e39b42$export$bea963256235a63e.observer) {
            (0, $4Y9NK.ufologger).warn('Observer is already running');
            return;
        }
        const resources = performance.getEntriesByType?.('resource');
        if (resources) $5ba1df2048e39b42$export$bea963256235a63e.timings = resources.map((resource)=>$5ba1df2048e39b42$export$bea963256235a63e.transformResource(resource));
        $5ba1df2048e39b42$export$bea963256235a63e.observer = new PerformanceObserver1($5ba1df2048e39b42$export$bea963256235a63e.addTimings);
        $5ba1df2048e39b42$export$bea963256235a63e.observer.observe({
            entryTypes: [
                'resource'
            ]
        });
    },
    stop: ()=>{
        if ($5ba1df2048e39b42$export$bea963256235a63e.observer) {
            $5ba1df2048e39b42$export$bea963256235a63e.observer.disconnect();
            $5ba1df2048e39b42$export$bea963256235a63e.observer = null;
        }
        $5ba1df2048e39b42$export$bea963256235a63e.timings = [];
    },
    addTimings: (list)=>{
        const entries = list.getEntries().map((entry)=>$5ba1df2048e39b42$export$bea963256235a63e.transformResource(entry));
        const overflow = $5ba1df2048e39b42$export$bea963256235a63e.timings.length + entries.length;
        if (overflow > $5ba1df2048e39b42$export$bea963256235a63e.maxSize) {
            const fieldsToRemove = overflow - $5ba1df2048e39b42$export$bea963256235a63e.maxSize;
            $5ba1df2048e39b42$export$bea963256235a63e.timings.splice(0, fieldsToRemove);
        }
        $5ba1df2048e39b42$export$bea963256235a63e.timings.push(...entries);
    }
};
const $5ba1df2048e39b42$export$9eebb59359c2e9e5 = (startTime, performance = (0, $eA0BY.getPerformanceObject)())=>{
    if (!PerformanceObserver || !$5ba1df2048e39b42$export$bea963256235a63e.observer) {
        const resources = performance?.getEntriesByType('resource');
        if (resources) return resources.filter((timing)=>timing.startTime >= startTime);
        return null;
    }
    return $5ba1df2048e39b42$export$bea963256235a63e.timings.filter((timing)=>timing.startTime >= startTime);
};

});



parcelRegister("avGph", function(module, exports) {

$parcel$export(module.exports, "pageVisibleState", () => $c2b4ae4fa485db7c$export$723b4c298aca63af);

var $iPwfg = parcelRequire("iPwfg");
const $c2b4ae4fa485db7c$export$723b4c298aca63af = (data)=>{
    return {
        'experience:pageVisible': data.pageVisibleState ?? (document.hidden ? (0, $iPwfg.PageVisibleState).HIDDEN : (0, $iPwfg.PageVisibleState).VISIBLE)
    };
};

});

parcelRegister("aGiji", function(module, exports) {

$parcel$export(module.exports, "appFramework", () => $d92c67daca38801b$export$e34e4529b979f74c);
const $d92c67daca38801b$export$e34e4529b979f74c = (config)=>{
    if (!config.framework) return null;
    return {
        'app:framework:name': config.framework.name,
        'app:framework:version': config.framework.version
    };
};

});

parcelRegister("7A9GV", function(module, exports) {

$parcel$export(module.exports, "appVersion", () => $679c2e8988b53419$export$82ae485178b37419);
const $679c2e8988b53419$export$82ae485178b37419 = (config)=>{
    const pluginData = {
        'app:web:version': config.version.web
    };
    if (config.version.ssr) pluginData['app:ssr:version'] = config.version.ssr;
    return pluginData;
};

});

parcelRegister("e7KPV", function(module, exports) {

$parcel$export(module.exports, "eventBrowserPlugin", () => $9a1bf83d5c6eb76d$export$f435c2789ca334a7);

var $3nEAz = parcelRequire("3nEAz");

var $LFmXM = parcelRequire("LFmXM");

var $eA0BY = parcelRequire("eA0BY");
const $9a1bf83d5c6eb76d$export$f435c2789ca334a7 = (0, $LFmXM.default)(()=>{
    if (!(0, (/*@__PURE__*/$parcel$interopDefault($3nEAz))).getParser) return null;
    const browser = (0, (/*@__PURE__*/$parcel$interopDefault($3nEAz))).getParser((0, $eA0BY.getWindowObject)()?.navigator?.userAgent || '');
    return {
        'event:browser:name': browser.getBrowserName(),
        'event:browser:version': browser.getBrowserVersion()
    };
});

});

parcelRegister("78eNh", function(module, exports) {

$parcel$export(module.exports, "eventCpusPlugin", () => $f50f35a63c9a2c78$export$db7649b8854107ad);

var $LFmXM = parcelRequire("LFmXM");
const $f50f35a63c9a2c78$export$db7649b8854107ad = (0, $LFmXM.default)(()=>{
    if (!navigator.hardwareConcurrency) return null;
    return {
        'event:cpus': navigator.hardwareConcurrency
    };
});

});

parcelRegister("eTZpK", function(module, exports) {

$parcel$export(module.exports, "featureFlags", () => $b7a8e41ce68f90c7$export$e62953d023125748);
const $b7a8e41ce68f90c7$export$e62953d023125748 = (featureFlagClient, featureFlags, data)=>{
    const allFeatureFlags = [
        ...featureFlags,
        ...data.featureFlags || []
    ];
    if (allFeatureFlags.length === 0) return null;
    const initialMemo = [];
    allFeatureFlags.reduce((memo, featureFlagKey)=>{
        const ffVal = featureFlagClient.getValue(featureFlagKey);
        if (ffVal !== undefined && ffVal !== null) memo.push([
            featureFlagKey,
            ffVal
        ]);
        return memo;
    }, initialMemo);
    const mappedFeatureFlags = Object.fromEntries(initialMemo);
    return {
        featureFlags: mappedFeatureFlags
    };
};

});

parcelRegister("lpC06", function(module, exports) {

$parcel$export(module.exports, "eventMemoryPlugin", () => $7b379b57c29307eb$export$81efaf8414879a1a);

var $LFmXM = parcelRequire("LFmXM");
const $7b379b57c29307eb$export$81efaf8414879a1a = (0, $LFmXM.default)(()=>{
    // @ts-ignore: deviceMemory is exposed in some browsers
    if (!navigator.deviceMemory) return null;
    return {
        // @ts-ignore
        'event:memory': navigator.deviceMemory
    };
});

});

parcelRegister("3xrw2", function(module, exports) {

$parcel$export(module.exports, "eventNetworkPlugin", () => $912a46ecb111f43f$export$ce1cf816dce1da56);
const $912a46ecb111f43f$export$ce1cf816dce1da56 = ()=>{
    // @ts-ignore: connection is available in some browsers
    // eslint-disable-next-line compat/compat
    if (!navigator.connection) return null;
    return {
        // @ts-ignore: connection is available in some browsers
        // eslint-disable-next-line compat/compat
        'event:network:effectiveType': navigator.connection.effectiveType,
        // @ts-ignore: connection is available in some browsers
        // eslint-disable-next-line compat/compat
        'event:network:rtt': navigator.connection.rtt,
        // @ts-ignore: connection is available in some browsers
        // eslint-disable-next-line compat/compat
        'event:network:downlink': navigator.connection.downlink
    };
};

});

parcelRegister("MPirS", function(module, exports) {

$parcel$export(module.exports, "ssrFeatureFlags", () => $c2cb8237178af29f$export$fdbea518c19dfa8);
const $c2cb8237178af29f$export$fdbea518c19dfa8 = (ssr)=>{
    if (!ssr?.getFeatureFlags) return null;
    try {
        const featureFlags = ssr.getFeatureFlags();
        if (featureFlags) return {
            'ssr:featureFlags': featureFlags
        };
    } catch (e) {}
    return null;
};

});

parcelRegister("blLYJ", function(module, exports) {

$parcel$export(module.exports, "ssrSuccess", () => $645bb7c4474c7274$export$a3dc8251cf55b2e0);
const $645bb7c4474c7274$export$a3dc8251cf55b2e0 = (ssr)=>{
    if (ssr?.getDoneMark()) return {
        'ssr:success': true
    };
    return null;
};

});

parcelRegister("1aRah", function(module, exports) {

$parcel$export(module.exports, "Route", () => $20a47329e1b8c6a6$export$e7b0ac011bb776c6);
const $20a47329e1b8c6a6$export$e7b0ac011bb776c6 = {
    route: '',
    setRoute (newRoute) {
        this.route = newRoute;
    },
    getRoute () {
        return this.route;
    }
};

});


const $9918d9eb79adfbba$export$ce553301d55c2fd8 = 'fedramp-moderate';
const $9918d9eb79adfbba$export$f005e2e9f707cb5f = 'commercial';
const $9918d9eb79adfbba$export$bd6b5a7802d76127 = 'fedramp-fedex';
const $9918d9eb79adfbba$export$a739cd5aac835909 = 'stg';
const $9918d9eb79adfbba$export$42dd0cdd351a4a9 = 'prod';
const $9918d9eb79adfbba$export$404582bc18fe4d9e = 'dev';

const $2346df6f4921ec53$export$42f4885608027d0c = 'non_boolean';

// This constant will be true on entry-fs (modern SSR) bundles and false on jira-fe-gateway (legacy SSR) and client bundles
const $9790b8dfe6f31c81$export$19d68f5aa485d903 = false;

const $7e5fbaca814a6bf2$export$4261d5d429e288ec = 'is-admin';
const $7e5fbaca814a6bf2$export$2eca2b4f46ed58e6 = 'is-nav4-tenant-opt-in';
const $7e5fbaca814a6bf2$export$a4507bf14f4bb764 = 'is-nav4-tenant-opt-out';
const $7e5fbaca814a6bf2$export$153ded4d539b820d = 'is-nav4-user-opt-in';
const $7e5fbaca814a6bf2$export$9c962957701a4fe8 = 'is-nav4-user-opt-out';

const $652f5f63189f3e2a$export$ef94a84e2990361c = 'ISSUE_VIEW';
const $652f5f63189f3e2a$export$fc5f182fc9019b1c = 'CLASSIC_BOARD';
const $652f5f63189f3e2a$export$664edf77d4c76110 = 'COMPANY_MANAGED_BOARD';
const $652f5f63189f3e2a$export$f364828958cffad0 = 'TEAM_MANAGED_BOARD';
const $652f5f63189f3e2a$export$93104dc4eba58ba4 = 'CLASSIC_BACKLOG';
const $652f5f63189f3e2a$export$571692eec8a399e1 = 'COMPANY_MANAGED_BACKLOG';
const $652f5f63189f3e2a$export$c17f34c425972af1 = 'TEAM_MANAGED_BACKLOG';
const $652f5f63189f3e2a$export$d0ad1160bb95ce50 = 'NIN_NEW_ISSUE_NAVIGATOR';
const $652f5f63189f3e2a$export$4695c1a423ffe431 = 'DASHBOARD';
const $652f5f63189f3e2a$export$f999749ac7a2cd1 = 'PLAN_CALENDAR';
const $652f5f63189f3e2a$export$9a80695e72849f84 = 'X-Atlassian-Capability';

// SCREENS
const $466f60259c330878$export$f636b5b56f1d624a = 'Screen';
const $466f60259c330878$export$9d2de6eebf7462b5 = 'Drawer';
const $466f60259c330878$export$1171103ea9083ffa = 'Modal';
const $466f60259c330878$export$cae2783c9279926 = 'InlineDialog';
const $466f60259c330878$export$d1123261ca8831d2 = 'Dropdown';
const $466f60259c330878$export$238d30785c4bca84 = 'Banner';
const $466f60259c330878$export$a1562d08625f5d7e = 'UI';
const $466f60259c330878$export$947dac6c72b26f81 = 'TRACK';
const $466f60259c330878$export$f1d537d508d2945a = 'SCREEN';
const $466f60259c330878$export$12346a674644c156 = 'OPERATIONAL';

const $1793be513d46f473$export$f636b5b56f1d624a = 'Screen';
const $1793be513d46f473$export$9d2de6eebf7462b5 = 'Drawer';
const $1793be513d46f473$export$1171103ea9083ffa = 'Modal';
const $1793be513d46f473$export$cae2783c9279926 = 'InlineDialog';
const $1793be513d46f473$export$d1123261ca8831d2 = 'Dropdown';
const $1793be513d46f473$export$a1562d08625f5d7e = 'UI';
const $1793be513d46f473$export$947dac6c72b26f81 = 'TRACK';
const $1793be513d46f473$export$f1d537d508d2945a = 'SCREEN';
const $1793be513d46f473$export$12346a674644c156 = 'OPERATIONAL';
const $1793be513d46f473$export$2ceccf177fae277c = 'analyticsBridge';

const $e08dff4ae358d899$export$c8c1c8c3f8ddba61 = 'jira-servicedesk';
const $e08dff4ae358d899$export$e9c56aa3b027d98f = 'jira-customer-service';
const $e08dff4ae358d899$export$1346c9aa3cbb477d = 'jira-software';
const $e08dff4ae358d899$export$202f50ee62667e32 = 'jira-product-discovery';
const $e08dff4ae358d899$export$db515c8cec1e6f79 = 'jira-core';
const $e08dff4ae358d899$export$c811f21c9ad05dc2 = 'confluence';
const $e08dff4ae358d899$export$961148c98d198270 = 'opsgenie';

// Media uses a namespaced analytics context under the following key MEDIA_CONTEXT.
const $bdc30ab321e3cece$export$70df29c238ba7306 = 'mediaCtx'; // However we don't export any JSX component to create that namespaced analytics context.
 // In media components, analytics context is being created by this component:
 // @see packages/media/media-common/src/analytics/withMediaAnalyticsContext.tsx

const $0bb5c01995a7bae8$export$cf090d5281b5ae06 = 10000;
const $0bb5c01995a7bae8$export$8575e30be0feb909 = 30000;

// same types defined in analytics-web-client but avoid creating dependency with that
const $27c7fc6638bd7614$export$a1562d08625f5d7e = 'ui';
const $27c7fc6638bd7614$export$947dac6c72b26f81 = 'track';
const $27c7fc6638bd7614$export$f1d537d508d2945a = 'screen';
const $27c7fc6638bd7614$export$12346a674644c156 = 'operational';
const $27c7fc6638bd7614$export$b055de0e665cb20c = 'unknown';

const $e7a8e9871386f1b8$export$3288b14b6745c572 = 204;
const $e7a8e9871386f1b8$export$c09e7ea0fc79f34f = 409;
const $e7a8e9871386f1b8$export$974c37534b0191b1 = 503;

const $2e47af044bce450a$export$56940a9488e85199 = 'jira.fe.spa-';
const $2e47af044bce450a$export$45c4b6bf7935c69a = `${$2e47af044bce450a$export$56940a9488e85199}start`;
const $2e47af044bce450a$export$135c96ab5afee429 = 'ssr.spa.rendered';
const $2e47af044bce450a$export$ff834eccc35b9089 = 'appBundleReady';
const $2e47af044bce450a$export$86b05e34d462ead8 = 'prefetchApiReady';
const $2e47af044bce450a$export$d6a604a7d9a390fb = 'prefetchApiStart';
const $2e47af044bce450a$export$3ae43cc1782d058f = 'jswRenderStart';
const $2e47af044bce450a$export$363f6703ffa600be = 'jswCreateReduxStoreStart';
const $2e47af044bce450a$export$e87b74567b79c8 = 'jswCreateReduxStoreEnd';
const $2e47af044bce450a$export$99fe642459a8b02 = 'jswTransformCriticalDataStart';
const $2e47af044bce450a$export$ab1f5705fc8e0571 = 'jswTransformCriticalDataEnd';
const $2e47af044bce450a$export$8c3a9046da692c35 = 'jswReduxSoftwareAppLoadedStart';
const $2e47af044bce450a$export$5aa497d1efdcc5bf = 'jswReduxSoftwareAppLoadedEnd';
const $2e47af044bce450a$export$99c08ec92759c71c = 'tti-raf-mark';
const $2e47af044bce450a$export$48552baa9db8ce1d = 'tti-raf';

const $99993c16fc53d6ec$export$c8b406ad8ee0dab9 = 'jiraServiceManagement';


$parcel$global.rlb("jhiae")
//# sourceMappingURL=shared~commons~atlassian~ar.b3866a5b.js.map
